webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(795)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(904),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);

// export const EventBus = new Vue({ el: '#app' }) <-- in this case access using import { EventBus }
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  data: {
    info: {
      xth: '20th',
      year: 2026,
      date: 'May 8-9, 2026',
      countdown: 'Fri May 8 2026 17:00:00 GMT-0400',
      countdownSignUp: 'Mon Jan 17 2026 00:00:00 GMT-0400'
      // countdownSignUp: 'Thu Dec 30 2021 13:13:50 GMT+0800'
    },
    _isDesktop: true,
    _windowWidth: 1024,
    _navMain: [{
      name: 'teams',
      title: 'Signup & 2026 Teams',
      path: '/info'
    }, {
      name: 'schedule',
      title: 'Events & Schedule',
      path: '/schedule'
      // }, {
      //   name: 'photos',
      //   title: 'Photos',
      //   path: '#',
      //   section: 'section-photo'
    }, {
      name: 'photos',
      title: 'Photos',
      path: '/photos'
    }, {
      name: 'sponsors',
      title: 'Sponsors',
      path: '/sponsors'
      // path: '#',
      // section: 'section-sponsors'
    }],
    _navSocial: [{
      name: 'facebook',
      fa: 'facebook',
      path: 'https://www.facebook.com/bosshogcookoff'
    }, {
      name: 'twitter',
      fa: 'twitter',
      path: 'https://www.twitter.com/bosshogcookoff'
    }, {
      name: 'instagram',
      fa: 'instagram',
      path: 'https://www.instagram.com/bosshogcookoff'
    }],
    _navInstagram: {
      title: 'BossHogCookOff',
      path: 'https://www.instagram.com/bosshogcookoff'
    },
    _navInstagramHashtag: {
      title: '#bosshogcookoff',
      path: 'https://www.instagram.com/explore/tags/bosshogcookoff/'
    },
    _navYoutube: {
      title: 'BossHogCookOff',
      path: 'https://www.youtube.com/bosshogcookoff'
    },
    _navTwitter: {
      title: 'BossHogCookOff',
      path: 'https://www.twitter.com/bosshogcookoff'
    },
    _navFacebook: {
      title: 'BossHogCookOff',
      path: 'https://www.facebook.com/bosshogcookoff'
    },
    _navLocation: {
      title: 'Schwank Way, Waynesboro, GA 30830',
      path: 'https://maps.google.com/maps?daddr=33.100098,-81.999403&hl=en&ll=33.100022,-81.999604&spn=0.004013,0.004603&sll=33.099289,-81.999807&sspn=0.016052,0.018132&t=m&mra=mift&mrsp=1&sz=16&z=18'
    },
    _navEmail: 'nlynch@fnbwaynesboro.com'
  },
  computed: {
    isDesktop: {
      get: function get() {
        return this._isDesktop;
      },
      set: function set(isDesktop) {
        if (this._isDesktop !== isDesktop) {
          // do not update immediately, only change if necessary
          this._isDesktop = isDesktop;
          this.$emit('isDesktopChanged', isDesktop);
        }
      }
    },
    windowWidth: {
      get: function get() {
        return this._windowWidth;
      },
      set: function set(windowWidth) {
        if (this._windowWidth !== windowWidth) {
          this._windowWidth = windowWidth;
          this.$emit('windowWidthChanged', windowWidth);
        }
      }
    }
  },
  watch: {},
  methods: {
    isSignUp: function isSignUp() {
      return false;
      // return true
      // let countdownSignUp = this.info.countdownSignUp
      // let countdown = Math.trunc(Date.parse(countdownSignUp) / 1000)
      // let aday = (3600 * 24)
      // let now = Math.trunc((new Date()).getTime() / 1000)
      // console.log('-- sign up gap', { countdown, now, aday, gap: (countdown - now) })
      // // {countdown: 1642392000, now: 1642390711, aday: 86400, gap: 1289}
      // // now = 17 Jan 2022 11:39am (current +0800)
      // // countdown = 'Mon Jan 17 2022 00:00:00 GMT-0400'
      // // 1289 / 60 = 21 minutes
      // return (countdown - now - aday) < 0
    },

    detectIE: function detectIE() {
      /**
       * detect IE
       * returns version of IE or false, if browser is not Internet Explorer
       */
      var ua = window.navigator.userAgent;

      // Test values; Uncomment to check result …

      // IE 10
      // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

      // IE 11
      // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

      // Edge 12 (Spartan)
      // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

      // Edge 13
      // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

      var msie = ua.indexOf('MSIE ');
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      }

      var trident = ua.indexOf('Trident/');
      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      }

      var edge = ua.indexOf('Edge/');
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
      }

      // other browser
      return false;
    }
  }
})); // <-- in this case access using import EventBus

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis__ = __webpack_require__(470);



// URL and endpoint constants
var PATH_INSTAGRAM_TAGPAGE = 'api/instagram/tagpage';
var PATH_INSTAGRAM_USERPAGE = 'api/instagram/userpage';

var IS_HTTPS = false;
var BASE_URL = '//bosshogbeta.adaptconcepts.com/october/';
var FRONTEND_URL = '//bosshogbeta.adaptconcepts.com/';
if (true) {
  IS_HTTPS = true;
  if (!window.location || !window.location.hostname) {
    // do nothing
  } else if (window.location.hostname.includes('bosshogcookoff')) {
    BASE_URL = '//bosshogcookoff.com/october/';
    FRONTEND_URL = '//bosshogcookoff.com/';
  } else if (window.location.hostname.includes('bosshoglive.adaptconcepts')) {
    BASE_URL = '//bosshoglive.adaptconcepts.com/october/';
    FRONTEND_URL = '//bosshoglive.adaptconcepts.com/';
  } else if (window.location.hostname.includes('bosshog.adaptconcepts')) {
    BASE_URL = '//bosshog.adaptconcepts.com/october/';
    FRONTEND_URL = '//bosshog.adaptconcepts.com/';
  }
} else {
  // BASE_URL = '//bosshoglive.adaptconcepts.com/october/'
  IS_HTTPS = true;
  BASE_URL = '//bosshogcookoff.com/october/';
  // IS_HTTPS = false
  // BASE_URL = '//localhost/october_bosshog/'
  // FRONTEND_URL = '//localhost:8082/'
  // IS_HTTPS = true
  // BASE_URL = '//bosshogbeta.adaptconcepts.com/october/'
}

/* harmony default export */ __webpack_exports__["a"] = ({
  isSecured: IS_HTTPS,

  // release
  baseUrl: BASE_URL + 'adapt/',
  baseUrlInstagram: BASE_URL,
  baseUrlRecaptcha: FRONTEND_URL + 'static/',

  // // staging
  // baseUrl: '//bosshogbeta.adaptconcepts.com/october/singulo/',
  // baseUrlInstagram: '//bosshogbeta.adaptconcepts.com/october/',
  // baseUrlRecaptcha: '//bosshogbeta.adaptconcepts.com/static/',

  // // debug
  // baseUrl: '//localhost:8080/october/singulo/',
  // baseUrlInstagram: '//bosshogbeta.adaptconcepts.com/october/',
  // baseUrlRecaptcha: '//bosshogbeta.adaptconcepts.com/static/',

  // apis
  baseUrlYoutube: '//www.googleapis.com/youtube/v3/',
  baseUrlRecaptchaDebug: '//localhost:8080/bosshogcookoff/static/',

  instagramUser: function instagramUser(token, maxid) {
    var _this = this;

    var maxidString = maxid ? '/' + maxid : '';
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this.baseUrlInstagram;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get(PATH_INSTAGRAM_USERPAGE + '/' + token + maxidString).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  instagramTag: function instagramTag(tag, maxid) {
    var _this2 = this;

    var maxidString = maxid ? '/' + maxid : '';
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this2.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this2.baseUrlInstagram;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get(PATH_INSTAGRAM_TAGPAGE + '/' + tag + '/24' + maxidString).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  instagramApi: function instagramApi() {
    var _this3 = this;

    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 24;
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this3.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = BASE_URL;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('api/instagram2/medias/' + limit + '/' + offset).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  about: function about() {
    var _this4 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this4.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this4.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('about/first').then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  aboutWithName: function aboutWithName(name) {
    var _this5 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this5.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this5.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('about/name/' + name).then(function (data) {
        if (Array.isArray(data) && data.length > 0) {
          data = data[0];
        }
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  carousel: function carousel() {
    var _this6 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this6.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this6.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('carousel/subpage/main').then(function (data) {
        // reject({ error: 'error' })
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  carouselSubpage: function carouselSubpage(subpage) {
    var _this7 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this7.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this7.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('carousel/subpage/' + subpage).then(function (data) {
        // if (Array.isArray(data) && data.length > 0) {
        //   data = data[0]
        // }
        // reject({ error: 'error' })
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  company: function company() {
    var _this8 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this8.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this8.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('company').then(function (data) {
        // reject({ error: 'error' })
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  gallery: function gallery() {
    var _this9 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this9.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this9.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('gallery').then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  hotlink: function hotlink() {
    var _this10 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this10.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this10.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('hotlink/all').then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  sponsor: function sponsor(level) {
    var _this11 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this11.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this11.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('staff/level/' + level).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  eventDetail: function eventDetail(showId) {
    var _this12 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this12.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this12.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('event/show/' + showId).then(function (data) {
        if (Array.isArray(data) && data.length > 0) {
          data = data[0];
        }
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  eventPrevious: function eventPrevious() {
    var _this13 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this13.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this13.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('event/previous').then(function (data) {
        if (Array.isArray(data) && data.length > 0) {
          data = data[0];
        }
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  eventUpcoming: function eventUpcoming() {
    var _this14 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this14.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this14.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('event/upcoming').then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  eventAll: function eventAll() {
    var _this15 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this15.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this15.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('event/all').then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  eventWithSlug: function eventWithSlug(slug) {
    var _this16 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this16.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this16.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('event/slug/' + slug).then(function (data) {
        if (Array.isArray(data) && data.length > 0) {
          data = data[0];
        }
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  scheduleDates: function scheduleDates() {
    var _this17 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this17.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this17.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('schedule/date/all').then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  scheduleWithDate: function scheduleWithDate(date) {
    var _this18 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this18.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this18.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('schedule/date/' + date).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  competition: function competition() {
    var _this19 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this19.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this19.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('signupteamoption/all').then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  team: function team() {
    var _this20 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this20.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this20.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('signupteam/all').then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  email: function email(recaptcha, name, _email, message) {
    var _this21 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this21.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this21.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].post('email/submit', { recaptcha: recaptcha, name: name, email: _email, phone: '-', message: message }).then(function (data) {
        // reject({ error: 'error' })
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  subscribe: function subscribe(name, email) {
    var _this22 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this22.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this22.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].post('email/subscribe', { name: name, email: email }).then(function (data) {
        // reject({ error: 'error' })
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  signUpApproved: function signUpApproved() {
    var _this23 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this23.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this23.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('signupteam/approved').then(function (data) {
        // reject({ error: 'error' })
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  signUpTeam: function signUpTeam(recaptcha, name, leader, members, memberNames, kcbsNumber, address, address2, city, state, zip, county, email, phone, phone2, bbq, power, volunteer, competition, locations, tshirt, tshirts, strawberry, kingofwing, signatureRight, signAtRight, signature, signAt, amount) {
    var _this24 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this24.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this24.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].post('signupteam/submit', {
        recaptcha: recaptcha,
        // main
        name: name,
        leader: leader,
        members: members,
        memberNames: memberNames,
        // location
        address: address,
        address2: address2,
        city: city,
        state: state,
        zip: zip,
        county: county,
        email: email,
        phone: phone,
        phone2: phone2,
        kcbsNumber: kcbsNumber,
        // options
        bbq: bbq,
        power: power,
        volunteer: volunteer,
        competition: competition,
        locations: locations,
        tshirt: tshirt,
        tshirts: tshirts,
        strawberry: strawberry,
        kingofwing: kingofwing,
        signatureRight: signatureRight,
        signAtRight: signAtRight,
        signature: signature,
        signAt: signAt,
        amount: amount
      }).then(function (data) {
        // reject({ error: 'error' })
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  signUpJudge: function signUpJudge(recaptcha, name, address, address2, city, state, zip, county, email, phone, phone2, tshirt, kcbsCertified, kcbsNumber, kcbsTotal, last1, last2, last3, masterJudge, tableCaptain, signature, signAt) {
    var _this25 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this25.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this25.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].post('signupjudge/submit', {
        recaptcha: recaptcha,
        // main
        name: name,
        // location
        address: address,
        address2: address2,
        city: city,
        state: state,
        zip: zip,
        county: county,
        email: email,
        phone: phone,
        phone2: phone2,
        // options
        tshirt: tshirt,
        kcbsCertified: kcbsCertified,
        kcbsNumber: kcbsNumber,
        kcbsTotal: kcbsTotal,
        last1: last1,
        last2: last2,
        last3: last3,
        masterJudge: masterJudge,
        tableCaptain: tableCaptain,
        signature: signature,
        signAt: signAt
      }).then(function (data) {
        // reject({ error: 'error' })
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getRecaptcha: function getRecaptcha() {
    var _this26 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this26.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this26.baseUrlRecaptcha;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('captcha.php').then(function (data) {
        // reject({ error: 'error' })
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  youtube: function youtube(path, params) {
    var _this27 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = true; // always secured
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this27.baseUrlYoutube;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get(path, params).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(794)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(903),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(831)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(941),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(813)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(923),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(816)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(926),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/car.c97b209.svg";

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/map.8cd692b.png";

/***/ }),
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB3aWR0aD0iNTc4cHgiIGhlaWdodD0iMTE2LjY2N3B4IiB2aWV3Qm94PSIwIDAgNTc4IDExNi42NjciIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDU3OCAxMTYuNjY3IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxwb2x5Z29uIGZpbGw9IiNGRkE3MTgiIHBvaW50cz0iNTc4LDExNi42NjcgMCwxMTYuNjY3IDU3LDU2LjY2NyAwLDAgNTc4LDAgNTIxLjY2Nyw1Ni42NjcgIi8+DQo8L3N2Zz4NCg=="

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-main.4a7584f.svg";

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(804)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(913),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(790)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(899),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-05df63c0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(797)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(906),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(829)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(939),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(799)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(908),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(833)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(943),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(13);





// Facebook Analytics
(function (d, s, id) {
  /* eslint one-var: 0 */
  // console.log('init FB in application.js')
  var js,
      fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {
    return;
  }
  js = d.createElement(s);js.id = id;
  js.src = '//connect.facebook.net/en_US/sdk.js';
  fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk');

var FBControl = {
  install: function install(Vue, options) {
    var _this = this;

    if (options && options.awaitAsyncTime) {
      this.awaitAsyncTime = options.awaitAsyncTime;
    }

    if (!window.FB) {
      // the following is template from FB developers
      // with compliance for ESlint
      window.fbAsyncInit = function () {
        _this.init();
      };
    } else {
      this.init();
    }
  },

  awaitAsyncTime: 100,
  init: function init() {
    /* global FB */
    FB.init({
      appId: '1464105310498764',
      xfbml: true,
      version: 'v2.7'
    });
    window.FB = FB;
    Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype, '$FB', { value: FB });
    return FB;
  },
  getFB: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var failsafe = 100;
                var repeat = setInterval(function () {
                  // console.log('logging event pending...' + Vue.$FB + ',' + window.FB)
                  if (__WEBPACK_IMPORTED_MODULE_3_vue__["default"].$FB !== undefined) {
                    // console.log('logging event logged later with Vue.$FB')
                    resolve(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].$FB);
                    clearInterval(repeat);
                  } else if (window.FB !== undefined) {
                    // console.log('logging event logged later with window.FB')
                    resolve(window.FB);
                    clearInterval(repeat);
                  }
                  failsafe--;
                  if (failsafe <= 0) {
                    clearInterval(repeat);
                  }
                }, _this2.awaitAsyncTime);
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function getFB() {
      return _ref.apply(this, arguments);
    }

    return getFB;
  }(),
  logEvent: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(name) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].$FB !== undefined)) {
                _context2.next = 4;
                break;
              }

              // console.log('logging event logged now with Vue.$FB')
              __WEBPACK_IMPORTED_MODULE_3_vue__["default"].$FB.AppEvents.logEvent(name);
              _context2.next = 13;
              break;

            case 4:
              if (!(window.FB !== undefined)) {
                _context2.next = 8;
                break;
              }

              // console.log('logging event logged now with window.FB')
              window.FB.AppEvents.logEvent(name);
              _context2.next = 13;
              break;

            case 8:
              if (this.awaitAsyncTime) {
                _context2.next = 11;
                break;
              }

              console.error('Invalid await async time');
              return _context2.abrupt('return');

            case 11:
              _context2.next = 13;
              return this.getFB().then(function (FB) {
                FB.AppEvents.logEvent(name);
              }).catch(function (error) {
                console.error('Internal error in FBControl failsafe', error);
              });

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function logEvent(_x) {
      return _ref2.apply(this, arguments);
    }

    return logEvent;
  }(),
  logPageView: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].$FB !== undefined)) {
                _context3.next = 4;
                break;
              }

              __WEBPACK_IMPORTED_MODULE_3_vue__["default"].$FB.AppEvents.logPageView();
              _context3.next = 13;
              break;

            case 4:
              if (!(window.FB !== undefined)) {
                _context3.next = 8;
                break;
              }

              window.FB.AppEvents.logPageView();
              _context3.next = 13;
              break;

            case 8:
              if (this.awaitAsyncTime) {
                _context3.next = 11;
                break;
              }

              console.error('Invalid await async time');
              return _context3.abrupt('return');

            case 11:
              _context3.next = 13;
              return this.getFB().then(function (FB) {
                FB.AppEvents.logPageView();
              }).catch(function (error) {
                console.error('Internal error in FBControl failsafe', error);
              });

            case 13:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function logPageView() {
      return _ref3.apply(this, arguments);
    }

    return logPageView;
  }()
};

/* harmony default export */ __webpack_exports__["a"] = (FBControl);

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_masonry_layout__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_masonry_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_masonry_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_imagesloaded__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_imagesloaded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_imagesloaded__);





var attributesMap = {
  'column-width': 'columnWidth',
  'transition-duration': 'transitionDuration',
  'item-selector': 'itemSelector',
  'origin-left': 'originLeft',
  'origin-top': 'originTop',
  'fit-width': 'fitWidth',
  'stamp': 'stamp',
  'gutter': 'gutter'
};
var EVENT_ADD = 'vuemasonry.itemAdded';
var EVENT_REMOVE = 'vuemasonry.itemRemoved';
var EVENT_IMAGE_LOADED = 'vuemasonry.imageLoaded';

var stringToBool = function stringToBool(val) {
  return (val + '').toLowerCase() === 'true';
};

var collectOptions = function collectOptions(attrs) {
  var res = {};
  var attributesArray = Array.prototype.slice.call(attrs);
  attributesArray.forEach(function (attr) {
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(attributesMap).indexOf(attr.name) > -1) {
      res[attributesMap[attr.name]] = attr.name.indexOf('origin') > -1 ? stringToBool(attr.value) : attr.value;
    }
  });
  return res;
};

var Events = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({});

// NoctorusCode: changed install method
// export const VueMasonryPlugin = function () {}

function install(Vue, options) {
  Vue.redrawVueMasonry = function () {
    Events.$emit(EVENT_ADD);
  };

  Vue.directive('masonry', {
    props: ['transitionDuration', ' itemSelector'],

    inserted: function inserted(el, nodeObj) {
      if (!__WEBPACK_IMPORTED_MODULE_2_masonry_layout___default.a) {
        throw new Error('Masonry plugin is not defined. Please check it\'s connected and parsed correctly.');
      }
      var masonry = new __WEBPACK_IMPORTED_MODULE_2_masonry_layout___default.a(el, collectOptions(el.attributes));
      var masonryDraw = function masonryDraw() {
        masonry.reloadItems();
        masonry.layout();
      };
      Vue.nextTick(function () {
        masonryDraw();
      });

      Events.$on(EVENT_ADD, function (eventData) {
        masonryDraw();
      });
      Events.$on(EVENT_REMOVE, function (eventData) {
        masonryDraw();
      });
      Events.$on(EVENT_IMAGE_LOADED, function (eventData) {
        masonryDraw();
      });
    }
  });

  Vue.directive('masonryTile', {

    inserted: function inserted(el) {
      Events.$emit(EVENT_ADD, {
        'element': el
      });

      /* eslint-disable no-new */
      new __WEBPACK_IMPORTED_MODULE_3_imagesloaded___default.a(el, function () {
        Events.$emit(EVENT_IMAGE_LOADED, {
          'element': el
        });
      });
    },
    beforeDestroy: function beforeDestroy(el) {
      Events.$emit(EVENT_REMOVE, {
        'element': el
      });
    }
  });
}

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/**
 * Created by lingchenxuan on 16-11-9.
 * https://github.com/ibufu/vue2-scrollspy
 */
var scrollSections = [];

var bodyScrollEl = {};

// For ff, ie
Object.defineProperty(bodyScrollEl, 'scrollTop', {
  get: function get() {
    return document.body.scrollTop || document.documentElement.scrollTop;
  },
  set: function set(val) {
    document.body.scrollTop = val;
    document.documentElement.scrollTop = val;
  }
});

function init(el) {
  scrollSections = [];
  var sections = el.children;
  if (sections[0] && sections[0].offsetParent !== el) {
    el[scrollSpyContext].eventEl = window;
    el[scrollSpyContext].scrollEl = bodyScrollEl;
  }

  for (var i = 0; i < sections.length; i++) {
    if (sections[i].offsetTop >= 0) {
      scrollSections.push(sections[i].offsetTop);
    }
  }
}

var scrollSpyContext = '@@scrollSpyContext';

function install(Vue) {
  Vue.directive('scroll-spy', {
    bind: function bind(el, binding, vnode) {
      function onScroll() {
        var _el$scrollSpyContext = el[scrollSpyContext],
            scrollEl = _el$scrollSpyContext.scrollEl,
            expression = _el$scrollSpyContext.expression;

        var pos = scrollEl.scrollTop;
        var i = 0;
        while (pos >= scrollSections[i]) {
          i++;
        }
        vnode.context.$data[expression] = i ? i - 1 : 0;
      }

      function scrollToIndex(index) {
        console.log('scroll!!!!');
        var scrollEl = el[scrollSpyContext].scrollEl;

        var current = scrollEl.scrollTop;
        var target = scrollSections[index];
        var time = 200;
        var steps = 30;
        var timems = parseInt(time / steps);
        var gap = target - current;

        var _loop = function _loop(i) {
          var pos = current + gap / steps * i;
          setTimeout(function () {
            scrollEl.scrollTop = pos;
          }, timems * i);
        };

        for (var i = 0; i <= steps; i++) {
          _loop(i);
        }
      }
      vnode.context.$scrollToIndex = scrollToIndex;

      el[scrollSpyContext] = {
        onScroll: onScroll,
        expression: binding.expression,
        eventEl: el,
        scrollEl: el
      };
    },
    inserted: function inserted(el) {
      init(el);

      var _el$scrollSpyContext2 = el[scrollSpyContext],
          eventEl = _el$scrollSpyContext2.eventEl,
          onScroll = _el$scrollSpyContext2.onScroll;

      eventEl.addEventListener('scroll', onScroll);
    },
    componentUpdated: function componentUpdated(el) {
      init(el);
    },
    unbind: function unbind(el) {
      var _el$scrollSpyContext3 = el[scrollSpyContext],
          eventEl = _el$scrollSpyContext3.eventEl,
          onScroll = _el$scrollSpyContext3.onScroll;

      eventEl.removeEventListener('scroll', onScroll);
    }
  });
}

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_persist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */]);

var state = {
  count: 0,
  authentication: undefined
};

var getters = {
  evenOrOdd: function evenOrOdd(state) {
    return state.count % 2 === 0 ? 'even' : 'odd';
  },
  isAuthenticated: function isAuthenticated(state) {
    if (!state.authentication || state.authentication === undefined) {
      return false;
    }

    var data = state.authentication;
    if (!data || !data.expires_in || !data.token_type || !data.access_token || !data.refresh_token) {
      return false;
    }

    return true;
  },
  authenticatedUsername: function authenticatedUsername(state) {
    if (!state.authentication) {
      return '';
    }
    return state.authentication.email;
  },
  authenticatedAuthorization: function authenticatedAuthorization(state) {
    if (!state.authentication || !state.authentication.access_token || !state.authentication.token_type) {
      return undefined;
    }
    return state.authentication.token_type + ' ' + state.authentication.access_token;
  }
};

var mutations = {
  increment: function increment(state) {
    state.count++;
  },
  decrement: function decrement(state) {
    state.count--;
  },
  authenticated: function authenticated(state, data) {
    // console.log('mutation:authenticated')
    // console.log(data)
    state.authentication = data;
  },
  unauthenticated: function unauthenticated(state) {
    // console.log('mutation:unauthenticated')
    state.authentication = undefined;
  }
};

var actions = {
  increment: function increment(_ref) {
    var commit = _ref.commit;
    return commit('increment');
  },
  decrement: function decrement(_ref2) {
    var commit = _ref2.commit;
    return commit('decrement');
  },
  incrementIfOdd: function incrementIfOdd(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state;

    if ((state.count + 1) % 2 === 0) {
      commit('increment');
    }
  },
  incrementAsync: function incrementAsync(_ref4) {
    var commit = _ref4.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      setTimeout(function () {
        commit('increment');
        resolve();
      }, 1000);
    });
  },
  authenticated: function authenticated(_ref5, data) {
    var commit = _ref5.commit;

    // console.log('actions:authenticated')
    // console.log(data)

    if (!data || !data.expires_in || !data.token_type || !data.access_token || !data.refresh_token) {
      console.error('actions:authenticated:invalid authentication data', data);
      return;
    }

    // set header & update cookie
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.post['Authorization'] = data.token_type + ' ' + data.access_token;
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.get['Authorization'] = data.token_type + ' ' + data.access_token;
    return commit('authenticated', data);
  },
  unauthenticated: function unauthenticated(_ref6) {
    var commit = _ref6.commit;

    // console.log('actions:unauthenticated')

    // remove header & clear cookie
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.post['Authorization'] = undefined;
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.get['Authorization'] = undefined;
    return commit('unauthenticated');
  }
};

// authentication cookie store to store persistent storage
var authCookieStore = new __WEBPACK_IMPORTED_MODULE_3_vuex_persist___default.a({
  key: 'authorization',
  restoreState: function restoreState(key, storage) {
    // console.log('cookie:restoreState')
    // console.log(key)
    // console.log(state)
    var data = __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.getJSON(key);
    state.authentication = data;
    if (!data || !data.token_type || !data.access_token) {
      // console.error('Invalid authorization')
      return __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.getJSON(key);
    }

    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.post['Authorization'] = data.token_type + ' ' + data.access_token;
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.get['Authorization'] = data.token_type + ' ' + data.access_token;

    // hopefully the following doesn't simply bind to override
    return __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.getJSON(key);
  },
  saveState: function saveState(key, state, storage) {
    // console.log('cookie:saveState')
    // console.log(key)
    // console.log(state)
    if (!state.authentication || state.authentication === undefined || !state.authentication.expires_in || state.authentication.expires_in === undefined || !state.authentication.access_token || state.authentication.access_token === undefined || !state.authentication.refresh_token || state.authentication.refresh_token === undefined || !state.authentication.token_type || state.authentication.token_type === undefined) {
      __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.remove(key);
      return;
    }

    var expires = state.authentication.expires_in / 60 / 60 / 24;
    console.log('cookie authentication expires in: ' + expires);
    return __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set(key, state.authentication, {
      expires: expires
    });
  },
  reducer: function reducer(state) {
    // console.log('cookie:reducer')
    // console.log(state)
    return { authentication: state.authentication };
  },
  filter: function filter(mutation) {
    // console.log('cookie:filter, mutation.type=' + mutation.type)
    return mutation.type === 'authenticated' || mutation.type === 'unauthenticated';
  }
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */].Store({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  plugins: [authCookieStore.plugin]
}));

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Landing__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Landing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Landing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Info__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Teams__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Teams___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Teams__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_About__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Schedule__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Schedule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_Schedule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Tickets__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Tickets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_Tickets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Photos__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Photos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_Photos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Sponsors__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Sponsors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_Sponsors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_SignUp__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_SignUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_SignUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_NotFound__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_NotFound__);



// import StayTuned from '@/pages/StayTuned'











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var vueRouter = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [
  // {
  //   path: '/',
  //   name: 'staytuned',
  //   id: -1,
  //   title: 'Stay Tuned',
  //   component: StayTuned
  // },
  {
    path: '/',
    name: 'landing',
    id: 0,
    title: 'Landing',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Landing___default.a
  }, {
    path: '/info',
    name: 'info',
    id: 1,
    title: 'Info',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Info___default.a
  }, {
    path: '/teams',
    name: 'teams',
    id: 10,
    title: 'Teams',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Teams___default.a
  }, {
    path: '/about',
    name: 'about',
    id: 11,
    title: 'About',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_About___default.a
  }, {
    path: '/schedule',
    name: 'schedule',
    id: 2,
    title: 'Schedule',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_Schedule___default.a
  }, {
    path: '/tickets',
    name: 'tickets',
    id: 3,
    title: 'Tickets',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_Tickets___default.a
  }, {
    path: '/photos',
    name: 'photos',
    id: 4,
    title: 'Photos',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_Photos___default.a
  }, {
    path: '/sponsors',
    name: 'sponsors',
    id: 5,
    title: 'Sponsors',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_Sponsors___default.a
  }, {
    path: '/signup',
    name: 'signup',
    id: 6,
    title: 'Signup',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_SignUp___default.a
  }, {
    path: '*',
    name: 'notfound',
    id: 404,
    title: 'Not Found',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_NotFound___default.a
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (vueRouter);

/***/ }),
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var __cov_0GTwwl$GMPTkkuRWFDyc4w = (Function('return this'))();
if (!__cov_0GTwwl$GMPTkkuRWFDyc4w.__coverage__) { __cov_0GTwwl$GMPTkkuRWFDyc4w.__coverage__ = {}; }
__cov_0GTwwl$GMPTkkuRWFDyc4w = __cov_0GTwwl$GMPTkkuRWFDyc4w.__coverage__;
if (!(__cov_0GTwwl$GMPTkkuRWFDyc4w['/home/fahrenq/code/v-img/lib/ImgScreen.vue'])) {
   __cov_0GTwwl$GMPTkkuRWFDyc4w['/home/fahrenq/code/v-img/lib/ImgScreen.vue'] = {"path":"/home/fahrenq/code/v-img/lib/ImgScreen.vue","s":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0},"b":{"1":[0,0],"2":[0,0],"3":[0,0],"4":[0,0],"5":[0,0],"6":[0,0],"7":[0,0],"8":[0,0],"9":[0,0],"10":[0,0],"11":[0,0],"12":[0,0],"13":[0,0],"14":[0,0],"15":[0,0],"16":[0,0],"17":[0,0],"18":[0,0],"19":[0,0]},"f":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0},"fnMap":{"1":{"name":"(anonymous_1)","line":1,"loc":{"start":{"line":1,"column":1},"end":{"line":1,"column":13}}},"2":{"name":"render","line":13,"loc":{"start":{"line":13,"column":25},"end":{"line":13,"column":43}}},"3":{"name":"click","line":14,"loc":{"start":{"line":14,"column":225},"end":{"line":14,"column":248}}},"4":{"name":"data","line":20,"loc":{"start":{"line":20,"column":8},"end":{"line":20,"column":24}}},"5":{"name":"close","line":31,"loc":{"start":{"line":31,"column":11},"end":{"line":31,"column":28}}},"6":{"name":"next","line":37,"loc":{"start":{"line":37,"column":10},"end":{"line":37,"column":26}}},"7":{"name":"prev","line":45,"loc":{"start":{"line":45,"column":10},"end":{"line":45,"column":26}}},"8":{"name":"showUI","line":53,"loc":{"start":{"line":53,"column":12},"end":{"line":53,"column":30}}},"9":{"name":"(anonymous_9)","line":60,"loc":{"start":{"line":60,"column":34},"end":{"line":60,"column":46}}},"10":{"name":"created","line":65,"loc":{"start":{"line":65,"column":11},"end":{"line":65,"column":30}}},"11":{"name":"(anonymous_11)","line":68,"loc":{"start":{"line":68,"column":37},"end":{"line":68,"column":50}}},"12":{"name":"(anonymous_12)","line":76,"loc":{"start":{"line":76,"column":38},"end":{"line":76,"column":50}}},"13":{"name":"(anonymous_13)","line":79,"loc":{"start":{"line":79,"column":41},"end":{"line":79,"column":53}}}},"statementMap":{"1":{"start":{"line":1,"column":0},"end":{"line":11,"column":5}},"2":{"start":{"line":2,"column":2},"end":{"line":10,"column":3}},"3":{"start":{"line":3,"column":4},"end":{"line":5,"column":2130}},"4":{"start":{"line":5,"column":2130},"end":{"line":5,"column":2154}},"5":{"start":{"line":5,"column":2154},"end":{"line":9,"column":5}},"6":{"start":{"line":6,"column":6},"end":{"line":6,"column":37}},"7":{"start":{"line":8,"column":6},"end":{"line":8,"column":54}},"8":{"start":{"line":9,"column":5},"end":{"line":9,"column":29}},"9":{"start":{"line":14,"column":4},"end":{"line":14,"column":19}},"10":{"start":{"line":14,"column":19},"end":{"line":14,"column":47}},"11":{"start":{"line":14,"column":47},"end":{"line":14,"column":75}},"12":{"start":{"line":14,"column":75},"end":{"line":18,"column":1683}},"13":{"start":{"line":15,"column":10},"end":{"line":17,"column":11}},"14":{"start":{"line":16,"column":12},"end":{"line":16,"column":24}},"15":{"start":{"line":17,"column":11},"end":{"line":17,"column":23}},"16":{"start":{"line":21,"column":4},"end":{"line":27,"column":6}},"17":{"start":{"line":32,"column":6},"end":{"line":32,"column":71}},"18":{"start":{"line":33,"column":6},"end":{"line":33,"column":23}},"19":{"start":{"line":34,"column":6},"end":{"line":34,"column":33}},"20":{"start":{"line":35,"column":6},"end":{"line":35,"column":25}},"21":{"start":{"line":39,"column":6},"end":{"line":43,"column":7}},"22":{"start":{"line":40,"column":8},"end":{"line":40,"column":33}},"23":{"start":{"line":42,"column":8},"end":{"line":42,"column":35}},"24":{"start":{"line":47,"column":6},"end":{"line":51,"column":7}},"25":{"start":{"line":48,"column":8},"end":{"line":48,"column":33}},"26":{"start":{"line":50,"column":8},"end":{"line":50,"column":56}},"27":{"start":{"line":54,"column":6},"end":{"line":54,"column":23}},"28":{"start":{"line":58,"column":6},"end":{"line":58,"column":35}},"29":{"start":{"line":59,"column":6},"end":{"line":59,"column":28}},"30":{"start":{"line":60,"column":6},"end":{"line":62,"column":15}},"31":{"start":{"line":61,"column":8},"end":{"line":61,"column":32}},"32":{"start":{"line":66,"column":4},"end":{"line":66,"column":22}},"33":{"start":{"line":68,"column":4},"end":{"line":75,"column":7}},"34":{"start":{"line":70,"column":6},"end":{"line":70,"column":63}},"35":{"start":{"line":70,"column":48},"end":{"line":70,"column":63}},"36":{"start":{"line":72,"column":6},"end":{"line":72,"column":62}},"37":{"start":{"line":72,"column":48},"end":{"line":72,"column":62}},"38":{"start":{"line":74,"column":6},"end":{"line":74,"column":62}},"39":{"start":{"line":74,"column":48},"end":{"line":74,"column":62}},"40":{"start":{"line":76,"column":4},"end":{"line":78,"column":7}},"41":{"start":{"line":77,"column":6},"end":{"line":77,"column":21}},"42":{"start":{"line":79,"column":4},"end":{"line":81,"column":7}},"43":{"start":{"line":80,"column":6},"end":{"line":80,"column":22}}},"branchMap":{"1":{"line":2,"type":"if","locations":[{"start":{"line":2,"column":2},"end":{"line":2,"column":2}},{"start":{"line":2,"column":2},"end":{"line":2,"column":2}}]},"2":{"line":3,"type":"binary-expr","locations":[{"start":{"line":3,"column":15},"end":{"line":3,"column":28}},{"start":{"line":3,"column":32},"end":{"line":3,"column":72}}]},"3":{"line":5,"type":"if","locations":[{"start":{"line":5,"column":2154},"end":{"line":5,"column":2154}},{"start":{"line":5,"column":2154},"end":{"line":5,"column":2154}}]},"4":{"line":14,"type":"binary-expr","locations":[{"start":{"line":14,"column":56},"end":{"line":14,"column":68}},{"start":{"line":14,"column":72},"end":{"line":14,"column":74}}]},"5":{"line":14,"type":"cond-expr","locations":[{"start":{"line":14,"column":165},"end":{"line":18,"column":1669}},{"start":{"line":18,"column":1672},"end":{"line":18,"column":1680}}]},"6":{"line":15,"type":"if","locations":[{"start":{"line":15,"column":10},"end":{"line":15,"column":10}},{"start":{"line":15,"column":10},"end":{"line":15,"column":10}}]},"7":{"line":18,"type":"cond-expr","locations":[{"start":{"line":18,"column":84},"end":{"line":18,"column":211}},{"start":{"line":18,"column":214},"end":{"line":18,"column":222}}]},"8":{"line":18,"type":"cond-expr","locations":[{"start":{"line":18,"column":425},"end":{"line":18,"column":903}},{"start":{"line":18,"column":906},"end":{"line":18,"column":914}}]},"9":{"line":18,"type":"binary-expr","locations":[{"start":{"line":18,"column":382},"end":{"line":18,"column":395}},{"start":{"line":18,"column":399},"end":{"line":18,"column":422}}]},"10":{"line":18,"type":"cond-expr","locations":[{"start":{"line":18,"column":1030},"end":{"line":18,"column":1509}},{"start":{"line":18,"column":1512},"end":{"line":18,"column":1520}}]},"11":{"line":18,"type":"binary-expr","locations":[{"start":{"line":18,"column":987},"end":{"line":18,"column":1000}},{"start":{"line":18,"column":1004},"end":{"line":18,"column":1027}}]},"12":{"line":39,"type":"if","locations":[{"start":{"line":39,"column":6},"end":{"line":39,"column":6}},{"start":{"line":39,"column":6},"end":{"line":39,"column":6}}]},"13":{"line":47,"type":"if","locations":[{"start":{"line":47,"column":6},"end":{"line":47,"column":6}},{"start":{"line":47,"column":6},"end":{"line":47,"column":6}}]},"14":{"line":70,"type":"if","locations":[{"start":{"line":70,"column":6},"end":{"line":70,"column":6}},{"start":{"line":70,"column":6},"end":{"line":70,"column":6}}]},"15":{"line":70,"type":"binary-expr","locations":[{"start":{"line":70,"column":10},"end":{"line":70,"column":26}},{"start":{"line":70,"column":30},"end":{"line":70,"column":46}}]},"16":{"line":72,"type":"if","locations":[{"start":{"line":72,"column":6},"end":{"line":72,"column":6}},{"start":{"line":72,"column":6},"end":{"line":72,"column":6}}]},"17":{"line":72,"type":"binary-expr","locations":[{"start":{"line":72,"column":10},"end":{"line":72,"column":26}},{"start":{"line":72,"column":30},"end":{"line":72,"column":46}}]},"18":{"line":74,"type":"if","locations":[{"start":{"line":74,"column":6},"end":{"line":74,"column":6}},{"start":{"line":74,"column":6},"end":{"line":74,"column":6}}]},"19":{"line":74,"type":"binary-expr","locations":[{"start":{"line":74,"column":10},"end":{"line":74,"column":26}},{"start":{"line":74,"column":30},"end":{"line":74,"column":46}}]}}};
}
__cov_0GTwwl$GMPTkkuRWFDyc4w = __cov_0GTwwl$GMPTkkuRWFDyc4w['/home/fahrenq/code/v-img/lib/ImgScreen.vue'];
__cov_0GTwwl$GMPTkkuRWFDyc4w.s['1']++;(function(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['1']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['2']++;if(document){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['1'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['3']++;var head=(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['2'][0]++,document.head)||(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['2'][1]++,document.getElementsByTagName('head')[0]),style=document.createElement('style'),css=' *[data-v-5928e1c7] { -webkit-box-sizing: border-box; box-sizing: border-box; } .fullscreen-v-img[data-v-5928e1c7] { height: 100%; width: 100%; position: fixed; top: 0; left: 0; overflow: hidden; background-color: rgba(0, 0, 0, .7); -ms-touch-action: none; touch-action: none; } .content-v-img img[data-v-5928e1c7] { width: auto; height: auto; max-width: 100%; max-height: 100%; position: absolute; top: 0; left: 0; right: 0; bottom: 0; margin: auto; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; } .header-v-img[data-v-5928e1c7] { position: absolute; width: 100%; background-color: rgba(0, 0, 0, .3); height: 50px; z-index: 9999; } .count-v-img[data-v-5928e1c7] { font-family: \'Avenir\', Helvetica, Arial, sans-serif; font-size: 15px; color: white; margin-left: 10px; line-height: 50px; } .close-v-img[data-v-5928e1c7] { float: right; margin-right: 10px; font-family: \'Avenir\', Helvetica, Arial, sans-serif; color: #E5E6EB; font-size: 30px; line-height: 50px; cursor: pointer; -webkit-transition: color .4s ease-in-out; transition: color .4s ease-in-out; } .close-v-img[data-v-5928e1c7]:hover { color: white; } .prev-v-img svg[data-v-5928e1c7], .next-v-img svg[data-v-5928e1c7] { margin: 5px auto; } .prev-v-img[data-v-5928e1c7], .next-v-img[data-v-5928e1c7] { color: white; width: 35px; height: 35px; position: absolute; top: 50%; margin-top: -12.5px; font-size: 15px; font-family: \'Avenir\', Helvetica, Arial, sans-serif; text-align: center; background-color: rgba(0, 0, 0, .3); z-index: 1000; opacity: .3; -webkit-transition: opacity .3s ease-in-out; transition: opacity .3s ease-in-out; cursor: pointer; } .prev-v-img[data-v-5928e1c7]:hover, .next-v-img[data-v-5928e1c7]:hover { opacity: 1; } .prev-v-img[data-v-5928e1c7] { left: 10px; } .next-v-img[data-v-5928e1c7] { right: 10px; } .v-img-fade-enter[data-v-5928e1c7], .v-img-fade-leave-to[data-v-5928e1c7] { opacity: 0; } .v-img-fade-enter-active[data-v-5928e1c7], .v-img-fade-leave-active[data-v-5928e1c7] { -webkit-transition: opacity .3s ease-in-out; transition: opacity .3s ease-in-out; } .body-fs-v-img {} ';__cov_0GTwwl$GMPTkkuRWFDyc4w.s['4']++;style.type='text/css';__cov_0GTwwl$GMPTkkuRWFDyc4w.s['5']++;if(style.styleSheet){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['3'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['6']++;style.styleSheet.cssText=css;}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['3'][1]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['7']++;style.appendChild(document.createTextNode(css));}__cov_0GTwwl$GMPTkkuRWFDyc4w.s['8']++;head.appendChild(style);}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['1'][1]++;}}());var ImgScreen = {render:function render(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['2']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['9']++;var _vm=this;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['10']++;var _h=_vm.$createElement;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['11']++;var _c=(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['4'][0]++,_vm._self._c)||(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['4'][1]++,_h);__cov_0GTwwl$GMPTkkuRWFDyc4w.s['12']++;return _c('transition',{attrs:{'appear':'','name':'v-img-fade'}},[!_vm.closed?(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['5'][0]++,_c('div',{staticClass:'fullscreen-v-img',on:{'click':function click($event){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['3']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['13']++;if($event.target!==$event.currentTarget){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['6'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['14']++;return null;}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['6'][1]++;}__cov_0GTwwl$GMPTkkuRWFDyc4w.s['15']++;_vm.close();}}},[_c('div',{staticClass:'header-v-img'},[_vm.images.length>1?(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['7'][0]++,_c('span',{staticClass:'count-v-img'},[_vm._v(_vm._s(_vm.currentImageIndex+1)+'/'+_vm._s(_vm.images.length)+' ')])):(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['7'][1]++,_vm._e()),_c('span',{staticClass:'close-v-img',on:{'click':_vm.close}},[_vm._v('\xD7')])]),_c('transition',{attrs:{'appear':'','name':'v-img-fade'}},[(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['9'][0]++,_vm.visibleUI)&&(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['9'][1]++,_vm.images.length!==1)?(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['8'][0]++,_c('span',{staticClass:'prev-v-img',on:{'click':_vm.prev}},[_c('svg',{attrs:{'width':'25','height':'25','viewBox':'0 0 1792 1915','xmlns':'http://www.w3.org/2000/svg'}},[_c('path',{attrs:{'d':'M1664 896v128q0 53-32.5 90.5t-84.5 37.5h-704l293 294q38 36 38 90t-38 90l-75 76q-37 37-90 37-52 0-91-37l-651-652q-37-37-37-90 0-52 37-91l651-650q38-38 91-38 52 0 90 38l75 74q38 38 38 91t-38 91l-293 293h704q52 0 84.5 37.5t32.5 90.5z','fill':'#fff'}})])])):(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['8'][1]++,_vm._e())]),_c('transition',{attrs:{'appear':'','name':'v-img-fade'}},[(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['11'][0]++,_vm.visibleUI)&&(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['11'][1]++,_vm.images.length!==1)?(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['10'][0]++,_c('span',{staticClass:'next-v-img',on:{'click':_vm.next}},[_c('svg',{attrs:{'width':'25','height':'25','viewBox':'0 0 1792 1915','xmlns':'http://www.w3.org/2000/svg'}},[_c('path',{attrs:{'d':'M1600 960q0 54-37 91l-651 651q-39 37-91 37-51 0-90-37l-75-75q-38-38-38-91t38-91l293-293h-704q-52 0-84.5-37.5t-32.5-90.5v-128q0-53 32.5-90.5t84.5-37.5h704l-293-294q-38-36-38-90t38-90l75-75q38-38 90-38 53 0 91 38l651 651q37 35 37 90z','fill':'#fff'}})])])):(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['10'][1]++,_vm._e())]),_c('div',{staticClass:'content-v-img'},[_c('img',{attrs:{'src':_vm.images[_vm.currentImageIndex]},on:{'click':_vm.next}})])],1)):(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['5'][1]++,_vm._e())]);},staticRenderFns:[],_scopeId:'data-v-5928e1c7',data:function data(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['4']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['16']++;return{images:[],visibleUI:true,currentImageIndex:0,closed:true,uiTimeout:null};},methods:{close:function close(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['5']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['17']++;document.querySelector('body').classList.remove('body-fs-v-img');__cov_0GTwwl$GMPTkkuRWFDyc4w.s['18']++;this.images=[];__cov_0GTwwl$GMPTkkuRWFDyc4w.s['19']++;this.currentImageIndex=0;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['20']++;this.closed=true;},next:function next(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['6']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['21']++;if(this.currentImageIndex+1<this.images.length){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['12'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['22']++;this.currentImageIndex++;}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['12'][1]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['23']++;this.currentImageIndex=0;}},prev:function prev(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['7']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['24']++;if(this.currentImageIndex>0){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['13'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['25']++;this.currentImageIndex--;}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['13'][1]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['26']++;this.currentImageIndex=this.images.length-1;}},showUI:function showUI(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['8']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['27']++;var _this=this;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['28']++;clearTimeout(this.uiTimeout);__cov_0GTwwl$GMPTkkuRWFDyc4w.s['29']++;this.visibleUI=true;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['30']++;this.uiTimeout=setTimeout(function(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['9']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['31']++;_this.visibleUI=false;},3500);}},created:function created(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['10']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['32']++;var _this2=this;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['33']++;window.addEventListener('keyup',function(e){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['11']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['34']++;if((__cov_0GTwwl$GMPTkkuRWFDyc4w.b['15'][0]++,e.keyCode===27)||(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['15'][1]++,e.keyCode===81)){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['14'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['35']++;_this2.close();}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['14'][1]++;}__cov_0GTwwl$GMPTkkuRWFDyc4w.s['36']++;if((__cov_0GTwwl$GMPTkkuRWFDyc4w.b['17'][0]++,e.keyCode===39)||(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['17'][1]++,e.keyCode===76)){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['16'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['37']++;_this2.next();}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['16'][1]++;}__cov_0GTwwl$GMPTkkuRWFDyc4w.s['38']++;if((__cov_0GTwwl$GMPTkkuRWFDyc4w.b['19'][0]++,e.keyCode===37)||(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['19'][1]++,e.keyCode===72)){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['18'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['39']++;_this2.prev();}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['18'][1]++;}});__cov_0GTwwl$GMPTkkuRWFDyc4w.s['40']++;window.addEventListener('scroll',function(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['12']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['41']++;_this2.close();});__cov_0GTwwl$GMPTkkuRWFDyc4w.s['42']++;window.addEventListener('mousemove',function(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['13']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['43']++;_this2.showUI();});}};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var __cov_WuSw60ZQZcI1aW7neh6dWA = (Function('return this'))();
if (!__cov_WuSw60ZQZcI1aW7neh6dWA.__coverage__) { __cov_WuSw60ZQZcI1aW7neh6dWA.__coverage__ = {}; }
__cov_WuSw60ZQZcI1aW7neh6dWA = __cov_WuSw60ZQZcI1aW7neh6dWA.__coverage__;
if (!(__cov_WuSw60ZQZcI1aW7neh6dWA['/home/fahrenq/code/v-img/lib/index.js'])) {
   __cov_WuSw60ZQZcI1aW7neh6dWA['/home/fahrenq/code/v-img/lib/index.js'] = {"path":"/home/fahrenq/code/v-img/lib/index.js","s":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0},"b":{"1":[0,0],"2":[0,0],"3":[0,0],"4":[0,0],"5":[0,0],"6":[0,0],"7":[0,0],"8":[0,0],"9":[0,0],"10":[0,0],"11":[0,0],"12":[0,0]},"f":{"1":0,"2":0,"3":0,"4":0},"fnMap":{"1":{"name":"install","line":6,"loc":{"start":{"line":6,"column":14},"end":{"line":6,"column":36}}},"2":{"name":"bind","line":10,"loc":{"start":{"line":10,"column":10},"end":{"line":10,"column":37}}},"3":{"name":"(anonymous_3)","line":45,"loc":{"start":{"line":45,"column":35},"end":{"line":45,"column":47}}},"4":{"name":"(anonymous_4)","line":52,"loc":{"start":{"line":52,"column":43},"end":{"line":52,"column":56}}}},"statementMap":{"1":{"start":{"line":6,"column":0},"end":{"line":61,"column":2}},"2":{"start":{"line":7,"column":2},"end":{"line":7,"column":37}},"3":{"start":{"line":9,"column":2},"end":{"line":60,"column":5}},"4":{"start":{"line":12,"column":6},"end":{"line":12,"column":29}},"5":{"start":{"line":13,"column":6},"end":{"line":13,"column":23}},"6":{"start":{"line":14,"column":6},"end":{"line":14,"column":38}},"7":{"start":{"line":17,"column":6},"end":{"line":21,"column":7}},"8":{"start":{"line":18,"column":8},"end":{"line":18,"column":48}},"9":{"start":{"line":19,"column":8},"end":{"line":19,"column":39}},"10":{"start":{"line":20,"column":8},"end":{"line":20,"column":45}},"11":{"start":{"line":24,"column":6},"end":{"line":24,"column":59}},"12":{"start":{"line":25,"column":6},"end":{"line":27,"column":7}},"13":{"start":{"line":26,"column":8},"end":{"line":26,"column":63}},"14":{"start":{"line":29,"column":6},"end":{"line":29,"column":70}},"15":{"start":{"line":29,"column":16},"end":{"line":29,"column":70}},"16":{"start":{"line":32,"column":6},"end":{"line":32,"column":31}},"17":{"start":{"line":35,"column":6},"end":{"line":35,"column":29}},"18":{"start":{"line":36,"column":6},"end":{"line":41,"column":7}},"19":{"start":{"line":37,"column":8},"end":{"line":37,"column":52}},"20":{"start":{"line":38,"column":8},"end":{"line":38,"column":50}},"21":{"start":{"line":39,"column":8},"end":{"line":39,"column":60}},"22":{"start":{"line":40,"column":8},"end":{"line":40,"column":65}},"23":{"start":{"line":45,"column":6},"end":{"line":58,"column":9}},"24":{"start":{"line":46,"column":8},"end":{"line":46,"column":70}},"25":{"start":{"line":48,"column":8},"end":{"line":48,"column":133}},"26":{"start":{"line":49,"column":8},"end":{"line":56,"column":9}},"27":{"start":{"line":50,"column":10},"end":{"line":50,"column":39}},"28":{"start":{"line":52,"column":10},"end":{"line":54,"column":14}},"29":{"start":{"line":53,"column":12},"end":{"line":53,"column":48}},"30":{"start":{"line":55,"column":10},"end":{"line":55,"column":63}},"31":{"start":{"line":57,"column":8},"end":{"line":57,"column":37}}},"branchMap":{"1":{"line":14,"type":"binary-expr","locations":[{"start":{"line":14,"column":18},"end":{"line":14,"column":29}},{"start":{"line":14,"column":33},"end":{"line":14,"column":37}}]},"2":{"line":17,"type":"if","locations":[{"start":{"line":17,"column":6},"end":{"line":17,"column":6}},{"start":{"line":17,"column":6},"end":{"line":17,"column":6}}]},"3":{"line":18,"type":"binary-expr","locations":[{"start":{"line":18,"column":17},"end":{"line":18,"column":37}},{"start":{"line":18,"column":41},"end":{"line":18,"column":47}}]},"4":{"line":19,"type":"binary-expr","locations":[{"start":{"line":19,"column":14},"end":{"line":19,"column":31}},{"start":{"line":19,"column":35},"end":{"line":19,"column":38}}]},"5":{"line":20,"type":"binary-expr","locations":[{"start":{"line":20,"column":16},"end":{"line":20,"column":35}},{"start":{"line":20,"column":39},"end":{"line":20,"column":44}}]},"6":{"line":24,"type":"binary-expr","locations":[{"start":{"line":24,"column":44},"end":{"line":24,"column":49}},{"start":{"line":24,"column":53},"end":{"line":24,"column":57}}]},"7":{"line":25,"type":"if","locations":[{"start":{"line":25,"column":6},"end":{"line":25,"column":6}},{"start":{"line":25,"column":6},"end":{"line":25,"column":6}}]},"8":{"line":25,"type":"binary-expr","locations":[{"start":{"line":25,"column":10},"end":{"line":25,"column":23}},{"start":{"line":25,"column":27},"end":{"line":25,"column":44}}]},"9":{"line":29,"type":"if","locations":[{"start":{"line":29,"column":6},"end":{"line":29,"column":6}},{"start":{"line":29,"column":6},"end":{"line":29,"column":6}}]},"10":{"line":36,"type":"if","locations":[{"start":{"line":36,"column":6},"end":{"line":36,"column":6}},{"start":{"line":36,"column":6},"end":{"line":36,"column":6}}]},"11":{"line":49,"type":"if","locations":[{"start":{"line":49,"column":8},"end":{"line":49,"column":8}},{"start":{"line":49,"column":8},"end":{"line":49,"column":8}}]},"12":{"line":53,"type":"binary-expr","locations":[{"start":{"line":53,"column":19},"end":{"line":53,"column":38}},{"start":{"line":53,"column":42},"end":{"line":53,"column":47}}]}}};
}
__cov_WuSw60ZQZcI1aW7neh6dWA = __cov_WuSw60ZQZcI1aW7neh6dWA['/home/fahrenq/code/v-img/lib/index.js'];
__cov_WuSw60ZQZcI1aW7neh6dWA.s['1']++;var install=function install(Vue){__cov_WuSw60ZQZcI1aW7neh6dWA.f['1']++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['2']++;var screen=Vue.extend(ImgScreen);__cov_WuSw60ZQZcI1aW7neh6dWA.s['3']++;Vue.directive('img',{bind:function bind(el,binding){__cov_WuSw60ZQZcI1aW7neh6dWA.f['2']++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['4']++;var cursor='pointer';__cov_WuSw60ZQZcI1aW7neh6dWA.s['5']++;var src=el.src;__cov_WuSw60ZQZcI1aW7neh6dWA.s['6']++;var group=(__cov_WuSw60ZQZcI1aW7neh6dWA.b['1'][0]++,binding.arg)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['1'][1]++,null);__cov_WuSw60ZQZcI1aW7neh6dWA.s['7']++;if(typeof binding.value!=='undefined'){__cov_WuSw60ZQZcI1aW7neh6dWA.b['2'][0]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['8']++;cursor=(__cov_WuSw60ZQZcI1aW7neh6dWA.b['3'][0]++,binding.value.cursor)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['3'][1]++,cursor);__cov_WuSw60ZQZcI1aW7neh6dWA.s['9']++;src=(__cov_WuSw60ZQZcI1aW7neh6dWA.b['4'][0]++,binding.value.src)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['4'][1]++,src);__cov_WuSw60ZQZcI1aW7neh6dWA.s['10']++;group=(__cov_WuSw60ZQZcI1aW7neh6dWA.b['5'][0]++,binding.value.group)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['5'][1]++,group);}else{__cov_WuSw60ZQZcI1aW7neh6dWA.b['2'][1]++;}__cov_WuSw60ZQZcI1aW7neh6dWA.s['11']++;el.setAttribute('data-vue-img-group',(__cov_WuSw60ZQZcI1aW7neh6dWA.b['6'][0]++,group)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['6'][1]++,null));__cov_WuSw60ZQZcI1aW7neh6dWA.s['12']++;if((__cov_WuSw60ZQZcI1aW7neh6dWA.b['8'][0]++,binding.value)&&(__cov_WuSw60ZQZcI1aW7neh6dWA.b['8'][1]++,binding.value.src)){__cov_WuSw60ZQZcI1aW7neh6dWA.b['7'][0]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['13']++;el.setAttribute('data-vue-img-src',binding.value.src);}else{__cov_WuSw60ZQZcI1aW7neh6dWA.b['7'][1]++;}__cov_WuSw60ZQZcI1aW7neh6dWA.s['14']++;if(!src){__cov_WuSw60ZQZcI1aW7neh6dWA.b['9'][0]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['15']++;console.error('v-img element missing src parameter.');}else{__cov_WuSw60ZQZcI1aW7neh6dWA.b['9'][1]++;}__cov_WuSw60ZQZcI1aW7neh6dWA.s['16']++;el.style.cursor=cursor;__cov_WuSw60ZQZcI1aW7neh6dWA.s['17']++;var vm=window.vueImg;__cov_WuSw60ZQZcI1aW7neh6dWA.s['18']++;if(!vm){__cov_WuSw60ZQZcI1aW7neh6dWA.b['10'][0]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['19']++;var element=document.createElement('div');__cov_WuSw60ZQZcI1aW7neh6dWA.s['20']++;element.setAttribute('id','imageScreen');__cov_WuSw60ZQZcI1aW7neh6dWA.s['21']++;document.querySelector('body').appendChild(element);__cov_WuSw60ZQZcI1aW7neh6dWA.s['22']++;vm=window.vueImg=new screen().$mount('#imageScreen');}else{__cov_WuSw60ZQZcI1aW7neh6dWA.b['10'][1]++;}__cov_WuSw60ZQZcI1aW7neh6dWA.s['23']++;el.addEventListener('click',function(){__cov_WuSw60ZQZcI1aW7neh6dWA.f['3']++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['24']++;document.querySelector('body').classList.add('body-fs-v-img');__cov_WuSw60ZQZcI1aW7neh6dWA.s['25']++;var images=[].concat(toConsumableArray(document.querySelectorAll('img[data-vue-img-group="'+group+'"]')));__cov_WuSw60ZQZcI1aW7neh6dWA.s['26']++;if(images.length==0){__cov_WuSw60ZQZcI1aW7neh6dWA.b['11'][0]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['27']++;Vue.set(vm,'images',[src]);}else{__cov_WuSw60ZQZcI1aW7neh6dWA.b['11'][1]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['28']++;Vue.set(vm,'images',images.map(function(e){__cov_WuSw60ZQZcI1aW7neh6dWA.f['4']++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['29']++;return(__cov_WuSw60ZQZcI1aW7neh6dWA.b['12'][0]++,e.dataset.vueImgSrc)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['12'][1]++,e.src);}));__cov_WuSw60ZQZcI1aW7neh6dWA.s['30']++;Vue.set(vm,'currentImageIndex',images.indexOf(el));}__cov_WuSw60ZQZcI1aW7neh6dWA.s['31']++;Vue.set(vm,'closed',false);});}});};

/* harmony default export */ __webpack_exports__["a"] = (install);
//# sourceMappingURL=v-img.mjs.map


/***/ }),
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(834)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(944),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(801)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(910),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(803)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(912),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(817)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(927),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(915),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__ = __webpack_require__(8);






var IS_HTTPS = false;
var BASE_URL;
if (true) {
  IS_HTTPS = true;
  BASE_URL = '//bosshogcookoff.com/october/';
} else {
  // IS_HTTPS = false
  // BASE_URL = '//localhost:8080/october_bosshog/'
  IS_HTTPS = true;
  BASE_URL = '//bosshogcookoff.com/october/';
}

/* harmony default export */ __webpack_exports__["a"] = ({

  forceSecure: IS_HTTPS, // true = autodetect, false = always secured
  baseUrl: BASE_URL,
  getProtocol: function getProtocol() {
    var protocol = window.location.protocol;
    if (!protocol || protocol.length <= 0) {
      protocol = 'http:';
    }
    if (this.forceSecure) {
      protocol = 'https:';
    }
    return protocol;
  },


  // callback format: (result, data, error)
  post: function post(path, data, noJson) {
    var _this = this;

    // context.$http.interceptors.push(function (request, next) {
    //   request.headers.set('Access-Control-Allow-Origin', '*')
    //   next()
    // })

    __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(data, {
      client_id: 1,
      client_secret: 'n4FdG7FaF14ka2id8WySAwHTtgdAGwBQTqovmeW0'
    });

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this.getProtocol() + _this.baseUrl + path, data).then(function (response) {
        // console.log('response')
        // console.log(response)
        if (!response.data) {
          // EventBus.$emit('unauthenticated')
          // callback(false, { error: 'Invalid response', code: 400 })
          reject({ error: 'Invalid response', code: 400 });
          return;
        }

        if (noJson) {
          resolve(response.data);
          return;
        }

        // validate if proper JSON
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(response.data) !== 'object') {
          console.log(response);
          reject({ error: 'Invalid JSON data', code: 400 });
          return;
        }

        if (response.data.error) {
          reject({ error: response.data.error.msg, code: response.data.error.code });
          return;
        }

        // EventBus.$emit('authenticated', response.data)
        // callback(true)
        resolve(response.data);
      }).catch(function (error) {
        // console.log('error')
        // console.log(error)
        if (!error) {
          reject({ error: 'Blank error response', code: 400 });
          return;
        }

        // console.log(error)
        if (!error.response || !error.response.data) {
          // EventBus.$emit('unauthenticated')
          // callback(context, false, { error: 'Invalid error response', code: 400 })
          reject({ error: 'Invalid error response', code: 400 });
          return;
        }

        // validate if proper JSON
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(error.response.data) !== 'object') {
          console.error(error.response);
          reject({ error: 'Invalid JSON error', code: 400 });
          return;
        }

        if (error.response.data.code === 401) {
          __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__["a" /* default */].$emit('unauthenticated');
        }

        // EventBus.$emit('unauthenticated')
        // callback(context, false, error.response.data)
        reject(error.response.data);
      });
    });

    // context.$http.post(LOGIN_URL, creds, {
    //   headers: {
    //     // 'Access-Control-Allow-Methods': '*'
    //   }
    // }).then(data => {
    //   console.log(data)
    //   localStorage.setItem('id_token', data.id_token)
    //   localStorage.setItem('access_token', data.access_token)
    //
    //   this.user.authenticated = true
    //
    //   // Redirect to a specified route
    //   if (redirect) {
    //     console.log('redirected')
    //     // router.go(redirect)
    //   }
    // }, err => {
    //   console.log('error login')
    //   console.log(err)
    //   context.error = err
    // })
  },
  get: function get(path, params, noJson) {
    var _this2 = this;

    noJson = noJson !== undefined ? noJson : false;
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(_this2.getProtocol() + _this2.baseUrl + path, { params: params }, {
        headers: {
          'HTTP_ORIGIN': 'http://localhost:8080'
        }
      }).then(function (response) {
        // console.log('response')
        // console.log(response)
        if (!response.data) {
          // EventBus.$emit('unauthenticated')
          // callback(false, { error: 'Invalid response', code: 400 })
          reject({ error: 'Invalid response', code: 400 });
          return;
        }

        if (noJson) {
          resolve(response.data);
          return;
        }

        // validate if proper JSON
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(response.data) !== 'object') {
          reject({ error: 'Invalid JSON data', code: 400 });
          return;
        }

        if (response.data.error) {
          reject({ error: response.data.error.msg, code: response.data.error.code });
          return;
        }

        // EventBus.$emit('authenticated', response.data)
        // callback(true)
        resolve(response.data);
      }).catch(function (error) {
        // console.log('error')
        // console.log(error)
        if (!error) {
          reject({ error: 'Blank error response', code: 400 });
          return;
        }

        // console.log(error)
        if (!error.response || !error.response.data) {
          // EventBus.$emit('unauthenticated')
          // callback(context, false, { error: 'Invalid error response', code: 400 })
          reject({ error: 'Invalid error response', code: 400 });
          return;
        }

        // validate if proper JSON
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(error.response.data) !== 'object') {
          reject({ error: 'Invalid JSON error', code: 400 });
          return;
        }

        if (error.response.data.code === 401) {
          __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__["a" /* default */].$emit('unauthenticated');
        }

        // EventBus.$emit('unauthenticated')
        // callback(context, false, error.response.data)
        reject(error.response.data);
      });
    });
  }
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios_dist_axios__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios_dist_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios_dist_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_scrollto__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__controllers_ScrollSpy__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_infinite_scroll__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_multiple_back_top__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_multiple_back_top___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_multiple_back_top__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_masonry_layout_masonry__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_masonry_layout_masonry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_masonry_layout_masonry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__controllers_Masonry__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_v_img__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_buefy__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_buefy_lib_buefy_css__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_buefy_lib_buefy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_buefy_lib_buefy_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_aos__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_aos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_aos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_aos_dist_aos_css__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_aos_dist_aos_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_aos_dist_aos_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_locale_lang_en__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_material_design_icons_iconfont_material_icons_css__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_material_design_icons_iconfont_material_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_material_design_icons_iconfont_material_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_app_scss__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__styles_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__styles_app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_slick_carousel_slick_slick_css__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_slick_carousel_slick_slick_theme_css__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_slick_carousel_slick_slick_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_slick_carousel_slick_slick_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__App__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__controllers_Store__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__router__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__controllers_FBControl__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_analytics__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_youtube_embed__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_disqus_VueDisqus_vue__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_disqus_VueDisqus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vue_disqus_VueDisqus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_FormError__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_FormError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_FormError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_FormInput__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_FormInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_FormInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_SideBar__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_SideBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_SideBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_moment__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$ajax = __WEBPACK_IMPORTED_MODULE_3_axios_dist_axios___default.a;


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a);
Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype, '$lodash', { value: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a });


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a);


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_scrollto___default.a, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  cancelable: true,
  onDone: false,
  onCancel: false
});


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7__controllers_ScrollSpy__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_infinite_scroll___default.a);


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_9_vue_multiple_back_top___default.a.name, __WEBPACK_IMPORTED_MODULE_9_vue_multiple_back_top___default.a);



__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11__controllers_Masonry__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_v_img__["a" /* default */]);

// Buefy Components UI

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_buefy___default.a);



__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_aos___default.a);






__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_locale_lang_en___default.a });

// Material Design Icons


// override common styles UI


// Carousel







// FB

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_27__controllers_FBControl__["a" /* default */]);

// GA

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_28_vue_analytics___default.a, {
  id: 'UA-112311200-1',
  router: __WEBPACK_IMPORTED_MODULE_26__router__["a" /* default */]
});


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_29_vue_youtube_embed__["a" /* default */]);

// // Google Maps
// import * as VueGoogleMaps from 'vue2-google-maps'
// // const VueGoogleMaps = require('vue2-google-maps')
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyBm43-gK1svcMQ7ULIOPOCOkdv1NX77TxM',
//     libraries: 'places' // This is required if you use the Autocomplete plugin
//     // OR: libraries: 'places,drawing'
//     // OR: libraries: 'places,drawing,visualization'
//     // (as you require)
//   }
// })
// // The following components are automatically installed globally
// // If you would like to define your own component names,
// // see below
// // GmapMap
// // GmapMarker
// // GmapCluster
// // GmapInfoWindow
// // GmapPolyline
// // GmapPolygon
// // GmapCircle
// // GmapRectangle
// // GmapAutocomplete
// // GmapPlaceInput

// Disqus


// Modules




__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('form-error', __WEBPACK_IMPORTED_MODULE_31__components_FormError___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('form-input', __WEBPACK_IMPORTED_MODULE_32__components_FormInput___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('side-bar', __WEBPACK_IMPORTED_MODULE_33__components_SideBar___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('vue-disqus', __WEBPACK_IMPORTED_MODULE_30_vue_disqus_VueDisqus_vue___default.a);


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('datetime', function (value, format) {
  format = format && format.slice(1, format.length - 1);
  if (!value) {
    return '0';
  }
  value = value.replace(/\s/, 'T');
  return __WEBPACK_IMPORTED_MODULE_34_moment___default()(new Date(value)).format(format || 'h:mm A - D MMM YYYY');
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('dateonly', function (value, format) {
  format = format && format.slice(1, format.length - 1);
  if (!value) {
    return '0';
  }
  value = value.replace(/\s/, 'T');
  return __WEBPACK_IMPORTED_MODULE_34_moment___default()(new Date(value)).format(format || 'MMMM D, YYYY');
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('timeonly', function (value, format) {
  format = format && format.slice(1, format.length - 1);
  if (!value) {
    return '0';
  }
  value = value.replace(/\s/, 'T');
  return __WEBPACK_IMPORTED_MODULE_34_moment___default()(new Date(value)).format(format || 'h:mm A');
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('two_digits', function (value) {
  if (value.toString().length <= 1) {
    return '0' + value.toString();
  }
  return value.toString();
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_25__controllers_Store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_26__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_24__App___default.a
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_15_aos___default.a.init({
      duration: 1600
    });
  }
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vue-disqus',
  props: {
    shortname: {
      type: String,
      required: true
    },
    identifier: {
      type: String,
      required: false
    },
    url: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    remote_auth_s3: {
      type: String,
      required: false
    },
    api_key: {
      type: String,
      required: false
    },
    sso_config: {
      type: Object,
      required: false
    },
    language: {
      type: String,
      required: false
    }
  },
  mounted: function mounted() {
    if (window.DISQUS) {
      this.reset(window.DISQUS);
      return;
    }
    this.init();
  },

  methods: {
    reset: function reset(dsq) {
      var self = this;
      dsq.reset({
        reload: true,
        config: function config() {
          self.setBaseConfig(this);
        }
      });
    },
    init: function init() {
      var _this = this;

      var self = this;
      window.disqus_config = function () {
        self.setBaseConfig(this);
      };
      setTimeout(function () {
        var d = document,
            s = d.createElement('script');
        s.setAttribute('id', 'embed-disqus');
        s.setAttribute('data-timestamp', +new Date());
        s.type = 'text/javascript';
        s.async = true;
        s.src = '//' + _this.shortname + '.disqus.com/embed.js';(d.head || d.body).appendChild(s);
      }, 0);
    },
    setBaseConfig: function setBaseConfig(disqusConfig) {
      var _this2 = this;

      disqusConfig.page.identifier = this.identifier || this.$route.path || window.location.pathname;
      disqusConfig.page.url = this.url || this.$el.baseURI;
      if (this.title) {
        disqusConfig.page.title = this.title;
      }
      if (this.remote_auth_s3) {
        disqusConfig.page.remote_auth_s3 = this.remote_auth_s3;
      }
      if (this.api_key) {
        disqusConfig.page.api_key = this.api_key;
      }
      if (this.sso_config) {
        disqusConfig.sso = this.sso_config;
      }
      if (this.language) {
        disqusConfig.language = this.language;
      }

      disqusConfig.callbacks.onReady = [function () {
        _this2.$emit('ready');
      }];
    }
  }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'PulseLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-pulseStretchDelay',
        animationDuration: '0.75s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.12s'
      },
      spinnerDelay2: {
        animationDelay: '0.24s'
      },
      spinnerDelay3: {
        animationDelay: '0.36s'
      }
    };
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NavBarFull_vue__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NavBarFull_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_NavBarFull_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NavBarOverlay_vue__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NavBarOverlay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_NavBarOverlay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TopSection_vue__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TopSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_TopSection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Footer_vue__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_PulseLoader_vue__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_PulseLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_PulseLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_ContactSection_vue__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_ContactSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_ContactSection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_TopCountdown_vue__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_TopCountdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_TopCountdown_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(398);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default.a,
    NavbarFull: __WEBPACK_IMPORTED_MODULE_2__components_NavBarFull_vue___default.a,
    NavbarOverlay: __WEBPACK_IMPORTED_MODULE_3__components_NavBarOverlay_vue___default.a,
    TopCountdown: __WEBPACK_IMPORTED_MODULE_8__pages_TopCountdown_vue___default.a,
    TopSection: __WEBPACK_IMPORTED_MODULE_4__components_TopSection_vue___default.a,
    ContactSection: __WEBPACK_IMPORTED_MODULE_7__pages_ContactSection_vue___default.a,
    FooterMain: __WEBPACK_IMPORTED_MODULE_5__components_Footer_vue___default.a,
    PulseLoader: __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_PulseLoader_vue___default.a
  },
  data: function data() {
    return {
      isDesktop: true,
      isPrint: false,
      navLocation: __WEBPACK_IMPORTED_MODULE_9__controllers_EventBus__["a" /* default */]._data._navLocation
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])(['isAuthenticated']), {
    countdown: function countdown() {
      return __WEBPACK_IMPORTED_MODULE_9__controllers_EventBus__["a" /* default */].info.countdown;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    sample: function sample(data) {}
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapActions */])(['authenticated', 'unauthenticated'])),
  beforeCreate: function beforeCreate() {
    /* global window */
    window.onLoadCallback = function () {
      console.log('callback function here...');
    };
  },
  created: function created() {
    // console.log('created App.vue')
    // EventBus.$off('authenticated')
    // EventBus.$on('authenticated', (data) => {
    //   this.authenticated(data)
    // })
    // EventBus.$off('unauthenticated')
    // EventBus.$on('unauthenticated', () => {
    //   this.unauthenticated()
    // })

    // on master event resize (propagating to EventBus)
    __WEBPACK_IMPORTED_MODULE_9__controllers_EventBus__["a" /* default */].isDesktop = window.innerWidth >= 768;
    __WEBPACK_IMPORTED_MODULE_9__controllers_EventBus__["a" /* default */].windowWidth = window.innerWidth;
    window.addEventListener('resize', function (event) {
      __WEBPACK_IMPORTED_MODULE_9__controllers_EventBus__["a" /* default */].isDesktop = event.target.innerWidth >= 768;
      __WEBPACK_IMPORTED_MODULE_9__controllers_EventBus__["a" /* default */].windowWidth = window.innerWidth;
    });

    if (this.$route.query) {
      if (this.$route.query.print && this.$route.query.print === 'true') {
        this.isPrint = true;
      } else {
        this.isPrint = false;
      }
    } else {
      this.isPrint = false;
    }
  },
  beforeMount: function beforeMount() {
    // console.log('beforeMount App.vue')
    window.addEventListener('load', function () {});
  },
  mounted: function mounted() {}
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MainDialog',
  props: ['visible', 'no-footer'],
  data: function data() {
    return {
      isDesktop: true
    };
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));
  },

  methods: {
    onClose: function onClose() {
      this.$emit('onClose');
    }
  }
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'div-columns',
  props: ['full', 'column-num', 'padding-top', 'padding-bottom', 'background-color', 'text-align'],
  components: {},
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    refresh: function refresh() {}
  }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'div-container',
  props: ['full', 'column-num', 'padding-top', 'padding-bottom'],
  components: {},
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    refresh: function refresh() {}
  }
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivContainer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footer',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default.a
  },
  data: function data() {
    return {
      navFacebook: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navFacebook,
      navTwitter: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navTwitter,
      navInstagram: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navInstagram
      // year: new Date().getFullYear()
    };
  },

  computed: {
    year: function year() {
      return __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].info.year;
    }
  },
  methods: {
    onScrollTo: function onScrollTo(name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } });
      } else {
        this.$scrollTo('#' + target);
      }
    }
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {},
  beforeMount: function beforeMount() {},
  mounted: function mounted() {}
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lightbox__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lightbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_lightbox__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'section-sign-up-team',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default.a,
    Lightbox: __WEBPACK_IMPORTED_MODULE_4_vue_lightbox___default.a,
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha__["a" /* default */]
  },
  watch: {},
  props: ['type', 'feedback', 'loading', 'names', 'models', 'attributes', 'vuelidate', 'is-print', 'is-print-pdf'],
  data: function data() {
    return {
      isDesktop: true,
      isIE: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].detectIE(),
      items: [],
      // captcha: '', // use back model's captcha for validation
      captchaImage: undefined,
      session: '',
      recaptchaKey: '6LfeGUAUAAAAAJO6iFz_2d4E0hWiyJ7B6K7k6QsG',
      // feedback: false, // capture from external due to send function
      // loading: false,
      navEmail: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navEmail
    };
  },
  created: function created() {
    console.log('FormDynamix:created(): $v / models');
    console.log(this.vuelidate);
    console.log(this.models);
    this.init();
  },
  mounted: function mounted() {
    var _this = this;

    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    this.onRecaptcha(function (data) {
      _this.captchaImage = data.data;
      _this.session = data.id;
    });

    console.log('FormDynamix:mounted(): $v / models');
    console.log(this.vuelidate);
    console.log(this.models);
  },
  methods: {
    init: function init() {
      console.log('FormDynamix:init()');
      if (this.vuelidate) {
        if (this.vuelidate.models) {
          for (var i = 0; i < this.names.length; i++) {
            var name = this.names[i];
            if (this.vuelidate.models[name]) {
              if (!this.attributes[name]) {
                this.$set(this.attributes, name, {
                  type: 'text',
                  title: 'Invalid'
                });
              }
              if (this.attributes[name] && !this.attributes[name].type) {
                this.attributes[name].type = 'text';
              }
              // if (this.attributes[name] && !this.attributes[name].title) {
              //   this.attributes[name].title = 'Invalid'
              // }

              // text area custom type
              if (this.attributes[name] && this.attributes[name].type === 'textarea') {
                if (!this.attributes[name].hasOwnProperty('onInput')) {
                  this.attributes[name].onInput = function (model, params) {
                    if (model) {
                      params.curLength = model.length;
                    }
                  };
                }
                if (!this.attributes[name].curLength) {
                  this.attributes[name].curLength = 0;
                }
                if (!this.attributes[name].maxLength) {
                  this.attributes[name].maxLength = 500;
                }
              }

              // check box custom type
              if (this.attributes[name] && this.attributes[name].type === 'checkbox') {}

              // console.log('initializing:' + name)
              // console.log(this.attributes[name])
              this.$set(this.vuelidate.models[name], 'name', name);
              this.$set(this.vuelidate.models[name], 'attributes', this.attributes[name]);
              this.items.push(this.vuelidate.models[name]);
            }
          }
        }
      }
    },
    onRecaptcha: function onRecaptcha(onRecaptchaSuccess) {
      __WEBPACK_IMPORTED_MODULE_3__apis_Site__["a" /* default */].getRecaptcha().then(function (data) {
        // console.log('get recaptcha')
        // console.log(data)
        if (onRecaptchaSuccess) {
          onRecaptchaSuccess(data);
        }
      }).catch(function (error) {
        console.log('get recaptcha error');
        console.log(error);
      });
    },
    onRenderRecaptcha: function onRenderRecaptcha(id) {
      this.$emit('recaptcha', { status: 'init' });
    },
    onExpiredRecaptcha: function onExpiredRecaptcha() {
      this.$emit('recaptcha', { status: 'expired' });
    },
    onVerifyRecaptcha: function onVerifyRecaptcha(response) {
      console.log(response);
      if (response && response.length > 0) {
        this.$emit('recaptcha', { status: 'ok', response: response });
      }
    },
    onResetRecaptcha: function onResetRecaptcha() {
      this.$refs.recaptcha.reset();
      this.$emit('recaptcha', { status: 'reset' });
    },
    onApplicationChanged: function onApplicationChanged(applicationType) {
      console.log('application type changed: ' + applicationType);
    },
    onSend: function onSend(vuelidate) {
      vuelidate.models.$touch();
      // var _self = this
      // console.log(vuelidate)
      // console.log(this.models)
      this.$emit('send', { vuelidate: vuelidate, models: this.models, session: this.session, captcha: this.models.captcha });
    }
  }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['error'],
  computed: {
    infos: function infos() {
      var infos = [];
      for (var i = 0; i < this.error.length; i++) {
        infos.push({
          message: this.error[i]
        });
      }
      return infos;
    }
  }
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue'
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: {
      default: 'text'
    },
    name: {
      default: 'invalid'
    },
    mdi: {
      default: 'error_outline'
    },
    placeholder: {
      default: 'invalid'
    },
    value: {
      default: 'invalid'
    },
    error: {
      default: undefined
    },
    required: {
      default: true
    },
    disabled: {
      default: false
    },
    autofocus: {
      default: false
    }
  },
  data: function data() {
    return {
      model: ''
      // value: 'invalid@invalid.com'
      // name: 'invalid',
      // type: 'invalid',
      // fa: 'error',
      // placeholder: 'invalid',
      // error: undefined
    };
  },

  computed: {},
  methods: {
    onInput: function onInput(event) {
      this.model = event.target.value;
      this.$emit('onInput', { name: this.name, value: this.model });
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  watch: {
    value: function value(val, old) {
      // to tally with external value
      this.model = this.value;

      // do not echo back!
      // this.$emit('onInput', { name: this.name, value: val })
    },
    model: function model(val, old) {
      // do not echo back!
      // this.$emit('onInput', { name: this.name, value: val })
    }
  }
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MainDialog',
  props: ['visible'],
  data: function data() {
    return {
      isDesktop: true
    };
  },

  computed: {
    year: function year() {
      return __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].info.year;
    },
    date: function date() {
      return __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].info.date;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));
  },

  methods: {
    onClose: function onClose() {
      this.$emit('onClose');
    }
  }
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_Site__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import Instafetch from '@/controllers/Instafetch'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'masonry-youtube',
  components: {},
  data: function data() {
    return {
      isDesktop: true,
      itemsCache: [],
      items: [],
      itemsLoading: false,
      itemsEnded: false,
      itemsHasNext: false,
      itemsHasNextToken: undefined,
      itemsMax: 48,
      error: undefined,
      navYoutube: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navYoutube
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    // refresh masonry
    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    parseInstagramImageLink: function parseInstagramImageLink(link) {
      var linkOut = link.replace(/(https*:\/\/.*\/.*)\/.*\/.*\/.*(\/.*)/g, '$1$2');
      return linkOut;
    },

    getItems: function getItems(onComplete) {
      var _this = this;

      this.itemsLoading = true;
      this.error = undefined;
      // Youtube.authenticate({
      //   type: 'key',
      //   key: 'AIzaSyBm43-gK1svcMQ7ULIOPOCOkdv1NX77TxM'
      // })
      // var params = {
      //   term: 'search',
      //   part: 'snippet',
      //   channelId: 'UCLXo7UDZvByw2ixzpQCufnA',
      //   order: 'date',
      //   type: 'video',
      //   videoSyndicated: true,
      //   maxResults: 50,
      //   key: 'AIzaSyBm43-gK1svcMQ7ULIOPOCOkdv1NX77TxM'
      // }
      // apis.get('https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UCLXo7UDZvByw2ixzpQCufnA&order=date&type=video&videoSyndicated=true&maxResults=50&key=AIzaSyBm43-gK1svcMQ7ULIOPOCOkdv1NX77TxM')
      var params = {
        term: 'playlistItems',
        part: 'snippet',
        playlistId: 'UUy4ssRxw_k0XdiH31OxVHmA',
        maxResults: 12,
        key: 'AIzaSyB0p_sU61SfOC0Pe2-I-gBZl8ebk6xaeJw'
      };
      __WEBPACK_IMPORTED_MODULE_1__apis_Site__["a" /* default */].youtube(params.term, params).then(function (data) {
        // console.log('Youtube Response')
        // console.log(data)
        _this.itemsHasNext = false;
        _this.itemsHasNextToken = undefined;
        onComplete(data.items);
        _this.itemsEnded = true;
        _this.$emit('onItemsEnded', {});
        _this.itemsLoading = false;
      }).catch(function (error) {
        console.log('Youtube Error');
        console.log(error);
        _this.itemsHasNext = false;
        _this.itemsHasNextToken = undefined;
        _this.items = [];
        _this.error = error.error;
        _this.error = 'Unable to load, please kindly visit our Youtube account <a href="' + _this.navYoutube.path + '" target="_blank">here</a>.';
        _this.itemsEnded = true;
        _this.$emit('onItemsEnded', {});
        _this.itemsLoading = false;
      });
    },
    refresh: function refresh() {
      var _this2 = this;

      this.getItems(function (items) {
        _this2.items = items;
      });
    },
    loadMore: function loadMore() {
      // return if exceed (showcase purpose)
      // if (!this.itemsHasNext) {
      //   this.itemsEnded = true
      //   this.$emit('onItemsEnded', {})
      //   return
      // }
      //
      // if (!this.itemsEnded) {
      //   this.getItems(function (items) {
      //     this.items = this.items.concat(items)
      //     if (this.items.length > this.itemsMax) {
      //       this.items = this.items.slice(0, this.itemsMax)
      //       this.itemsEnded = true
      //       this.$emit('onItemsEnded', {})
      //     }
      //   }.bind(this))
      // }
    }
  }
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivContainer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navbarfull',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default.a
  },
  props: ['toggle'],
  data: function data() {
    return {
      showNav: false,
      navMain: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navMain,
      navSocial: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navSocial,
      navEmail: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navEmail
    };
  },

  computed: {},
  watch: {
    toggle: function toggle(val) {
      this.showNav = val;
    },
    '$route.name': function $routeName(val) {
      // only do this when overlay mode and route change
      if (this.showNav) {
        this.onToggle();
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    onScrollTo: function onScrollTo($event, name, target) {
      $event.preventDefault();
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } });
      } else {
        this.$scrollTo('#' + target, { offset: -30 });
      }
    },

    onToggle: function onToggle() {
      this.showNav = !this.showNav;
      var className = 'modal-open';
      var root = document.documentElement;
      root.className = '';
      if (this.showNav) {
        root.className += className;
      } else {
        root.className -= className;
      }
      this.$emit('onToggle', this.showNav);
    }
  }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavBarFull_vue__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavBarFull_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__NavBarFull_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'topsection',
  components: {
    'NavbarFull': __WEBPACK_IMPORTED_MODULE_1__NavBarFull_vue___default.a
  },
  data: function data() {
    return {
      toggle: false,
      navMain: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navMain,
      navSocial: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navSocial,
      navEmail: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navEmail
    };
  },

  watch: {
    toggle: function toggle(val) {
      // console.log('toggle changed to: ' + val)
    }
  },
  methods: {
    onScrollTo: function onScrollTo($event, name, target) {
      $event.preventDefault();
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } });
      } else {
        this.toggle = !this.toggle;
        var root = document.documentElement;
        root.className = '';

        // this.$scrollTo(el)
        this.$scrollTo('#' + target, { offset: -50 });
      }
    }
  }
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_DivContainer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-header',
  props: ['title'],
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_0__components_DivContainer___default.a
  },
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    refresh: function refresh() {}
  }
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_DivContainer__);
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-subheader',
  props: ['title', 'text-align', 'title-style'],
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_0__components_DivContainer___default.a
  },
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    refresh: function refresh() {}
  }
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_DivContainer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import EventBus from '@/controllers/EventBus'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-subtab',
  props: ['full', 'column-num', 'is-print', 'title-infos', 'selected-index'],
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_0__components_DivContainer___default.a
  },
  watch: {
    selectedIndex: function selectedIndex(value, oldValue) {
      // change externally
      this.currentIndex = value;
    }
  },
  data: function data() {
    return {
      // selectedIndex: 0
      currentIndex: 0
    };
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {
    // initial value
    this.currentIndex = this.selectedIndex;
  },

  methods: {
    refresh: function refresh() {},

    onClickTitle: function onClickTitle($event, title, index, isfull, disabledText) {
      $event.preventDefault();
      // this.selectedIndex = index
      if (isfull) {
        var titleInfos = this.titleInfos;
        var titleInfo = titleInfos[index];
        var id = titleInfo.id;
        if (id === 'sign-up-team') {
          // alert(`We are sorry, team application is not open yet.`)
          alert('We are sorry, ' + (disabledText && disabledText.toLowerCase()) + '.');
        } else if (id === 'sign-up-judge') {
          // alert(`We are sorry, all judging spots are full for ${EventBus.info.year}.`)
          alert('We are sorry, ' + (disabledText && disabledText.toLowerCase()) + '.');
        } else {
          alert('invalid tab.');
        }
      } else {
        this.currentIndex = index;
        this.$emit('title-changed', title);
      }
    }
  }
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'lodash'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidebar',
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.activeLink = to.path;
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.activeLink = to.path;
    next();
  },

  // mounted () {
  //   console.log('Component mounted.')
  //   let match = _.chain(this.$route.matched).sortBy(n => n.path.length).last().value()
  //   this.activeLink = match.path
  // },
  data: function data() {
    return {
      activeLink: null
    };
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slick__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lightbox__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lightbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_lightbox__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'landing',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_2__components_DivContainer___default.a,
    Slick: __WEBPACK_IMPORTED_MODULE_3_vue_slick__["a" /* default */],
    Lightbox: __WEBPACK_IMPORTED_MODULE_4_vue_lightbox___default.a
  },
  data: function data() {
    return {
      isDesktop: true,
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        fade: true,
        speed: 1000,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        pauseOnFocus: false,
        pauseOnDotsHover: false,
        focusOnSelect: false,
        responsive: [{
          breakpoint: 1008,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        }, {
          // 768 = tablet (not break yet)
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true
          }
        }]
      },
      items: [],
      itemsEnded: false,
      error: undefined,
      loading: true,
      scrollPos: 0
    };
  },

  computed: {
    // isDesktop: function () {
    //   return EventBus.isDesktop
    // }
  },
  watch: {},
  created: function created() {
    // console.log('created TopSection.vue')
  },
  mounted: function mounted() {
    // console.log('mounted TopSection.vue')
    // window.GA('send', 'pageview')

    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    next: function next() {
      if (this.$refs.slick) {
        this.$refs.slick.next();
      }
    },
    prev: function prev() {
      if (this.$refs.slick) {
        this.$refs.slick.prev();
      }
    },
    reInit: function reInit() {
      if (this.$refs.slick) {
        this.$refs.slick.reSlick();
      }
    },

    getItems: function getItems(onComplete) {
      var _this = this;

      this.loading = true;
      this.error = undefined;
      __WEBPACK_IMPORTED_MODULE_1__apis_Site__["a" /* default */].carousel().then(function (data) {
        // console.log(data)
        onComplete(data);
        _this.$nextTick(function () {
          this.reInit();
        });
        _this.reInit();
        _this.loading = false;
      }).catch(function (error) {
        _this.error = error;
        _this.error = 'Unable to load, please kindly refresh the page.';
        _this.loading = false;
      });
    },
    refresh: function refresh() {
      var _this2 = this;

      this.getItems(function (items) {
        _this2.items = items;
      });
    },
    renderYtSubscribeButton: function renderYtSubscribeButton(channel) {
      /* global gapi */
      var container = document.getElementById('yt-button-container-render');
      var options = {
        'channel': channel,
        'layout': 'full'
      };
      gapi.ytsubscribe.render(container, options);
    }
  }
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slick__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lightbox__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lightbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_lightbox__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'top-subpage-section',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_2__components_DivContainer___default.a,
    Slick: __WEBPACK_IMPORTED_MODULE_3_vue_slick__["a" /* default */],
    Lightbox: __WEBPACK_IMPORTED_MODULE_4_vue_lightbox___default.a
  },
  data: function data() {
    return {
      isDesktop: true,
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        fade: true,
        speed: 1000,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        pauseOnFocus: false,
        pauseOnDotsHover: false,
        focusOnSelect: false,
        responsive: [{
          breakpoint: 1008,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        }, {
          // 768 = tablet (not break yet)
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true
          }
        }]
      },
      items: [],
      itemsEnded: false,
      error: undefined,
      loading: true,
      scrollPos: 0
    };
  },

  computed: {
    // isDesktop: function () {
    //   return EventBus.isDesktop
    // }
  },
  watch: {},
  created: function created() {
    // console.log('created TopSection.vue')
  },
  mounted: function mounted() {
    // console.log('mounted TopSection.vue')
    // window.GA('send', 'pageview')

    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    next: function next() {
      if (this.$refs.slick) {
        this.$refs.slick.next();
      }
    },
    prev: function prev() {
      if (this.$refs.slick) {
        this.$refs.slick.prev();
      }
    },
    reInit: function reInit() {
      if (this.$refs.slick) {
        this.$refs.slick.reSlick();
      }
    },

    getItems: function getItems(onComplete) {
      var _this = this;

      this.loading = true;
      this.error = undefined;
      var name = this.$route.name;
      if (name === 'teams') {
        name = 'info';
      } else if (name === 'about') {
        name = 'info';
      }
      __WEBPACK_IMPORTED_MODULE_1__apis_Site__["a" /* default */].carouselSubpage(name).then(function (data) {
        // console.log(data)

        // fallback to subpage default
        if (!data || data.length <= 0) {
          __WEBPACK_IMPORTED_MODULE_1__apis_Site__["a" /* default */].carouselSubpage('subpage').then(function (data) {
            onComplete(data);
            _this.$nextTick(function () {
              this.reInit();
            });
            _this.reInit();
            _this.loading = false;
          }).catch(function (error) {
            _this.error = error;
            _this.error = 'Unable to load, please kindly refresh the page.';
            _this.loading = false;
          });
          return;
        }

        onComplete(data);
        _this.$nextTick(function () {
          this.reInit();
        });
        _this.reInit();
        _this.loading = false;
      }).catch(function (error) {
        _this.error = error;
        _this.error = 'Unable to load, please kindly refresh the page.';
        _this.loading = false;
      });
    },
    refresh: function refresh() {
      var _this2 = this;

      this.getItems(function (items) {
        _this2.items = items;
      });
    },
    renderYtSubscribeButton: function renderYtSubscribeButton(channel) {
      /* global gapi */
      var container = document.getElementById('yt-button-container-render');
      var options = {
        'channel': channel,
        'layout': 'full'
      };
      gapi.ytsubscribe.render(container, options);
    }
  }
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageSubheader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PageSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TopSubpageSection__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TopSubpageSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_TopSubpageSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AboutSubSection__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AboutSubSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AboutSubSection__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default.a,
    PageHeader: __WEBPACK_IMPORTED_MODULE_2__components_PageHeader___default.a,
    PageSubheader: __WEBPACK_IMPORTED_MODULE_3__components_PageSubheader___default.a,
    TopSubpageSection: __WEBPACK_IMPORTED_MODULE_4__components_TopSubpageSection___default.a,
    AboutSubSection: __WEBPACK_IMPORTED_MODULE_5__AboutSubSection___default.a
  },
  data: function data() {
    return {
      isDesktop: true,
      // itemsEnded: false,
      scrollPos: 0
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    if (this.$route.query && this.$route.query.anchor) {
      console.log('automatic scroll to...: ' + this.$route.query.anchor);
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor);
      }.bind(this), 2000);
    }

    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));
  },

  methods: {
    onScrollTo: function onScrollTo(name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } });
      } else {
        this.$scrollTo('#' + target, { offset: -30 });
      }
    }
  }
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DivColumns__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DivColumns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_DivColumns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PageSubheader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PageSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_PageSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_showdown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_showdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_showdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_showdown_target_blank__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_showdown_target_blank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_showdown_target_blank__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'section-prize-awards-sub-about',
  props: ['name-like', 'is-alt'],
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_5__components_DivContainer___default.a,
    DivColumns: __WEBPACK_IMPORTED_MODULE_6__components_DivColumns___default.a,
    PageSubheader: __WEBPACK_IMPORTED_MODULE_7__components_PageSubheader___default.a
  },
  data: function data() {
    return {
      items: {},
      maxItems: 10,
      imageUrl: undefined,
      error: undefined,
      loading: false
    };
  },

  computed: {},
  watch: {},
  created: function created() {
    var nameLike = this.nameLike;
    for (var i = 1; i <= this.maxItems; i++) {
      var name = nameLike + '-' + i;
      // var name = this.names[i]
      this.$set(this.items, name, { loading: true });
    }
  },
  mounted: function mounted() {
    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    getItems: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(name) {
        var data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loading = true;
                this.error = undefined;
                _context.prev = 2;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4__apis_Site__["a" /* default */].aboutWithName(name);

              case 5:
                data = _context.sent;

                this.loading = false;
                // console.log(data)

                if (!(!data || !data.content)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt('return');

              case 9:

                this.onComplete(name, data);
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](2);

                this.loading = false;
                // this.error = 'Unable to load, please kindly refresh the page.'
                // console.log(error)

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 12]]);
      }));

      function getItems(_x) {
        return _ref.apply(this, arguments);
      }

      return getItems;
    }(),

    refresh: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var promises, promise, keys, i;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                promises = [];
                promise = void 0;
                keys = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.keys(this.items);

                for (i = 0; i < keys.length; i++) {
                  promise = this.getItems(keys[i]);
                  promises.push(promise);
                }
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function refresh() {
        return _ref2.apply(this, arguments);
      }

      return refresh;
    }(),

    onComplete: function onComplete(name, data) {
      var converter = new __WEBPACK_IMPORTED_MODULE_8_showdown___default.a.Converter({ extension: ['targetblank'] });
      var html = converter.makeHtml(data.content);
      this.$set(this.items, name, {
        loading: false,
        content: html,
        title: data.title,
        imageUrl: data.image ? data.image.path : undefined
      });
    }
  }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DivColumns__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DivColumns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_DivColumns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PageSubheader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PageSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_PageSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_showdown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_showdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_showdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_showdown_target_blank__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_showdown_target_blank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_showdown_target_blank__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'section-prize-sub-about',
  props: ['name', 'is-alt'],
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_2__components_DivContainer___default.a,
    DivColumns: __WEBPACK_IMPORTED_MODULE_3__components_DivColumns___default.a,
    PageSubheader: __WEBPACK_IMPORTED_MODULE_4__components_PageSubheader___default.a
  },
  data: function data() {
    return {
      isDesktop: true,
      paragraph: {
        title: '',
        content: ''
      },
      imageUrl: undefined,
      error: undefined,
      loading: false
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_1__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_1__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_1__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    getItems: function getItems(onComplete) {
      var _this = this;

      this.loading = true;
      this.error = undefined;
      this.imageUrl = undefined;
      this.paragraph.content = '';
      this.paragraph.title = '';
      __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].aboutWithName(this.name).then(function (data) {
        _this.loading = false;
        // console.log(data)
        if (!data || !data.content) {
          _this.error = 'Unable to load, please kindly refresh the page.';
          return;
        }

        var converter = new __WEBPACK_IMPORTED_MODULE_5_showdown___default.a.Converter({ extension: ['targetblank'] });
        var html = converter.makeHtml(data.content);
        _this.paragraph.content = html;
        _this.paragraph.title = data.title;
        _this.imageUrl = data.image ? data.image.path : undefined;

        if (onComplete) {
          onComplete(data);
        }
      }).catch(function (error) {
        _this.loading = false;
        _this.error = 'Unable to load, please kindly refresh the page.';
        console.log(error);
      });
    },

    refresh: function refresh() {
      this.getItems(function (item) {
        // this.item = item
      });
    }
  }
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_showdown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_showdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_showdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_aplayer__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_aplayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_aplayer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import RadioFile from '@/assets/radio-2019.mp3'
// import RadioFile from '@/assets/radio-2021.mp3'
// import RadioFile from '@/assets/radio-2022.mp3'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default.a,
    VueAplayer: __WEBPACK_IMPORTED_MODULE_3_vue_aplayer___default.a
  },
  data: function data() {
    return {
      paragraph: {
        title: '',
        content: ''
      },
      music: undefined,
      imageUrl: undefined,
      error: undefined,
      loading: false,
      disabled: true
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    getItems: function getItems(onComplete) {
      var _this = this;

      this.loading = true;
      this.error = undefined;
      this.paragraph.content = '';
      this.paragraph.title = '';
      __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].aboutWithName('bosshog::about-main').then(function (data) {
        _this.loading = false;
        // console.log(data)
        if (!data || !data.content) {
          _this.error = 'Unable to load, please kindly refresh the page.';
          return;
        }

        var converter = new __WEBPACK_IMPORTED_MODULE_2_showdown___default.a.Converter();
        var html = converter.makeHtml(data.content);
        _this.paragraph.content = html;
        _this.paragraph.title = data.title;
        _this.imageUrl = data.image.path;

        var element = document.getElementById('aplayer');
        if (data.file && data.file.path) {
          _this.music = {
            element: element,
            narrow: true,
            autoplay: false,
            mode: 'single',
            title: 'Boss Hog Radio',
            author: 'Boss Hog Cook-Off',
            url: data.file.path,
            pic: _this.imageUrl,
            lrc: '[00:00.00]lrc here\n[00:01.00]aplayer'
          };
        } else {
          _this.music = undefined;
        }
        _this.disabled = data.disabled;
        _this.$nextTick(function () {
          this.music.autoplay = false;
          // console.log('-- $refs')
          // console.log(this.$refs.aplayer)
          if (this.$refs.aplayer) {
            // var player = this.$refs.aplayer
            // player.$set('mode', 'single')
            // if (player.control) {
            //   player.control.mode = 'single'
            // }
            // player.play()
          }
        });

        if (onComplete) {
          onComplete(data);
        }
      }).catch(function (error) {
        _this.loading = false;
        _this.error = 'Unable to load, please kindly refresh the page.';
        console.log(error);
      });
    },
    refresh: function refresh() {
      this.getItems(function (item) {
        // this.item = item
      });
    }
  }
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivColumns__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivColumns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DivColumns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageSubheader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PageSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_showdown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_showdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_showdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_showdown_target_blank__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_showdown_target_blank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_showdown_target_blank__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import EventBus from '@/controllers/EventBus'







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sub-about',
  props: ['name'],
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default.a,
    DivColumns: __WEBPACK_IMPORTED_MODULE_2__components_DivColumns___default.a,
    PageSubheader: __WEBPACK_IMPORTED_MODULE_3__components_PageSubheader___default.a
  },
  data: function data() {
    return {
      paragraph1: {
        title: '',
        content: ''
      },
      paragraph2: {
        title: '',
        content: ''
      },
      defaultDisabledText: '...',
      teamDisabledText: '',
      judgeDisabledText: '',
      imageUrl: undefined,
      error: undefined,
      loading: false,
      isSignUpTeam: false,
      isSignUpTeamUi: true,
      isSignUpJudge: false,
      isSignUpJudgeUi: true
    };
  },

  computed: {
    // isSignUp: function () {
    //   return EventBus.isSignUp()
    // }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    getItems: function getItems() {
      var _this = this;

      this.loading = true;
      this.error = undefined;
      this.imageUrl = undefined;
      this.paragraph1.content = '';
      this.paragraph1.title = '';

      this.isSignUpTeam = false;
      this.isSignUpTeamUi = true;
      this.isSignUpJudge = false;
      this.isSignUpJudgeUi = true;
      this.teamDisabledText = this.defaultDisabledText;
      this.judgeDisabledText = this.defaultDisabledText;

      __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].aboutWithName('bosshog::about-sign-up').then(function (data) {
        _this.loading = false;
        // console.log(data)
        if (!data || !data.content) {
          _this.error = 'Unable to load, please kindly refresh the page.';
          return;
        }

        var converter = new __WEBPACK_IMPORTED_MODULE_4_showdown___default.a.Converter({ extension: ['targetblank'] });
        var html = converter.makeHtml(data.content);
        _this.paragraph1.content = html;
        _this.paragraph1.title = data.title;
        _this.imageUrl = data.image ? data.image.path : undefined;

        return __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].aboutWithName('bosshog::about-sign-up-rules');
      }).then(function (data) {
        _this.loading = false;
        // console.log(data)
        if (!data || !data.content) {
          _this.error = 'Unable to load, please kindly refresh the page.';
          return;
        }

        var converter = new __WEBPACK_IMPORTED_MODULE_4_showdown___default.a.Converter({ extension: ['targetblank'] });
        var html = converter.makeHtml(data.content);
        _this.paragraph2.content = html.replace('><strong>here</strong>', ' target=&quot;_blank&quot;><strong>here</strong>');
        _this.paragraph2.title = data.title;
        _this.imageUrl = data.image ? data.image.path : undefined;

        return __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].aboutWithName('bosshog::about-sign-up-rules');
      }).then(function (data) {
        return __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].aboutWithName('bosshog::signup-team');
      }).then(function (data) {
        if (data && data.hasOwnProperty('disabled')) {
          _this.isSignUpTeam = !data.disabled;
          _this.isSignUpTeamUi = data.disabled_ui;
          _this.teamDisabledText = data.content || _this.defaultDisabledText;
        }
        return __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].aboutWithName('bosshog::signup-judge');
      }).then(function (data) {
        if (data && data.hasOwnProperty('disabled')) {
          _this.isSignUpJudge = !data.disabled;
          _this.isSignUpJudgeUi = data.disabled_ui;
          _this.judgeDisabledText = data.content || _this.defaultDisabledText;
        }
      }).catch(function (error) {
        _this.loading = false;
        _this.error = 'Unable to load, please kindly refresh the page.';
        console.log(error);
      });
    },

    refresh: function refresh() {
      this.getItems();
    }
  }
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivColumns__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivColumns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DivColumns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageSubheader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PageSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_showdown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_showdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_showdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_showdown_target_blank__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_showdown_target_blank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_showdown_target_blank__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sub-about',
  props: ['name', 'is-alt'],
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default.a,
    DivColumns: __WEBPACK_IMPORTED_MODULE_2__components_DivColumns___default.a,
    PageSubheader: __WEBPACK_IMPORTED_MODULE_3__components_PageSubheader___default.a
  },
  data: function data() {
    return {
      paragraph: {
        title: '',
        content: ''
      },
      imageUrl: undefined,
      imageLink: undefined,
      error: undefined,
      loading: false
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    getItems: function getItems(onComplete) {
      var _this = this;

      this.loading = true;
      this.error = undefined;
      this.imageUrl = undefined;
      this.imageLink = undefined;
      this.paragraph.content = '';
      this.paragraph.title = '';
      __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].aboutWithName(this.name).then(function (data) {
        _this.loading = false;
        // console.log(data)
        if (!data || !data.content) {
          _this.error = 'Unable to load, please kindly refresh the page.';
          return;
        }

        var converter = new __WEBPACK_IMPORTED_MODULE_4_showdown___default.a.Converter({ extension: ['targetblank'] });
        var html = converter.makeHtml(data.content);
        _this.paragraph.content = html;
        _this.paragraph.title = data.title;
        _this.imageUrl = data.image ? data.image.path : undefined;
        _this.imageLink = data.link ? data.link : undefined;

        if (onComplete) {
          onComplete(data);
        }
      }).catch(function (error) {
        _this.loading = false;
        _this.error = 'Unable to load, please kindly refresh the page.';
        console.log(error);
      });
    },

    refresh: function refresh() {
      this.getItems(function (item) {
        // this.item = item
      });
    }
  }
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivColumns__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivColumns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DivColumns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_recaptcha__ = __webpack_require__(395);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contactsection',
  mixins: [__WEBPACK_IMPORTED_MODULE_3_vuelidate__["validationMixin"]],
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default.a,
    DivColumns: __WEBPACK_IMPORTED_MODULE_2__components_DivColumns___default.a,
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_6_vue_recaptcha__["a" /* default */]
  },
  data: function data() {
    return {
      isDesktop: true,
      name: '',
      email: '',
      message: '',
      // captcha: '',
      // session: '',
      // captchaImage: undefined,
      recaptcha: undefined,
      recaptchaKey: '6LfeGUAUAAAAAJO6iFz_2d4E0hWiyJ7B6K7k6QsG',
      feedback: false,
      loading: false,
      navEmail: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navEmail
    };
  },
  mounted: function mounted() {
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    // this.onRecaptcha(data => {
    //   // console.log('recaptcha data!')
    //   this.captchaImage = data.data
    //   this.session = data.id
    // })
  },
  methods: {
    // onRecaptcha: function (onRecaptchaSuccess) {
    //   Site.getRecaptcha()
    //   .then(data => {
    //     // console.log('get recaptcha')
    //     // console.log(data)
    //     if (onRecaptchaSuccess) {
    //       onRecaptchaSuccess(data)
    //     }
    //   })
    //   .catch(error => {
    //     console.log('get recaptcha error')
    //     console.log(error)
    //   })
    // },
    onRenderRecaptcha: function onRenderRecaptcha(id) {
      this.recaptcha = undefined;
    },
    onExpiredRecaptcha: function onExpiredRecaptcha() {
      this.recaptcha = undefined;
    },
    onVerifyRecaptcha: function onVerifyRecaptcha(response) {
      if (response && response.length > 0) {
        this.recaptcha = response;
      }
    },
    onResetRecaptcha: function onResetRecaptcha() {
      this.$refs.recaptcha.reset();
      this.recaptcha = undefined;
    },
    onSend: function onSend($v) {
      var _self = this;
      if ($v.$invalid) {
        _self.feedback = 'Please fill in all fields to proceed.';
        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Please fill in all fields to proceed.',
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
      } else {
        _self.feedback = false;
        _self.loading = true;
        __WEBPACK_IMPORTED_MODULE_5__apis_Site__["a" /* default */].email(_self.recaptcha, _self.name, _self.email, _self.message
        // _self.captcha,
        // _self.session,
        ).then(function (data) {
          _self.loading = false;

          // invalid captcha
          if (data && data.status === 'invalid_session') {
            _self.feedback = 'Invalid session, please kindly refresh and try again.';
            return;
          }

          // invalid captcha
          if (data && data.status === 'invalid_captcha') {
            _self.feedback = 'Invalid captcha, please re-type again.';
            return;
          }

          if (data && data.status !== 'ok') {
            _self.feedback = 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail;
            return;
          }

          _self.name = '';
          _self.email = '';
          _self.message = '';
          // _self.captcha = ''
          // _self.session = '' // open up to maintain session
          // _self.$toast.open({
          //   message: 'We will be contacting you via email or phone. Thanks!',
          //   position: 'is-bottom',
          //   type: 'is-success'
          // })
          _self.feedback = 'Thank you for reaching out to The Boss. Someone will get back to you shortly.';
        }).catch(function (error) {
          console.log('invalid email', error);
          // this.error = error.error
          console.log(error);
          // _self.captcha = ''

          // invalid captcha
          if (error && error.status === 'invalid_session') {
            _self.feedback = 'Invalid session, please kindly refresh and try again.';
            _self.loading = false;
            return;
          }

          // invalid captcha
          if (error && error.status === 'invalid_captcha') {
            _self.feedback = 'Invalid captcha, please retype again.';
            _self.loading = false;
            return;
          }

          // _self.$toast.open({
          //   duration: 5000,
          //   message: 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail,
          //   position: 'is-bottom',
          //   type: 'is-warning'
          // })
          _self.feedback = 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail;
          _self.loading = false;
        });
      }
    }
  },
  validations: {
    email: {
      required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
      email: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["email"]
    },
    name: {
      required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
    },
    message: {
      required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
    },
    recaptcha: {
      required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
    }
  }
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageSubheader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_showdown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_showdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_showdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_showdown_target_blank__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_showdown_target_blank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_showdown_target_blank__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Site from '@/apis/Site'





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sub-event',
  props: ['slug', 'title', 'item'],
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_0__components_DivContainer___default.a,
    PageSubheader: __WEBPACK_IMPORTED_MODULE_1__components_PageSubheader___default.a
  },
  data: function data() {
    return {
      paragraph: {
        title: '',
        content: ''
      },
      imageUrl: undefined,
      error: undefined,
      loading: false
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    getItems: function getItems(onComplete) {
      // this.loading = true
      // this.error = undefined
      // this.imageUrl = undefined
      // this.paragraph.content = ''
      // this.paragraph.title = ''
      // Site.eventWithSlug(this.slug)
      // .then((data) => {
      //   this.loading = false
      //   // console.log(data)
      //   if (!data || !data.content) {
      //     this.error = 'Unable to load, please kindly refresh the page.'
      //     return
      //   }
      //
      //   var converter = new ShowDown.Converter({ extension: ['targetblank'] })
      //   var html = converter.makeHtml(data.content)
      //   this.paragraph.content = html
      //   this.paragraph.title = data.title
      //   this.imageUrl = data.image.path
      //
      //   if (onComplete) {
      //     onComplete(data)
      //   }
      // })
      // .catch((error) => {
      //   this.loading = false
      //   this.error = 'Unable to load, please kindly refresh the page.'
      //   console.log(error)
      // })
    },

    refresh: function refresh() {
      // this.getItems((item) => {
      //   this.item = item
      // })

      var converter = new __WEBPACK_IMPORTED_MODULE_2_showdown___default.a.Converter({ extension: ['targetblank'] });
      var html = converter.makeHtml(this.item.description);
      this.paragraph.content = html;
      this.paragraph.title = this.item.title;
      this.imageUrl = this.item.image.path;
    }
  }
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivContainer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import ShowDown from 'showdown'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'section-hotlink',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default.a
  },
  data: function data() {
    return {
      items: [],
      error: undefined,
      loading: false
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    getItems: function getItems(onComplete) {
      var _this = this;

      this.loading = true;
      this.error = undefined;
      this.items = [];
      __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].hotlink().then(function (data) {
        _this.loading = false;

        if (!data) {
          _this.error = 'Unable to load, please kindly refresh the page.';
          return;
        }

        if (onComplete) {
          onComplete(data);
        }
      }).catch(function (error) {
        _this.loading = false;
        _this.error = 'Unable to load, please kindly refresh the page.';
        console.error(error);
      });
    },
    refresh: function refresh() {
      var _this2 = this;

      this.getItems(function (items) {
        _this2.items = items;
      });
    }
  }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageSubheader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PageSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TopSubpageSection__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TopSubpageSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_TopSubpageSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AboutSubSection__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AboutSubSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AboutSubSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AboutSignUpSubSection__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AboutSignUpSubSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AboutSignUpSubSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AboutPrizeSubSection__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AboutPrizeSubSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__AboutPrizeSubSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AboutPrizeAwardsSubSection__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AboutPrizeAwardsSubSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__AboutPrizeAwardsSubSection__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










// import TeamsSubSection from '@/components/TeamsSubSection'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-info',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default.a,
    PageHeader: __WEBPACK_IMPORTED_MODULE_2__components_PageHeader___default.a,
    PageSubheader: __WEBPACK_IMPORTED_MODULE_3__components_PageSubheader___default.a,
    TopSubpageSection: __WEBPACK_IMPORTED_MODULE_4__components_TopSubpageSection___default.a,
    AboutSubSection: __WEBPACK_IMPORTED_MODULE_5__AboutSubSection___default.a,
    AboutSignUpSubSection: __WEBPACK_IMPORTED_MODULE_6__AboutSignUpSubSection___default.a,
    AboutPrizeSubSection: __WEBPACK_IMPORTED_MODULE_7__AboutPrizeSubSection___default.a,
    AboutPrizeAwardsSubSection: __WEBPACK_IMPORTED_MODULE_8__AboutPrizeAwardsSubSection___default.a
    // TeamsSubSection
  },
  data: function data() {
    return {
      isDesktop: true,
      // itemsEnded: false,
      scrollPos: 0
    };
  },

  computed: {
    year: function year() {
      return __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].info.year;
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    if (this.$route.query && this.$route.query.anchor) {
      console.log('automatic scroll to...: ' + this.$route.query.anchor);
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor);
      }.bind(this), 1000);
    }

    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));
  },

  methods: {
    onScrollTo: function onScrollTo(name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } });
      } else {
        this.$scrollTo('#' + target, { offset: 0 });
      }
    }
  }
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DivColumns__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DivColumns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_DivColumns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PageSubheader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PageSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_PageSubheader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import Instafetch from '@/controllers/Instafetch'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'masonry-instagram',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_2__components_DivContainer___default.a,
    DivColumns: __WEBPACK_IMPORTED_MODULE_3__components_DivColumns___default.a,
    PageSubheader: __WEBPACK_IMPORTED_MODULE_4__components_PageSubheader___default.a
  },
  props: ['id'],
  data: function data() {
    return {
      isDesktop: true,
      isIE: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].detectIE(),
      styleIE: {},
      itemsCache: [],
      items: [],
      itemsLoading: true,
      itemsEnded: false,
      itemsHasNext: false,
      itemsHasNextToken: undefined,
      itemsMax: 9,
      error: undefined,
      navInstagram: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navInstagram,
      navInstagramHashtag: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navInstagramHashtag
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    // refresh masonry
    this.refresh();

    // var callbackInstagram = function (data) {
    //   console.log(data)
    // }
    // var fetcher = new Instafetch('15794449.23ef492.b92d5f8be35a469ebfaeceb6b259b3d7')
    // // var fetcher = new Instafetch('23ef492f142645d7892ae61d3697f3a6')
    // fetcher.fetch({
    //   // user: 15794449,
    //   tag: 'adamlobotv',
    //   limit: 88,
    //   callback: callbackInstagram
    //   // params: '9gagBlock'
    // })

    // fix for IE where images are not displayed
    if (this.isIE) {
      var minHeight = '300px';
      if (!this.isDesktop) {
        minHeight = '150px';
      }
      this.styleIE = {
        minHeight: minHeight
      };
    }
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    parseInstagramImageLink: function parseInstagramImageLink(link) {
      var linkOut = link.replace(/(https*:\/\/.*\/.*)\/.*\/.*\/.*(\/.*)/g, '$1$2');
      return linkOut;
    },

    getItems: function getItems(onComplete) {
      var _this = this;

      this.itemsLoading = true;

      // if (this.id && this.id === 'photos-official') {
      // Site.instagramUser('1766012752.1677ed0.e930de6bc89c44b494d75da69dca6a3a', this.itemsHasNextToken)
      // .then(data => {
      //   // console.log('get gallery')
      //   // console.log(data)
      //   this.itemsHasNext = data.hasNextPage
      //   this.itemsHasNextToken = data.maxId
      //   var items = data.items
      //   onComplete(items)
      //   this.itemsLoading = false
      // })
      __WEBPACK_IMPORTED_MODULE_1__apis_Site__["a" /* default */].instagramApi(24, this.itemsHasNextToken).then(function (response) {
        // console.log('get gallery')
        // console.log(data)
        var items = response.data;
        onComplete(items);
        var hasNext = response.data && response.data.length > 0;
        _this.itemsHasNext = hasNext;
        _this.itemsHasNextToken = hasNext ? _this.items.length : 0;
        _this.itemsLoading = false;
      }).catch(function (error) {
        // console.log('invalid get gallery', error)
        _this.items = [];
        // this.error = error.error
        _this.error = error.error;
        _this.error = 'Unable to load, please kindly visit our Instagram account <a href="' + _this.navInstagram.path + '" target="_blank">here</a>.';
        _this.itemsLoading = false;
      });
      // } else {
      //   console.log('-- getting hash --')
      //   console.log(this.navInstagramHashtag.title.replace('#', ''))
      //   Site.instagramTag(this.navInstagramHashtag.title.replace('#', ''), this.itemsHasNextToken)
      //   .then(data => {
      //     console.log('get gallery tag')
      //     console.log(data)
      //     this.itemsHasNext = false
      //     this.itemsHasNextToken = false
      //     var items = data.graphql.hashtag.edge_hashtag_to_media.edges // this one differ from user photos
      //     // var items = data.tag.top_posts.nodes // this one differ from user photos
      //     var newItems = []
      //     for (var i = 0; i < items.length; i++) {
      //       var item = items[i].node
      //       if (item.display_url) {
      //         item.images = {
      //           standard_resolution: {
      //             // url: this.parseInstagramImageLink(item.display_url)
      //             url: item.display_url
      //           }
      //         }
      //         item.link = 'https://www.instagram.com/p/' + item.shortcode
      //         // console.log(item)
      //       }
      //       newItems.push(item)
      //     }
      //     onComplete(newItems)
      //     this.itemsLoading = false
      //   })
      //   .catch(error => {
      //     // console.log('invalid get gallery', error)
      //     this.items = []
      //     // this.error = error.error
      //     this.error = error.error
      //     this.error = 'Unable to load, please kindly visit our Instagram account <a href="' + this.navInstagram.path + '" target="_blank">here</a>.'
      //     this.itemsLoading = false
      //   })
      // }
    },
    refresh: function refresh() {
      var _this2 = this;

      this.getItems(function (items) {
        if (items && items.length > 0) {
          var limitItems = [];
          for (var i = 0; i < _this2.itemsMax; i++) {
            if (i < items.length) {
              limitItems.push(items[i]);
            }
          }
          _this2.items = limitItems;
        } else {
          _this2.items = [];
        }
      });
    },
    loadMore: function loadMore() {
      // return if exceed (showcase purpose)
      if (!this.itemsHasNext) {
        this.itemsEnded = true;
        this.$emit('onItemsEnded', {});
        return;
      }

      if (!this.itemsEnded) {
        this.getItems(function (items) {
          this.items = this.items.concat(items);
          if (this.items.length > this.itemsMax) {
            this.items = this.items.slice(0, this.itemsMax);
            this.itemsEnded = true;
            this.$emit('onItemsEnded', {});
          }
        }.bind(this));
      }
    },
    onItemClick: function onItemClick($event, item) {
      $event.preventDefault();
      this.$emit('onItemClick', item);
    }
  }
});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MasonryYoutube_vue__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MasonryYoutube_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_MasonryYoutube_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HotlinkSection_vue__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HotlinkSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__HotlinkSection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AboutSection_vue__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AboutSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AboutSection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SponsorsSection_vue__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SponsorsSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SponsorsSection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NewsletterSection_vue__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NewsletterSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__NewsletterSection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InstagramSection_vue__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InstagramSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__InstagramSection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContactSection_vue__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContactSection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ContactSection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_MainDialog_vue__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_MainDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_MainDialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Dialog_vue__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Dialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Dialog_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'landing',
  components: {
    MasonryYoutube: __WEBPACK_IMPORTED_MODULE_1__components_MasonryYoutube_vue___default.a,
    HotlinkSection: __WEBPACK_IMPORTED_MODULE_2__HotlinkSection_vue___default.a,
    AboutSection: __WEBPACK_IMPORTED_MODULE_3__AboutSection_vue___default.a,
    NewsletterSection: __WEBPACK_IMPORTED_MODULE_5__NewsletterSection_vue___default.a,
    InstagramSection: __WEBPACK_IMPORTED_MODULE_6__InstagramSection_vue___default.a,
    ContactSection: __WEBPACK_IMPORTED_MODULE_7__ContactSection_vue___default.a,
    SponsorsSection: __WEBPACK_IMPORTED_MODULE_4__SponsorsSection_vue___default.a,
    MainDialog: __WEBPACK_IMPORTED_MODULE_8__components_MainDialog_vue___default.a,
    BaseDialog: __WEBPACK_IMPORTED_MODULE_9__components_Dialog_vue___default.a
  },
  data: function data() {
    return {
      isDesktop: true,
      // itemsEnded: false,
      scrollPos: 0,
      dialogVisible: true,
      dialogPhotoVisible: false,
      dialogPhoto: {}
    };
  },

  computed: {},
  watch: {},
  created: function created() {
    // console.log('created Landing.vue')
  },
  mounted: function mounted() {
    // console.log('mounted Landing.vue')
    // window.GA('send', 'pageview')

    if (this.$route.query && this.$route.query.anchor) {
      console.log('automatic scroll to...: ' + this.$route.query.anchor);
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor);
      }.bind(this), 2000);
    }

    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));
  },

  methods: {
    onScrollTo: function onScrollTo(name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } });
      } else {
        this.$scrollTo('#' + target, { offset: -30 });
      }
    },


    onCloseDialog: function onCloseDialog() {
      this.dialogVisible = false;
    },

    onDialogPhoto: function onDialogPhoto(item) {
      this.dialogPhotoVisible = true;
      this.$set(this, 'dialogPhoto', item || {});
    },

    onCloseDialogPhoto: function onCloseDialogPhoto() {
      this.dialogPhotoVisible = false;
      this.$set(this, 'dialogPhoto', {});
    }
  }
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_Site__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'newslettersection',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      name: '',
      email: '',
      // captcha: '',
      // session: '',
      captchaImage: undefined,
      feedback: false,
      loading: false
    };
  },
  mounted: function mounted() {
    // this.onRecaptcha(data => {
    //   console.log('recaptcha data!')
    //   this.captchaImage = data.data
    //   this.session = data.id
    // })
  },
  methods: {
    onRecaptcha: function onRecaptcha(onRecaptchaSuccess) {
      // Site.getRecaptcha()
      // .then(data => {
      //   console.log('get recaptcha')
      //   console.log(data)
      //   if (onRecaptchaSuccess) {
      //     onRecaptchaSuccess(data)
      //   }
      // })
      // .catch(error => {
      //   console.log('get recaptcha error')
      //   console.log(error)
      // })
    },
    onSend: function onSend($v) {
      var _self = this;
      if ($v.$invalid) {
        _self.feedback = 'Please fill in all fields to proceed.';
        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Please fill in all fields to proceed.',
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
      } else {
        _self.feedback = false;
        _self.loading = true;
        __WEBPACK_IMPORTED_MODULE_2__apis_Site__["a" /* default */].subscribe(_self.name, _self.email).then(function (data) {
          console.log('email sent');
          _self.loading = false;
          _self.name = '';
          _self.email = '';

          if (data && data.status !== 'ok') {
            _self.feedback = 'Oops. Something went wrong. Please try again later..';
            return;
          }

          // _self.session = '' // open up to maintain session
          // _self.$toast.open({
          //   message: 'We will be contacting you via email or phone. Thanks!',
          //   position: 'is-bottom',
          //   type: 'is-success'
          // })
          _self.feedback = 'Subscribed. Thanks!';
          _self.loading = false;
        }).catch(function (error) {
          console.log('invalid email', error);
          // this.error = error.error
          console.log(error);
          _self.captcha = '';

          // invalid recaptcha
          if (error && error.code === 103) {
            _self.feedback = error.error;
            _self.loading = false;
            return;
          }

          // _self.$toast.open({
          //   duration: 5000,
          //   message: 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail,
          //   position: 'is-bottom',
          //   type: 'is-warning'
          // })
          _self.feedback = 'Oops. Something went wrong. Please try again later..';
          _self.loading = false;
        });
      }
    }
  },
  validations: {
    email: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
      email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"]
    },
    name: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    }
  }
});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TopSubpageSection__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TopSubpageSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_TopSubpageSection__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'notfound',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_0__components_DivContainer___default.a,
    TopSubpageSection: __WEBPACK_IMPORTED_MODULE_1__components_TopSubpageSection___default.a
  },
  data: function data() {
    return {
      isDesktop: true
    };
  }
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageSubheader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PageSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TopSubpageSection__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TopSubpageSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_TopSubpageSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InstagramSection__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InstagramSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__InstagramSection__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-photos',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default.a,
    PageHeader: __WEBPACK_IMPORTED_MODULE_2__components_PageHeader___default.a,
    PageSubheader: __WEBPACK_IMPORTED_MODULE_3__components_PageSubheader___default.a,
    TopSubpageSection: __WEBPACK_IMPORTED_MODULE_4__components_TopSubpageSection___default.a,
    InstagramSection: __WEBPACK_IMPORTED_MODULE_5__InstagramSection___default.a
  },
  data: function data() {
    return {
      isDesktop: true,
      // itemsEnded: false,
      scrollPos: 0
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    if (this.$route.query && this.$route.query.anchor) {
      console.log('automatic scroll to...: ' + this.$route.query.anchor);
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor);
      }.bind(this), 1000);
    }

    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));
  },

  methods: {
    onScrollTo: function onScrollTo(name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } });
      } else {
        this.$scrollTo('#' + target, { offset: 0 });
      }
    }
  }
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageHeader__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TopSubpageSection__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TopSubpageSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_TopSubpageSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ScheduleSubSection__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ScheduleSubSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ScheduleSubSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EventSubSection__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EventSubSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__EventSubSection__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'schedule',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_2__components_DivContainer___default.a,
    PageHeader: __WEBPACK_IMPORTED_MODULE_3__components_PageHeader___default.a,
    TopSubpageSection: __WEBPACK_IMPORTED_MODULE_4__components_TopSubpageSection___default.a,
    ScheduleSubSection: __WEBPACK_IMPORTED_MODULE_5__ScheduleSubSection___default.a,
    EventSubSection: __WEBPACK_IMPORTED_MODULE_6__EventSubSection___default.a
  },
  data: function data() {
    return {
      isDesktop: true,
      // itemsEnded: false,
      scrollPos: 0,
      items: [],
      loading: true,
      error: undefined
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    if (this.$route.query && this.$route.query.anchor) {
      console.log('automatic scroll to...: ' + this.$route.query.anchor);
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor);
      }.bind(this), 2000);
    }

    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_1__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_1__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_1__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    this.refresh();
  },

  methods: {
    onScrollTo: function onScrollTo(name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } });
      } else {
        this.$scrollTo('#' + target, { offset: -30 });
      }
    },
    getEventAll: function getEventAll() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].eventAll().then(function (data) {
        _this.loading = false;
        // console.log(data)
        if (!data) {
          _this.error = 'Unable to load, please kindly refresh the page.';
          return;
        }

        if (data && data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            var event = data[i];
            var name = event.title_slug;
            if (!name || name.length <= 0) {
              data[i].icon = 'misc';
            } else if (name && name.indexOf('strawberry') !== -1) {
              data[i].icon = 'strawberry';
            } else if (name.indexOf('king') !== -1 || name.indexOf('wing') !== -1) {
              data[i].icon = 'king';
            } else if (name.indexOf('people') !== -1 || name.indexOf('choice') !== -1) {
              data[i].icon = 'people';
            } else {
              data[i].icon = 'misc';
            }

            data[i].title_short = data[i].title.replace(/competition/ig, '');
          }
        }

        _this.items = data;
      }).catch(function (error) {
        _this.loading = false;
        _this.error = 'Unable to load, please kindly refresh the page.';
        console.log(error);
      });
    },
    refresh: function refresh() {
      this.getEventAll();
    }
  }
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageSubtab__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageSubtab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PageSubtab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_showdown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_showdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_showdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_showdown_target_blank__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_showdown_target_blank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_showdown_target_blank__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'section-sub-schedule',
  props: ['title'],
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default.a,
    PageSubtab: __WEBPACK_IMPORTED_MODULE_2__components_PageSubtab___default.a
  },
  data: function data() {
    return {
      currentDate: undefined,
      currentDateScheduleLoaded: false,
      dates: [],
      dateIndex: 0,
      items: [],
      itemsLoaded: false,
      error: undefined,
      loading: false
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    onDateChanged: function onDateChanged(date) {
      console.log(date + ' changed@');
      this.currentDateScheduleLoaded = false;
      if (this.items[date]) {
        this.currentDate = date;
        this.currentDateScheduleLoaded = true;
        return;
      }
      this.getSchedules(date);
    },

    getDates: function getDates() {
      var _this = this;

      this.loading = true;
      this.error = undefined;
      __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].scheduleDates().then(function (data) {
        _this.loading = false;
        if (!data) {
          _this.error = 'Unable to load, please kindly refresh the page.';
          return;
        }
        _this.onDateComplete(data);
      }).catch(function (error) {
        _this.loading = false;
        _this.error = 'Unable to load, please kindly refresh the page.';
        console.log(error);
      });
    },

    getSchedules: function getSchedules(date) {
      var _this2 = this;

      this.loading = true;
      this.error = undefined;
      __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].scheduleWithDate(date).then(function (data) {
        _this2.loading = false;
        if (!data) {
          _this2.error = 'Unable to load, please kindly refresh the page.';
          return;
        }
        _this2.onSchedulesComplete(date, data);
      }).catch(function (error) {
        _this2.loading = false;
        _this2.error = 'Unable to load, please kindly refresh the page.';
        console.log(error);
      });
    },

    convertDate: function convertDate(value) {
      if (!value) {
        return undefined;
      }
      value = value.replace(/\s/, 'T');
      value = __WEBPACK_IMPORTED_MODULE_5_moment___default()(new Date(value)).format('MMMM D, YYYY');
      return value;
    },

    convertDateTitle: function convertDateTitle(value) {
      if (!value) {
        return undefined;
      }
      value = value.replace(/\s/, 'T');
      var day = __WEBPACK_IMPORTED_MODULE_5_moment___default()(value).format('E');
      switch (day) {
        case '0':
        case '7':
          day = 'Sunday';
          break;
        case '1':
          day = 'Monday';
          break;
        case '2':
          day = 'Tuesday';
          break;
        case '3':
          day = 'Wednesday';
          break;
        case '4':
          day = 'Thursday';
          break;
        case '5':
          day = 'Friday';
          break;
        case '6':
          day = 'Saturday';
          break;
        default:
          day = 'Invalid';
          break;
      }
      var date = __WEBPACK_IMPORTED_MODULE_5_moment___default()(value).format('MMMM D');
      return day + ', ' + date;
    },

    convertTime: function convertTime(value) {
      if (!value) {
        return undefined;
      }
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(value, 'YYYY-MM-DD HH:mm:ss').format('h:mm A');
      // note: issue with safari, but the following is wrong too..
      // value = value.replace(/\s/, 'T')
      // return moment(new Date(value)).format('h:mm A')
    },

    onDateComplete: function onDateComplete(dates) {
      // console.log('loaded dates')
      // console.log(dates)
      if (dates && dates.length > 0) {
        this.currentDate = dates[0];
      }
      for (var j = 0; j < dates.length; j++) {
        var date = dates[j];
        this.dates.push({
          id: date,
          title: this.convertDateTitle(date) + ''
        });
        this.getSchedules(date);
      }
      // // ---- test start
      // this.currentDateScheduleLoaded = false
      // var current = '2019-05-10'
      // this.dates = [{
      //   id: '2019-05-10',
      //   title: this.convertDateTitle('2019-05-10')
      // }, {
      //   id: '2019-05-11',
      //   title: this.convertDateTitle('2019-05-11')
      // }]
      // for (var i = 0; i < 2; i++) {
      //   var id = this.dates[i].id
      //   this.items[id] = []
      //   this.getSchedules(id)
      // }
      // this.$nextTick(function () {
      //   this.currentDate = current
      //   this.currentDateScheduleLoaded = true
      // }.bind(this))
      // // ---- test end
      // if (dates && dates.length > 0) {
      //   this.currentDate = dates[0]
      //   for (var i = 0; i < dates.length; i++) {
      //     var date = dates[i]
      //     this.getSchedules(date)
      //   }
      // }
    },

    onSchedulesComplete: function onSchedulesComplete(date, schedules) {
      // console.log('loaded schedules')
      // console.log(date)
      // console.log(schedules)
      for (var i = 0; i < schedules.length; i++) {
        var schedule = schedules[i];
        if (schedule.description) {
          var converter = new __WEBPACK_IMPORTED_MODULE_3_showdown___default.a.Converter({ extension: ['targetblank'] });
          var html = converter.makeHtml(schedule.description);
          schedule.description = html;
        }

        // var startDate = this.convertDate(schedule.date_start)
        var startTime = this.convertTime(schedule.date_start);
        // var endDate
        var endTime;
        var fullDateTime = 'invalid';
        if (schedule.date_start === schedule.date_end) {
          schedule.date_end = undefined;
        }
        if (schedule.date_end) {
          // only start time and end time
          // endDate = this.convertDate(schedule.date_end)
          endTime = this.convertTime(schedule.date_end);
          // only start time and end time
          fullDateTime = startTime + ' - ' + endTime;
          // if (startDate === endDate) {
          //   // only start time and end time
          //   fullDateTime = startTime + ' - ' + endTime
          // } else {
          //   // different start date & end date
          //   fullDateTime = startTime + ' - ' + endDate + ' ' + endTime
          // }
        } else {
          // only start date & time
          fullDateTime = startTime;
        }
        schedules[i].full_date = fullDateTime;
      }

      this.items[date] = schedules;

      if (date === this.currentDate) {
        this.currentDateScheduleLoaded = true;
      }
    },

    onScheduleUpdated: function onScheduleUpdated(date) {
      // switch date
      // console.log(date + ' updated!!11')
    },

    refresh: function refresh() {
      this.getDates();
    }
  }
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DivColumns__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DivColumns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_DivColumns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PageHeader__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TopSubpageSection__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TopSubpageSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_TopSubpageSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PageSubtab__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PageSubtab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_PageSubtab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SignUpTeamSection__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SignUpTeamSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__SignUpTeamSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SignUpJudgeSection__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SignUpJudgeSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__SignUpJudgeSection__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'lodash'










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_4__components_DivContainer___default.a,
    DivColumns: __WEBPACK_IMPORTED_MODULE_5__components_DivColumns___default.a,
    PageHeader: __WEBPACK_IMPORTED_MODULE_6__components_PageHeader___default.a,
    TopSubpageSection: __WEBPACK_IMPORTED_MODULE_7__components_TopSubpageSection___default.a,
    PageSubtab: __WEBPACK_IMPORTED_MODULE_8__components_PageSubtab___default.a,
    SignUpTeamSection: __WEBPACK_IMPORTED_MODULE_9__SignUpTeamSection___default.a,
    SignUpJudgeSection: __WEBPACK_IMPORTED_MODULE_10__SignUpJudgeSection___default.a
  },
  data: function data() {
    return {
      applications: [{
        id: 'sign-up-team',
        title: 'Team Application',
        strikethrough: true,
        disabled: true,
        disabledText: 'Team Application Is Not Open Yet',
        isfull: true
      }, {
        id: 'sign-up-judge',
        title: 'Judge Application',
        strikethrough: true,
        disabled: true,
        disabledText: 'All Judging Spots Full',
        isfull: true
      }],
      defaultDisabledTextTeam: 'Team Application Is Not Open Yet',
      defaultDisabledTextJudge: 'All Judging Spots Full',
      applicationCurrent: 'sign-up-team',
      applicationIndex: 0,
      signUpTeamSectionWrapper: {
        display: 'block'
      },
      signUpJudgeSectionWrapper: {
        display: 'none'
      },
      isDesktop: true,
      isPrint: false,
      // itemsEnded: false,
      scrollPos: 0
    };
  },

  computed: {
    isDebug: function isDebug() {
      return this.$route.query.hasOwnProperty('debug') && this.$route.query.debug === '1';
    }
  },
  watch: {},
  created: function created() {
    // let isSignUp = false
    // let isDebug = this.isDebug
    // console.log('-- is sign up', isSignUp)
    // console.log('-- is debug', isDebug)
    // let isfull = !isSignUp
    console.log('-- sign up created');
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var type, disabled, data, _data, _data2, totalSites, remain;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.$route.query && _this.$route.query.anchor) {
                console.log('scroll to: ' + _this.$route.query.anchor);
                setTimeout(function () {
                  this.$scrollTo('#' + this.$route.query.anchor);
                }.bind(_this), 2000);
              }

              if (!_this.$route.query) {
                _context.next = 18;
                break;
              }

              if (!_this.$route.query.type) {
                _context.next = 15;
                break;
              }

              type = _this.$route.query.type;
              _context.t0 = type;
              _context.next = _context.t0 === 'judge' ? 7 : _context.t0 === 'team' ? 11 : 11;
              break;

            case 7:
              // this.applicationCurrent = 'sign-up-team'
              // this.applicationIndex = 0
              // this.onApplicationChanged(this.applicationCurrent)
              // this.$nextTick(() => {
              //   let query = _.assign({}, this.$route.query)
              //   query.type = 'team'
              //   this.$router.replace({ name: this.$route.name, query: query })
              // })
              // break
              _this.applicationCurrent = 'sign-up-judge';
              _this.applicationIndex = 1;
              _this.onApplicationChanged(_this.applicationCurrent);
              return _context.abrupt('break', 15);

            case 11:
              _this.applicationCurrent = 'sign-up-team';
              _this.applicationIndex = 0;
              _this.onApplicationChanged(_this.applicationCurrent);
              return _context.abrupt('break', 15);

            case 15:

              if (_this.$route.query.print && _this.$route.query.print === 'true') {
                _this.isPrint = true;
              } else {
                _this.isPrint = false;
              }
              _context.next = 21;
              break;

            case 18:
              // reset
              _this.applicationCurrent = 'sign-up-team';
              _this.applicationIndex = 0;
              _this.isPrint = false;

            case 21:

              // init
              disabled = true;

              _this.$set(_this.applications[0], 'strikethrough', disabled);
              _this.$set(_this.applications[0], 'isfull', disabled);
              _this.$set(_this.applications[0], 'disabledText', _this.defaultDisabledTextTeam);
              _this.$set(_this.applications[1], 'strikethrough', disabled);
              _this.$set(_this.applications[1], 'isfull', disabled);
              _this.$set(_this.applications[1], 'disabledText', _this.defaultDisabledTextJudge);

              _context.prev = 28;
              _context.next = 31;
              return __WEBPACK_IMPORTED_MODULE_3__apis_Site__["a" /* default */].aboutWithName('bosshog::signup-team');

            case 31:
              data = _context.sent;

              if (data && data.hasOwnProperty('disabled')) {
                _this.$set(_this.applications[0], 'strikethrough', data.disabled);
                _this.$set(_this.applications[0], 'isfull', data.disabled);
                _this.$set(_this.applications[0], 'disabledText', data.content || _this.defaultDisabledTextTeam);
              }
              _context.next = 38;
              break;

            case 35:
              _context.prev = 35;
              _context.t1 = _context['catch'](28);

              console.error(_context.t1);

            case 38:
              _context.prev = 38;
              _context.next = 41;
              return __WEBPACK_IMPORTED_MODULE_3__apis_Site__["a" /* default */].aboutWithName('bosshog::signup-judge');

            case 41:
              _data = _context.sent;

              if (_data && _data.hasOwnProperty('disabled')) {
                _this.$set(_this.applications[1], 'strikethrough', _data.disabled);
                _this.$set(_this.applications[1], 'isfull', _data.disabled);
                _this.$set(_this.applications[1], 'disabledText', _data.content || _this.defaultDisabledTextJudge);
              }
              _context.next = 48;
              break;

            case 45:
              _context.prev = 45;
              _context.t2 = _context['catch'](38);

              console.error(_context.t2);

            case 48:
              if (_this.applications[0].isfull) {
                _context.next = 62;
                break;
              }

              _context.prev = 49;
              _context.next = 52;
              return __WEBPACK_IMPORTED_MODULE_3__apis_Site__["a" /* default */].signUpApproved();

            case 52:
              _data2 = _context.sent;

              // console.log(data)
              totalSites = 42;
              remain = totalSites - _data2.length;

              remain = remain < 0 ? 0 : remain;
              _this.applications[0].disabledText = 'Only&nbsp;&nbsp;<span style="font-size:1.6em;">' + remain + '</span>&nbsp;&nbsp;Locations Left!';
              _context.next = 62;
              break;

            case 59:
              _context.prev = 59;
              _context.t3 = _context['catch'](49);

              console.error(_context.t3);

            case 62:

              // on event resize
              _this.isDesktop = __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */]._isDesktop;
              __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
                this.isDesktop = __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */]._isDesktop;
              }.bind(_this));

            case 64:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[28, 35], [38, 45], [49, 59]]);
    }))();
  },

  methods: {
    onScrollTo: function onScrollTo(name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } });
      } else {
        this.$scrollTo('#' + target, { offset: -30 });
      }
    },


    onApplicationChanged: function onApplicationChanged(applicationType) {
      console.log('application type changed: ' + applicationType);
      this.applicationCurrent = applicationType;
      if (applicationType === 'sign-up-team') {
        this.signUpTeamSectionWrapper.display = 'block';
        this.signUpJudgeSectionWrapper.display = 'none';
      } else if (applicationType === 'sign-up-judge') {
        this.signUpTeamSectionWrapper.display = 'none';
        this.signUpJudgeSectionWrapper.display = 'block';
      }
    }
  }
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivColumns__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivColumns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DivColumns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageSubheader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PageSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FormDynamix__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FormDynamix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_FormDynamix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//











// function validateArrayRequired (values) {
//   if (values && values.length > 0) {
//     var isChecked = false
//     for (var i = 0; i < values.length; i++) {
//       var value = values[i]
//       isChecked |= value
//     }
//     return isChecked
//   }
//   return false
// }
//
// function validateArrayOneNoneOrTwoThreeFour (values) {
//   if (values && values.length > 0) {
//     var noneSelected = false
//     var eitherOneSelected = false
//     if (values[1] === true) {
//       noneSelected = true
//     }
//     if (values[2] === true) {
//       eitherOneSelected = true
//     }
//     if (values[3] === true) {
//       eitherOneSelected = true
//     }
//     if (values[4] === true) {
//       eitherOneSelected = true
//     }
//     if (noneSelected && eitherOneSelected) {
//       return false
//     }
//   }
//   return true
// }

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'section-sign-up-judge',
  mixins: [__WEBPACK_IMPORTED_MODULE_5_vuelidate__["validationMixin"]],
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default.a,
    DivColumns: __WEBPACK_IMPORTED_MODULE_2__components_DivColumns___default.a,
    PageSubheader: __WEBPACK_IMPORTED_MODULE_3__components_PageSubheader___default.a,
    FormDynamix: __WEBPACK_IMPORTED_MODULE_4__components_FormDynamix___default.a
  },
  props: ['is-print'],
  watch: {
    'isPrint': {
      handler: function handler(value, oldValue) {
        var isPrint = value;
        if (isPrint) {
          this.models.signAt = '';
        } else {
          this.models.signAt = __WEBPACK_IMPORTED_MODULE_8_moment___default()(new Date()).format();
        }
      }
    },
    'models.kcbsCertified': {
      handler: function handler(value, oldValue) {
        var certified = value;
        if (certified === 1) {
          this.attributes.kcbsNumber.disabled = false;
          this.attributes.kcbsTotal.disabled = false;
        } else {
          this.attributes.kcbsNumber.disabled = true;
          this.attributes.kcbsTotal.disabled = true;
        }
      },
      deep: true
    }
  },
  data: function data() {
    return {
      isDesktop: true,
      isIE: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].detectIE(),
      isPrintPdf: '/static/judge-application.pdf',
      items: [],
      names: ['name', 'address', 'address2', 'city', 'state', 'zip', 'county', 'email', 'phone', 'phone2',
      // 'tshirt',
      'labelTshirt', 'labelCheck', // label
      'kcbsCertified', 'kcbsNumber', 'kcbsTotal', 'masterJudge', 'tableCaptain', 'kcbsLastThree', 'last1', 'last2', 'last3', 'labelTermsPre', // label
      'labelTerms', // label
      'signature', 'signAt', 'signNote' // label
      ],
      models: {
        recaptcha: undefined,
        name: '',
        address: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        county: '',
        email: '',
        phone: '',
        phone2: '',
        tshirt: undefined,
        kcbsCertified: false,
        kcbsNumber: '',
        kcbsTotal: undefined,
        kcbsLastThree: [],
        last1: '',
        last2: '',
        last3: '',
        masterJudge: false,
        tableCaptain: false,
        signature: '',
        signAt: ''
      },
      attributes: {
        name: {
          title: 'Judge Applicant\'s Name'
        },
        // address: {
        //   type: 'textarea',
        //   title: 'Address',
        //   curLength: 0,
        //   maxLength: 500
        // },
        address: {
          title: 'Address 1'
        },
        address2: {
          title: 'Address 2'
        },
        city: {
          title: 'City',
          column: 'is-6'
        },
        state: {
          title: 'State',
          column: 'is-6'
        },
        zip: {
          title: 'Zip Code',
          column: 'is-6'
        },
        county: {
          title: 'County',
          column: 'is-6'
        },
        email: {
          title: 'Email'
        },
        phone: {
          title: 'Phone',
          column: 'is-6'
        },
        phone2: {
          title: 'Secondary Phone',
          column: 'is-6'
        },
        // tshirt: {
        //   type: 'dropdown',
        //   title: 'T-Shirt Size',
        //   options: [
        //     { value: undefined,
        //       title: 'T-shirt Size' },
        //     { value: 1, title: 'S' },
        //     { value: 2, title: 'M' },
        //     { value: 3, title: 'L' },
        //     { value: 4, title: 'XL' },
        //     { value: 5, title: '2XL' },
        //     { value: 6, title: '3XL' }
        //   ],
        //   note: 'Please select your size'
        // },
        labelTshirt: {
          type: 'label',
          note: 'For T-SHIRT PRE-ORDER, contact our Judge Coordinator, Tim Lively.'
        },
        // labelCheck: {
        //   type: 'label',
        //   title: 'Applicant\'s Judging History:'
        // },
        kcbsCertified: {
          type: 'radio',
          title: 'KCBS Certified',
          options: [
          // { value: undefined,
          //   title: 'KCBS Certified' },
          { value: 1, title: 'Yes' }, { value: 2, title: 'No' }]
        },
        kcbsNumber: {
          title: 'KCBS CBJ Number',
          disabled: true,
          column: 'is-6'
        },
        kcbsTotal: {
          title: 'Total # of KCBS Events judged to date',
          disabled: true,
          column: 'is-6'
        },
        masterJudge: {
          type: 'radio',
          title: 'Master Judge',
          options: [
          // { value: undefined,
          //   title: 'Master Judge' },
          { value: 1, title: 'Yes' }, { value: 2, title: 'No' }]
        },
        tableCaptain: {
          type: 'radio',
          title: 'Certified Table Captain',
          options: [
          // { value: undefined,
          //   title: 'Certified Table Captain' },
          { value: 1, title: 'Yes' }, { value: 2, title: 'No' }]
        },
        kcbsLastThree: {
          type: 'checkbox',
          title: 'List the three (3) most recent contests you have judged:',
          options: []
        },
        last1: {
          title: '1.',
          column: 'is-10 is-offset-1'
        },
        last2: {
          title: '2.',
          column: 'is-10 is-offset-1'
        },
        last3: {
          title: '3.',
          column: 'is-10 is-offset-1'
        },
        labelTermsPre: {
          type: 'label',
          note: '<b>Waiver of Liability:</b> In consideration of your accepting this entry, I, the undersigned, intending to be legally bound, hereby for myself, my heirs, executors and administrators, waive and release any and all rights and claims for damages that I may have against The Boss Hog Cook-off, The Downtown Organization of Retailers, First National Bank of Waynesboro, Georgia; The City of Waynesboro; Mr. Golf Carts, Inc.; The Kansas City Barbecue Society, or any individual or group responsible for the organization or management of The Boss Hog Cook-off.  I hereby grant permission for The Boss Hog Cook-off and/or agents authorized by them to use any photographs, videotapes, motion pictures, recordings, and any other record of this event for any legitimate purpose.  I agree to abide by the rules and regulations of The Boss Hog Cook-off and Kansas City Barbecue Society.<br />' + '<b>Conditions:</b> The Boss Hog Cook-Off Committee reserves the right to reject any application. If your application is not accepted, your money will be refunded. However, no refunds of the application fee will be made once you have been accepted into the contest. Any photographs or videos taken of your team on-site become the property of D.O.O.R. and may be used for promotional purposes. By signing the application, contestants agree to indemnify and hold D.O.O.R., the Boss Hog Committee, the City of Waynesboro, Mr. Golf Carts Inc., and all employees, agents and volunteers, harmless from any and all claims made against same; including without limitation, all costs, liabilities, judgments, expenses, damages or reasonable attorneys’ fees, arising out of, or in connection with; (1) any structure erected by Contestant; (2) any apparatus, equipment or personal property used by Contestant; (3) any act or omission to act of Contestant, its agents, invitees, participants, representatives, employees, servants, and assigns; and (4) any claims made on account or resulting from contestants participating in the contest.<br />' + '<b>Participant’s Agreement:</b> The undersigned agrees that he/she will be responsible for any loss or damage to his/her work during Boss Hog. He/She agrees to abide by all rules as set forth by Boss Hog and KCBS. My signature below and enclosed amount due/mailed payment indicate that I understand that failure to abide by these rules and regulations may result in the termination of my contract and my participation in future events with D.O.O.R. This is a rain or shine festival, and no refund will be given due to weather.<br />' + '<b>Parking Agreement:</b> ONLY ONE VEHICLE ALLOWED PER TEAM COOK SITE.  Due to the overwhelming growth of our event, we need as much parking for patrons as possible.  Therefore, any vehicle OR trailer in excess of ONE must park in the designated area.  Parking Passes will be given for the team vehicles to be placed in the front window – towing will be enforced at the owner’s expense.  Thank you for understanding!'
        },
        labelTerms: {
          type: 'label',
          note: 'Please complete this form or mail it to Tim Lively at 411 Claxton-Lively Road, Waynesboro, GA 30830. If you have any questions, please call Tim Lively at (706) 551-2045. Thank you for your interest in the ' + __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].info.xth + ' Boss Hog Cook-Off. A representative will contact you soon about your judging status.'
        },
        signature: {
          title: 'Applicant\'s Name',
          column: 'is-6'
        },
        signAt: {
          title: 'Date',
          column: 'is-6',
          disabled: true
        },
        signNote: {
          null: true,
          title: 'Note',
          column: 'is-12',
          note: '* By typing your name, you agree to the above.<br />' + '* By typing your name and submitting this Judge Application, you agree to the above and agree to follow all of the COVID-19 restrictions & regulations enforced locally as well as any KCBS guidelines/addendums that may arise.'
        }
      },
      // captcha: '',
      // captchaImage: undefined,
      // session: '',
      feedback: false,
      loading: false,
      navEmail: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navEmail
    };
  },
  validations: {
    models: {
      recaptcha: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"] },
      name: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"] },
      // address: { required, maxLength: maxLength(500) },
      address: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"], maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["maxLength"])(500) },
      address2: { maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["maxLength"])(500) },
      city: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"], maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["maxLength"])(191) },
      state: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"], maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["maxLength"])(191) },
      zip: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"], maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["maxLength"])(191) },
      county: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"] },
      email: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["email"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["minLength"])(4) },
      phone: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"] },
      phone2: {},
      // tshirt: { required },
      labelTshirt: {}, // label
      kcbsCertified: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"] },
      kcbsNumber: {},
      kcbsTotal: {},
      kcbsLastThree: {},
      last1: {},
      last2: {},
      last3: {},
      masterJudge: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"] },
      tableCaptain: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"] },
      labelTermsPre: {}, // label
      labelTerms: {}, // label
      signature: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"] },
      signAt: { required: __WEBPACK_IMPORTED_MODULE_6_vuelidate_lib_validators__["required"] },
      signNote: {}
    }
  },
  created: function created() {
    // console.log('-- creating... --')
    // console.log(this.$v)
    // console.log(this.models)
    // this.init()
  },
  mounted: function mounted() {
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    // this.onRecaptcha(data => {
    //   // console.log('recaptcha data!')
    //   this.captchaImage = data.data
    //   this.session = data.id
    // })

    if (this.isPrint) {
      this.models.signAt = '';
    } else {
      this.models.signAt = __WEBPACK_IMPORTED_MODULE_8_moment___default()(new Date()).format();
    }

    // console.log('-- mounting... --')
    // console.log(this.$v)
  },
  methods: {
    onRecaptcha: function onRecaptcha(info) {
      if (info && info.status) {
        this.models.recaptcha = info.status === 'ok' ? info.response : undefined;
        if (info.status !== 'ok') {
          console.log('FormDynamix:recaptcha():' + info.status);
        }
      }
    },

    onClear: function onClear() {
      // this.models.recaptcha = undefined
      this.models.name = '';
      this.models.address = '';
      this.models.address2 = '';
      this.models.city = '';
      this.models.state = '';
      this.models.zip = '';
      this.models.county = '';
      this.models.email = '';
      this.models.phone = '';
      this.models.phone2 = '';
      this.models.tshirt = undefined;
      this.models.kcbsCertified = undefined;
      this.models.kcbsNumber = '';
      this.models.kcbsTotal = '';
      this.models.kcbsLastThree = [];
      this.models.last1 = '';
      this.models.last2 = '';
      this.models.last3 = '';
      this.models.masterJudge = undefined;
      this.models.tableCaptain = undefined;
      this.models.signature = '';
      this.models.signAt = __WEBPACK_IMPORTED_MODULE_8_moment___default()(new Date()).format();
    },

    onSendDisabled: function onSendDisabled() {
      var _self = this;
      _self.feedback = 'We are sorry, all judging spots are full.';
      return;
    },

    onSend: function onSend(formInfo) {
      var _this = this;

      // $v.models.$touch()
      var _self = this;
      console.log('SignUpTeamSection:onSend(): $v / models');
      console.log(formInfo);

      // var models = formInfo.models
      if (formInfo.vuelidate.$invalid) {
        _self.feedback = 'Form contains errors, please recheck.';
        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Please fill in all fields to proceed.',
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
        return;
      }

      if (!this.models.recaptcha) {
        _self.feedback = 'Invalid recaptcha, please validate again.';
        return;
      }
      _self.feedback = false;

      var models = formInfo.models;

      console.log('-- send form --');
      console.log(models);
      console.log(models.name);
      console.log(models.address);
      console.log(models.address2);
      console.log(models.city);
      console.log(models.state);
      console.log(models.zip);
      console.log(models.county);
      console.log(models.email);
      console.log(models.phone);
      console.log(models.phone2);
      console.log(models.tshirt);
      console.log(models.kcbsCertified);
      console.log(models.kcbsNumber);
      console.log(models.kcbsTotal);
      console.log(models.last1);
      console.log(models.last2);
      console.log(models.last3);
      console.log(models.masterJudge);
      console.log(models.tableCaptain);
      console.log(models.signature);
      console.log(models.signAt);

      // if (formInfo) {
      //   return
      // }

      _self.loading = true;
      __WEBPACK_IMPORTED_MODULE_7__apis_Site__["a" /* default */].signUpJudge(models.recaptcha, models.name, models.address, models.address2, models.city, models.state, models.zip, models.county, models.email, models.phone, models.phone2, models.tshirt, models.kcbsCertified, models.kcbsNumber, models.kcbsTotal, models.last1, models.last2, models.last3, models.masterJudge, models.tableCaptain, models.signature, models.signAt).then(function (data) {
        _self.loading = false;

        // invalid captcha
        if (data && data.status === 'invalid_session') {
          _self.feedback = 'Invalid session, please kindly refresh and try again.';
          return;
        }

        // invalid captcha
        if (data && data.status === 'invalid_captcha') {
          _self.feedback = 'Invalid captcha, please re-type again.';
          return;
        }

        if (data && data.status !== 'ok') {
          _self.feedback = 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail;
          return;
        }

        _this.$v.models.$reset();
        _this.onClear();

        // _self.captcha = ''
        // _self.session = '' // open up to maintain session

        // _self.$toast.open({
        //   message: 'We will be contacting you via email or phone. Thanks!',
        //   position: 'is-bottom',
        //   type: 'is-success'
        // })
        _self.feedback = 'Your application has been successfully submitted. Thank you!';
      }).catch(function (error) {
        console.log('invalid email', error);
        // this.error = error.error
        console.log(error);
        // _self.captcha = ''

        // invalid captcha
        if (error && error.status === 'invalid_session') {
          _self.feedback = 'Invalid session, please kindly refresh and try again.';
          _self.loading = false;
          return;
        }

        // invalid captcha
        if (error && error.status === 'invalid_captcha') {
          _self.feedback = 'Invalid captcha, please retype again.';
          _self.loading = false;
          return;
        }

        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail,
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
        _self.feedback = 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail;
        _self.loading = false;
      });
    }
  }
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DivColumns__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DivColumns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_DivColumns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PageSubheader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PageSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_PageSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FormDynamix__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FormDynamix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_FormDynamix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_map_png__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_map_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_map_png__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













// function validateArrayRequired (values) {
//   if (values && values.length > 0) {
//     var isChecked = false
//     for (var i = 0; i < values.length; i++) {
//       var value = values[i]
//       isChecked |= value
//     }
//     return isChecked
//   }
//   return false
// }
//
// function validateArrayOneNoneOrTwoThreeFour (values) {
//   if (values && values.length > 0) {
//     var noneSelected = false
//     var eitherOneSelected = false
//     if (values[1] === true) {
//       noneSelected = true
//     }
//     if (values[2] === true) {
//       eitherOneSelected = true
//     }
//     if (values[3] === true) {
//       eitherOneSelected = true
//     }
//     if (values[4] === true) {
//       eitherOneSelected = true
//     }
//     if (noneSelected && eitherOneSelected) {
//       return false
//     }
//   }
//   return true
// }

function validateEitherOr(value1, value2) {
  // console.log('-- validate either or --')
  // console.log(value1)
  // console.log(value2)
  if (value1 && !value2) {
    return true;
  } else if (!value1 && value2) {
    return true;
  }
  return false;
}

function validateUnique(valueOwn, value2, value3, value4, value5) {
  var values = [];
  if (valueOwn) {
    values.push(valueOwn);
  }
  if (value2) {
    values.push(value2);
  }
  if (value3) {
    values.push(value3);
  }
  if (value4) {
    values.push(value4);
  }
  if (value5) {
    values.push(value5);
  }

  for (var i = 0; i < (values.length > 0 ? 1 : 0); i++) {
    for (var j = 0; j < values.length; j++) {
      if (i !== j) {
        // do not check itself
        if (values[i] === values[j]) {
          return false;
        }
      }
    }
  }
  return true;
}

function addAllValues(value1, value2, value3, value4, value5, value6) {
  var values = 0;
  if (value1 && parseInt(value1, 10)) {
    values += parseInt(value1, 10);
  }
  if (value2 && parseInt(value2, 10)) {
    values += parseInt(value2, 10);
  }
  if (value3 && parseInt(value3, 10)) {
    values += parseInt(value3, 10);
  }
  if (value4 && parseInt(value4, 10)) {
    values += parseInt(value4, 10);
  }
  if (value5 && parseInt(value5, 10)) {
    values += parseInt(value5, 10);
  }
  if (value6 && parseInt(value6, 10)) {
    values += parseInt(value6, 10);
  }
  return values;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'section-sign-up-team',
  mixins: [__WEBPACK_IMPORTED_MODULE_7_vuelidate__["validationMixin"]],
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_3__components_DivContainer___default.a,
    DivColumns: __WEBPACK_IMPORTED_MODULE_4__components_DivColumns___default.a,
    PageSubheader: __WEBPACK_IMPORTED_MODULE_5__components_PageSubheader___default.a,
    FormDynamix: __WEBPACK_IMPORTED_MODULE_6__components_FormDynamix___default.a
  },
  props: ['is-print'],
  watch: {
    'isPrint': {
      handler: function handler(value, oldValue) {
        var isPrint = value;
        if (isPrint) {
          this.attributes.topMap.column = 'is-10';
        } else {
          this.attributes.topMap.column = 'is-5';
        }

        if (isPrint) {
          this.models.signAt = '';
          this.models.signAtRight = '';
        } else {
          this.models.signAt = __WEBPACK_IMPORTED_MODULE_10_moment___default()(new Date()).format();
          this.models.signAtRight = __WEBPACK_IMPORTED_MODULE_10_moment___default()(new Date()).format();
        }
      }
    },
    'models.competition': {
      handler: function handler(value, oldValue) {
        var disabled = value !== 1;
        this.attributes.top1.disabled = disabled;
        this.attributes.top2.disabled = disabled;
        this.attributes.top3.disabled = disabled;
        this.attributes.top4.disabled = disabled;
        this.attributes.top5.disabled = disabled;
        this.attributes.volunteer.disabled = disabled;
        if (disabled) {
          this.models.top1 = '';
          this.models.top2 = '';
          this.models.top3 = '';
          this.models.top4 = '';
          this.models.top5 = '';
          this.models.volunteer = undefined;
        }
        // if (value[2] !== oldValue[2]) {
        // var changed = value.filter(function (p, idx) {
        //   return Object.keys(p).some(function (prop) {
        //     return p[prop] !== oldValue[idx][prop]
        //   })
        // })
        // console.log('changed-value...')
        // console.log(changed)

        if (value !== oldValue && value === 1) {
          this.models.competition2 = false;
        }
        this.calculateTotal(this.models.competition, this.models.competition2, this.models.members, this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL);
      },
      deep: true
    },
    'models.competition2': {
      handler: function handler(value, oldValue) {
        if (value !== oldValue && value === 2) {
          this.models.competition = false;
        }
        this.calculateTotal(this.models.competition, this.models.competition2, this.models.members, this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL);
      }
    },
    'models.members': {
      handler: function handler(value, oldValue) {
        console.log('member change: ' + value);
        this.calculateTotal(this.models.competition, this.models.competition2, this.models.members, this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL);
      }
    },
    'models.tshirt': {
      handler: function handler(value, oldValue) {
        var disabled = value !== 1;
        this.attributes.tshirtS.disabled = disabled;
        this.attributes.tshirtM.disabled = disabled;
        this.attributes.tshirtL.disabled = disabled;
        this.attributes.tshirtXL.disabled = disabled;
        this.attributes.tshirt2XL.disabled = disabled;
        this.attributes.tshirt3XL.disabled = disabled;
        if (disabled) {
          this.models.tshirtS = '';
          this.models.tshirtM = '';
          this.models.tshirtL = '';
          this.models.tshirtXL = '';
          this.models.tshirt2XL = '';
          this.models.tshirt3XL = '';
        }
        this.calculateTotal(this.models.competition, this.models.competition2, this.models.members, this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL);
      },
      deep: true
    },
    'models.tshirtS': {
      handler: function handler(value, oldValue) {
        this.calculateTotal(this.models.competition, this.models.competition2, this.models.members, this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL);
      }
    },
    'models.tshirtM': {
      handler: function handler(value, oldValue) {
        this.calculateTotal(this.models.competition, this.models.competition2, this.models.members, this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL);
      }
    },
    'models.tshirtL': {
      handler: function handler(value, oldValue) {
        this.calculateTotal(this.models.competition, this.models.competition2, this.models.members, this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL);
      }
    },
    'models.tshirtXL': {
      handler: function handler(value, oldValue) {
        this.calculateTotal(this.models.competition, this.models.competition2, this.models.members, this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL);
      }
    },
    'models.tshirt2XL': {
      handler: function handler(value, oldValue) {
        this.calculateTotal(this.models.competition, this.models.competition2, this.models.members, this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL);
      }
    },
    'models.tshirt3XL': {
      handler: function handler(value, oldValue) {
        this.calculateTotal(this.models.competition, this.models.competition2, this.models.members, this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL);
      }
    }
  },
  computed: {
    // isDesktop: function () {
    //   return EventBus.isDesktop
    // }
  },
  data: function data() {
    var _this = this;

    return {
      isDesktop: true,
      isIE: __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */].detectIE(),
      isPrintPdf: '/static/team-application.pdf',
      isMapModalActive: false,
      imageMapSrc: __WEBPACK_IMPORTED_MODULE_11__assets_map_png___default.a,
      markerCurrent: undefined,
      markerHeight: '4%',
      markerClear: {
        topRatio: 57,
        top: '57%',
        left: '2%'
      },
      markerList: [{
        text: '1',
        textSelected: '',
        topRatio: 5.8,
        top: '5.8%',
        left: '14%',
        state: 0,
        selTop: 'initial',
        selBottom: '50%',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '2',
        textSelected: '',
        topRatio: 8.8,
        top: '8.8%',
        left: '11%',
        state: 0,
        selTop: 'initial',
        selBottom: '50%',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '3',
        textSelected: '',
        topRatio: 12.4,
        top: '12.4%',
        left: '8%',
        state: 0,
        selTop: 'initial',
        selBottom: '50%',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '4',
        textSelected: '',
        topRatio: 15.8,
        top: '15.8%',
        left: '6.3%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '5',
        textSelected: '',
        topRatio: 20.2,
        top: '20.2%',
        left: '5.2%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '6',
        textSelected: '',
        topRatio: 24.6,
        top: '24.6%',
        left: '5.2%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '7',
        textSelected: '',
        topRatio: 28.6,
        top: '28.6%',
        left: '5.2%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '8',
        textSelected: '',
        topRatio: 33,
        top: '33%',
        left: '6.4%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '9',
        textSelected: '',
        topRatio: 36.9,
        top: '36.9%',
        left: '9%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '10',
        textSelected: '',
        topRatio: 40.4,
        top: '40.4%',
        left: '12%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '11',
        textSelected: '',
        topRatio: 43.6,
        top: '43.6%',
        left: '14.7%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '12',
        textSelected: '',
        topRatio: 46.6,
        top: '46.6%',
        left: '17.8%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '13',
        textSelected: '',
        topRatio: 49.4,
        top: '49.4%',
        left: '21.6%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '14',
        textSelected: '',
        topRatio: 52.1,
        top: '52.1%',
        left: '24.2%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: 'initial',
        selRight: '100%'
      }, {
        text: '15',
        textSelected: '',
        topRatio: 55.1,
        top: '55.1%',
        left: '29.8%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-50%',
        selRight: 'initial'
      }, {
        text: '16',
        textSelected: '',
        topRatio: 57.1,
        top: '57.1%',
        left: '34.3%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-50%',
        selRight: 'initial'
      }, {
        text: '17',
        textSelected: '',
        topRatio: 58.8,
        top: '58.8%',
        left: '39%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-50%',
        selRight: 'initial'
      }, {
        text: '18',
        textSelected: '',
        topRatio: 60.5,
        top: '60.5%',
        left: '43%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-50%',
        selRight: 'initial'
      }, {
        text: '19',
        textSelected: '',
        topRatio: 63,
        top: '63%',
        left: '53.6%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-100%',
        selRight: 'initial'
      }, {
        text: '20',
        textSelected: '',
        topRatio: 63,
        top: '63%',
        left: '56.8%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-80%',
        selRight: 'initial'
      }, {
        text: '21',
        textSelected: '',
        topRatio: 63,
        top: '63%',
        left: '60%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-60%',
        selRight: 'initial'
      }, {
        text: '22',
        textSelected: '',
        topRatio: 63,
        top: '63%',
        left: '63%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-40%',
        selRight: 'initial'
      }, {
        text: '23',
        textSelected: '',
        topRatio: 62.6,
        top: '62.6%',
        left: '66.2%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-20%',
        selRight: 'initial'
      }, {
        text: '24',
        textSelected: '',
        topRatio: 62.4,
        top: '62.4%',
        left: '69.4%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '0%',
        selRight: 'initial'
      }, {
        text: '25',
        textSelected: '',
        topRatio: 62,
        top: '62%',
        left: '72.6%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-20%',
        selRight: 'initial'
      }, {
        text: '26',
        textSelected: '',
        topRatio: 62,
        top: '62%',
        left: '76.2%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '-10%',
        selRight: 'initial'
      }, {
        text: '27',
        textSelected: '',
        topRatio: 62.6,
        top: '62.6%',
        left: '80.8%',
        state: 0,
        selTop: '100%',
        selBottom: 'initial',
        selLeft: '0%',
        selRight: 'initial'
      }, {
        text: '28',
        textSelected: '',
        topRatio: 63.6,
        top: '63.6%',
        left: '84.6%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '29',
        textSelected: '',
        topRatio: 61.1,
        top: '61.1%',
        left: '89.6%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '30',
        textSelected: '',
        topRatio: 53.6,
        top: '53.6%',
        left: '90.9%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '31',
        textSelected: '',
        topRatio: 48,
        top: '48%',
        left: '88.8%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '32',
        textSelected: '',
        topRatio: 43.3,
        top: '43.3%',
        left: '86.4%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '33',
        textSelected: '',
        topRatio: 38.9,
        top: '38.9%',
        left: '83.8%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '34',
        textSelected: '',
        topRatio: 34.2,
        top: '34.2%',
        left: '81%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '35',
        textSelected: '',
        topRatio: 30.2,
        top: '30.2%',
        left: '78.4%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '36',
        textSelected: '',
        topRatio: 26.8,
        top: '26.8%',
        left: '76.1%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '37',
        textSelected: '',
        topRatio: 23.2,
        top: '23.2%',
        left: '74.1%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '38',
        textSelected: '',
        topRatio: 19.4,
        top: '19.4%',
        left: '71.4%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '39',
        textSelected: '',
        topRatio: 16,
        top: '16%',
        left: '69%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '40',
        textSelected: '',
        topRatio: 13,
        top: '13%',
        left: '66.6%',
        state: 0,
        selTop: '0%',
        selBottom: 'initial',
        selLeft: '100%',
        selRight: 'initial'
      }, {
        text: '41',
        textSelected: '',
        topRatio: 11,
        top: '11%',
        left: '62.2%',
        state: 0,
        selTop: 'initial',
        selBottom: '100%',
        selLeft: '0%',
        selRight: 'initial'
      }, {
        text: '42',
        textSelected: '',
        topRatio: 11,
        top: '11%',
        left: '57.8%',
        state: 0,
        selTop: 'initial',
        selBottom: '100%',
        selLeft: '0%',
        selRight: 'initial'
      }],
      markerDisabledList: [],
      items: [],
      names: ['name', 'leader', 'members', 'memberNames', 'kcbsNumber', 'address', 'address2', 'city', 'state', 'zip', 'county', 'email', 'phone', 'phone2', 'sellBbq', 'bbq', 'power', 'labelCheck', // label
      'competition2', 'competition', 'labelTopNote', 'labelCompetition', 'topDesiredLocation', 'topMap', 'top1', 'top2', 'top3', 'top4', 'top5', 'volunteer', 'labelVolunteer',
      // 'labelVolunteerYes',
      'tshirt', 'tshirtS', 'tshirtM', 'tshirtL', 'tshirtXL', 'tshirt2XL', 'tshirt3XL', 'freeStrawberry', 'freeKingOfWing', 'labelAmount', // label
      'amount', 'labelAmountTerm', // label
      'labelTerm', // label
      'signatureRight', 'signAtRight', 'labelTerm2', // label
      'signature', 'signAt', 'signNote'],
      models: {
        recaptcha: undefined,
        name: '',
        leader: '',
        members: '',
        memberNames: '',
        kcbsNumber: '',
        address: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        county: '',
        email: '',
        phone: '',
        phone2: '',
        // sellBbq: undefined,
        bbq: undefined,
        power: undefined,
        volunteer: 0,
        competition: 0,
        competition2: 0,
        // topDesiredLocation: [],
        top1: '',
        top2: '',
        top3: '',
        top4: '',
        top5: '',
        tshirt: undefined,
        tshirtS: '',
        tshirtM: '',
        tshirtL: '',
        tshirtXL: '',
        tshirt2XL: '',
        tshirt3XL: '',
        freeStrawberry: false,
        freeKingOfWing: false,
        // labelAmount: '',
        amount: '0',
        // labelAmountTerm: '',
        // labelTerm: '',
        signatureRight: '',
        signAtRight: '',
        // labelTerm2: '',
        signature: '',
        signAt: '',
        signNote: undefined
      },
      // models: {
      //   recaptcha: undefined,
      //   name: 'team1',
      //   leader: 'leader1',
      //   members: '11',
      //   address: 'address1',
      //   address2: 'address2',
      //   city: 'city1',
      //   state: 'state1',
      //   zip: '12345',
      //   county: 'county1',
      //   email: 'email@gmail.com',
      //   phone: 'phone1',
      //   phone2: 'phone2',
      //   // sellBbq: undefined,
      //   bbq: 1,
      //   power: 2,
      //   competition: 1,
      //   competition2: false,
      //   // topDesiredLocation: [],
      //   top1: '5',
      //   top2: '4',
      //   top3: '3',
      //   top4: '2',
      //   top5: '1',
      //   tshirt: true,
      //   tshirtS: '1',
      //   tshirtM: '2',
      //   tshirtL: '3',
      //   tshirtXL: '4',
      //   tshirt2XL: '5',
      //   tshirt3XL: '6',
      //   freeStrawberry: true,
      //   freeKingOfWing: true,
      //   // labelAmount: [],
      //   amount: '0',
      //   // labelTerm: [],
      //   signatureRight: 'leader1',
      //   signAtRight: 'date1'
      //   // labelTerm2: [],
      //   signature: 'leader1',
      //   signAt: 'date1'
      // },
      attributes: {
        name: {
          title: 'Team Name',
          column: 'is-6'
        },
        leader: {
          title: 'Team Leader',
          column: 'is-6'
        },
        members: {
          // type: 'dropdown',
          title: 'Number of Team Members',
          // options: [
          //   { value: undefined,
          //     title: 'Number of Team Members' },
          //   { value: 1, title: '1' },
          //   { value: 2, title: '2' },
          //   { value: 3, title: '3' },
          //   { value: 4, title: '4' },
          //   { value: 5, title: '5' },
          //   { value: 6, title: '6' },
          //   { value: 7, title: '7' },
          //   { value: 8, title: '8' },
          //   { value: 9, title: '9' }
          // ],
          note: '* Please include $10 per team member in excess of four (include Team Leader in this count). Team wristbands will be distributed on site before gates open.'
        },
        memberNames: {
          title: 'Team Member Names',
          note: '* Please fill in the names separated by commas, including the Team Leader’s Name.'
        },
        kcbsNumber: {
          title: 'KCBS Team Number'
        },
        email: {
          title: 'Email'
        },
        // address: {
        //   type: 'textarea',
        //   title: 'Address',
        //   curLength: 0,
        //   maxLength: 500
        // },
        address: {
          title: 'Address 1'
        },
        address2: {
          title: 'Address 2'
        },
        city: {
          title: 'City',
          column: 'is-6'
        },
        state: {
          title: 'State',
          column: 'is-6'
        },
        zip: {
          title: 'Zip Code',
          column: 'is-6'
        },
        county: {
          title: 'County',
          column: 'is-6'
        },
        phone: {
          title: 'Primary Phone',
          column: 'is-6'
        },
        phone2: {
          title: 'Secondary Phone',
          column: 'is-6'
        },
        // sellBbq: {
        //   type: 'dropdown',
        //   title: 'Sell BBQ',
        //   options: [{
        //     value: undefined,
        //     title: 'Do you plan on selling BBQ? It\'s FREE y\'all!'
        //   }, {
        //     value: 1,
        //     title: 'YES'
        //   }, {
        //     value: 2,
        //     title: 'NO'
        //   }]
        // },
        bbq: {
          type: 'radio',
          title: 'Do you plan on selling BBQ? It\'s FREE y\'all! (If you sell BBQ, you keep all of the money!)',
          options: [{
            value: 1,
            title: 'YES'
          }, {
            value: 2,
            title: 'NO'
          }]
          // note: `* COVID-19 RESTRICTIONS (i.e., masks & gloves required) | Must follow “Emergency Addendum to KCBS Sanctioning Agreement,” attached at bottom of application`,
          // noteStyle: {
          //   marginLeft: '24px'
          // }
        },
        power: {
          type: 'radio',
          title: 'Power (please specify)',
          options: [{
            value: 1,
            title: 'None'
          }, {
            value: 2,
            title: '20 amp 120 volt (Standard receptacle)'
          }, {
            value: 3,
            title: '30 amp 120 volt (RV receptacle)'
          }],
          onChecked: function onChecked(value) {
            console.log(value);
          }
        },
        labelCheck: {
          type: 'label',
          title: 'Check all that apply:'
        },
        competition2: {
          type: 'radio',
          title: 'Competition',
          options: [{
            value: 2,
            title: '$300 KCBS Competition Only'
          }]
          // note: `* COVID-19 RESTRICTIONS (i.e., masks & gloves required) | Must follow “Emergency Addendum to KCBS Sanctioning Agreement,” attached at bottom of application`,
          // noteStyle: {
          //   marginLeft: '24px'
          // }
        },
        competition: {
          type: 'radio',
          title: 'Competition',
          titleHidden: true,
          options: [{
            value: 1,
            title: '$225 KCBS Competition & People\'s Choice Competition'
          }]
          // note: '<b>NEW:</b> you scratch our backs, we scratch yours &#9786; People\'s Choice Participants can now rank their <b>TOP 5</b> most desired site location numbers according to the Event Map below, & we will assure you get 1 of the 5:',
          // note: `* COVID-19 RESTRICTIONS (i.e., masks & gloves required) | Must follow “Emergency Addendum to KCBS Sanctioning Agreement,” attached at bottom of application`,
          // noteStyle: {
          //   marginLeft: '24px'
          // }
        },
        labelTopNote: {
          type: 'label',
          column: 'is-10',
          // note: '<b>NOTE: There will be 1st & 2nd Places awarded to 2 Hometown Teams and 2 Out-of-Town Teams.</b><br />Ticket holders will get 4 voting chips, which must be used to vote for 2 different Hometown Teams and 2 different Out-of-Town Teams. The voting process will be strictly monitored. Which cash prizes will be awarded, this portion of the Cook-Off is intended to be a fun, casual time for sponsors, judges and general public to interact with team members. This contest is a huge draw for our community, and in order for The Boss to remain successful, we are asking for your support and participation! Click <a href="/schedule?anchor=peoples-choice-competition" style="text-decoration:underline;" target="_blank">here</a> for more details.'
          note: '<b>So how does People’s Choice Competition work?? There will be 1st, 2nd, & 3rd Places awarded for this Competition.</b><br />Ticket holders will get 3 voting chips, which must be used to vote for 3 different teams—the voting process will be strictly monitored. Cash prizes will be awarded. This portion of the Cook-Off is intended to be a fun, casual time for sponsors, judges and general public to interact with team members & sample some of the best BBQ around! This contest is a huge draw for our community, and in order for The Boss to remain successful, we are asking for your support and participation! Click <a href="/schedule?anchor=peoples-choice-competition" style="text-decoration:underline;" target="_blank">here</a> for more details.'
        },
        labelCompetition: {
          type: 'label',
          note: 'As a THANK YOU, <b>People\'s Choice Participants can now rank their TOP 5 most desired site location numbers</b> according to the Event Map below, & we will assure you get 1 of the 5 (* must choose 3 from one side of the field & 2 from the other side [left side is 1-18 & right side is 19-42] AND must list all 5 locations to receive this perk!)',
          noteStyle: {
            fontSize: '0.9em'
          }
        },
        topDesiredLocation: {
          type: 'label',
          title: 'Top 5 Desired Site Location (Available for People\'s Choice Participants Only!)',
          column: 'is-10'
        },
        topMap: {
          type: 'image',
          link: __WEBPACK_IMPORTED_MODULE_11__assets_map_png___default.a,
          onClick: function onClick() {
            _this.onSelectMarkerAll();
          },
          title: '(click to select locations)',
          column: 'is-8'
        },
        top1: {
          title: '1st',
          column: 'is-10',
          disabled: true,
          type: 'button',
          onClick: function onClick(item, model) {
            _this.onSelectMarker(item);
          }
        },
        top2: {
          title: '2nd',
          column: 'is-10',
          disabled: true,
          type: 'button',
          onClick: function onClick(item, model) {
            _this.onSelectMarker(item);
          }
        },
        top3: {
          title: '3rd',
          column: 'is-10',
          disabled: true,
          type: 'button',
          onClick: function onClick(item, model) {
            _this.onSelectMarker(item);
          }
        },
        top4: {
          title: '4th',
          column: 'is-10',
          disabled: true,
          type: 'button',
          onClick: function onClick(item, model) {
            _this.onSelectMarker(item);
          }
        },
        top5: {
          title: '5th',
          column: 'is-10',
          disabled: true,
          type: 'button',
          onClick: function onClick(item, model) {
            _this.onSelectMarker(item);
          }
          // note: '<b>NOTE: There will be 1st & 2nd Places awarded to 2 Hometown Teams and 2 Out-of-Town Teams.</b><br />Ticket holders will get 4 voting chips, which must be used to vote for 2 different Hometown Teams and 2 different Out-of-Town Teams. The voting process will be strictly monitored. Which cash prizes will be awarded, this portion of the Cook-Off is intended to be a fun, casual time for sponsors, judges and general public to interact with team members. This contest is a huge draw for our community, and in order for The Boss to remain successful, we are asking for your support and participation! See the details below.'
        },
        volunteer: {
          disabled: true,
          column: 'is-10',
          type: 'radio',
          title: 'Volunteer * for People’s Choice Competition (Saturday, 11AM-2PM)',
          options: [{
            value: 1,
            title: 'Yes, I want a volunteer.'
          }, {
            value: 2,
            title: 'No, I want to provide my own volunteer.'
          }]
        },
        labelVolunteer: {
          type: 'label',
          column: 'is-10',
          // note: '<b>NOTE:</b> If participating in the People’s Choice Competition, D.O.O.R. will provide a volunteer & paper goods to distribute to the public throughout the tasting and voting times.  However, if you have a team member who would like to do this please indicate below. *'
          note: '<b>NOTE:</b> If participating in People’s Choice Competition, D.O.O.R. will provide paper goods & a volunteer (*IF indicated above) to distribute samples to the public during the tasting/voting times (11AM-2PM).  IF you have a Team Member who is able to do this then please indicate by choosing “No, I want to provide my own volunteer.”<br /><br />If you choose “Yes, I want a volunteer.” then you must provide shade for the volunteer (i.e., tent, canopy, etc.).  All participating teams must provide their own table.'
        },
        // labelVolunteerYes: {
        //   type: 'label',
        //   column: 'is-10',
        //   note: '<b>NOTE:</b> If you select Yes I would like a volunteer, you must provide a table and shade for the volunteer. *'
        // },
        tshirt: {
          type: 'radio',
          title: 'T-Shirt Pre Order',
          options: [{
            value: 1,
            title: 'YES'
          }, {
            value: 2,
            title: 'NO'
          }],
          // withDefault: true,
          note: '$15 per shirt, please list the quantity next to the sizes below (2XL and 3XL are preorder only).'
        },
        tshirtS: {
          title: 'S',
          column: 'is-5',
          disabled: true
        },
        tshirtM: {
          title: 'M',
          column: 'is-5',
          disabled: true
        },
        tshirtL: {
          title: 'L',
          column: 'is-5',
          disabled: true
        },
        tshirtXL: {
          title: 'XL',
          column: 'is-5',
          disabled: true
        },
        tshirt2XL: {
          title: '2XL',
          column: 'is-5',
          disabled: true
        },
        tshirt3XL: {
          title: '3XL',
          column: 'is-5',
          disabled: true
        },
        freeStrawberry: {
          type: 'checkbox',
          title: 'FREE Anything Strawberry Competition',
          options: [],
          withDefault: true,
          note: '$600 purse! See <a href="/schedule?anchor=anything-strawberry-competition" target="_blank" style="border-bottom:1px solid black;">Events & Schedule</a> for more details.<br />'
          // `<div style="margin-top:6px;">* COVID-19 RESTRICTIONS (i.e., masks & gloves required) | Must follow “Emergency Addendum to KCBS Sanctioning Agreement,” attached at bottom of application</div>`
        },
        freeKingOfWing: {
          type: 'checkbox',
          title: 'FREE King of the Wing Competition (wings provided)',
          options: [],
          withDefault: true,
          note: '$1500 purse! See <a href="/schedule?anchor=king-of-the-wing" target="_blank" style="border-bottom:1px solid black;">Events & Schedule</a> for more details.<br />Participating teams will receive a custom Boss Hog Cook-Off gift in an effort to encourage team participation.<br />This Competition entertains our largest sponsorship level, so the more participants the better.<br />'
          // `<div style="margin-top:6px;">* COVID-19 RESTRICTIONS (i.e., masks & gloves required) | Must follow “Emergency Addendum to KCBS Sanctioning Agreement,” attached at bottom of application</div>`
        },
        labelAmount: {
          type: 'label',
          title: 'Total Amount Due:'
        },
        amount: {
          title: 'Amount',
          disabled: true,
          column: 'is-4'
        },
        labelAmountTerm: {
          type: 'label',
          note: '<p><b>Note:</b> Your online team application submission does NOT guarantee your selection and/or placement for the ' + __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */].info.xth + ' Annual Boss Hog Cook-Off.  The BOSS must receive your payment in order to be entered into the ' + __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */].info.year + ' competition.</p>' + '<p style="margin-top:5px;margin-bottom:5px;">Once your payment has been received, you will be notified by the BOSS to confirm your entry.  Email confirmation for the application submission will be sent upon completion.</p>' + '<p style="margin-top:5px;margin-bottom:5px;">TWO Payment Options Available: VENMO & CHECK.</p>' + '<p style="margin-left:30px;margin-top:5px;margin-bottom:5px;">PAY BY VENMO:</p>' + '<p style="margin-left:30px;margin-top:5px;margin-bottom:5px;"><ul style="display:block;margin:0;margin-left:60px;"><li>please add a $6 convenience fee to your total and send to @DOORwaynesboroGA</li></ul></p>' + '<p style="margin-left:30px;margin-top:5px;margin-bottom:5px;">PAY BY CHECK:</p>' + '<p style="margin-left:30px;margin-top:5px;margin-bottom:5px;"><ul style="display:block;margin:0;margin-left:60px;"><li>Make checks payable to D.O.O.R.</li><li>Mail your check to:</br>D.O.O.R.</br>ATTN: Nan Lynch & Lindsey Beazley Keller</br>P.O. Box 647</br>Waynesboro, GA 30830.</li></ul></p>'
        },
        labelTerm: {
          type: 'label',
          note: '<b>Conditions:</b> <b><u>The Boss Hog Cook-Off Committee reserves the right to reject any application. If your application is not accepted, your money will be refunded. However, no refunds of the application fee will be made once you have been accepted into the contest.</u></b>'
        },
        signatureRight: {
          title: 'Team Leader\'s Name',
          column: 'is-6'
          // note: '* By typing your name, you agree to the above.<br />' +
          // `* By typing your name and submitting this Team A pplication, you agree to the above and agree to follow all of the COVID-19 restrictions & regulations stated in the “Emergency Addendum to KCBS Sanctioning Agreement” attached above.`
        },
        signAtRight: {
          title: 'Date',
          column: 'is-6',
          disabled: true
        },
        labelTerm2: {
          type: 'label',
          note: '<b>Conditions:</b> Any photographs or videos taken of your team on-site become the property of D.O.O.R. and may be used for promotional purposes. ' + 'By signing the application, contestants agree to indemnify and hold D.O.O.R., the Boss Hog Committee, the City of Waynesboro, Mr. Golf Carts Inc., and all employees, agents and volunteers, harmless from any and all claims made against same; including without limitation, all costs, liabilities, judgments, expenses, damages or reasonable attorneys’ fees, arising out of, or in connection with; (1) any structure erected by Contestant; (2) any apparatus, equipment or personal property used by Contestant; (3) any act or omission to act of Contestant, its agents, invitees, participants, representatives, employees, servants, and assigns; and (4) any claims made on account or resulting from contestants participating in the contest.<br />' + '<b>Participant’s Agreement:</b> The undersigned agrees that he/she will be responsible for any loss or damage to his/her work during Boss Hog. He/She agrees to abide by all rules as set forth by Boss Hog and <a href="static/rules.pdf" target="_blank"><b>KCBS</b></a>. My signature below and enclosed amount due/mailed payment indicate that I understand that failure to abide by these rules and regulations may result in the termination of my contract and my participation in future events with D.O.O.R. This is a rain or shine festival, and no refund will be given due to weather.<br />' + '<b>Parking Agreement:</b> ONLY ONE VEHICLE ALLOWED PER TEAM COOK SITE.  Due to the overwhelming growth of our event, we need as much parking for patrons as possible.  Therefore, any vehicle OR trailer in excess of ONE must park in the designated area.  Parking Passes will be given for the team vehicles to be placed in the front window – towing will be enforced at the owner’s expense.  Thank you for understanding!'
          // `<div style="margin-top:12px;"><a href="/static/kcbs_covid-19_regulations.pdf" target="_blank" style="font-weight:bold;"><i class="fa fa-file-o" style="font-size:1.5em;"></i>&nbsp;&nbsp;EMERGENCY ADDENDUM TO KCBS SANCTIONING AGREEMENT.PDF</a></div>`
        },
        signature: {
          title: 'Team Leader\'s Name',
          column: 'is-6'
          // note: '* By typing your name, you agree to the above.<br />' +
          // `* By typing your name and submitting this Team A pplication, you agree to the above and agree to follow all of the COVID-19 restrictions & regulations stated in the “Emergency Addendum to KCBS Sanctioning Agreement” attached above.`
        },
        signAt: {
          title: 'Date',
          column: 'is-6',
          disabled: true
        },
        signNote: {
          null: true,
          title: 'Note',
          column: 'is-12',
          note: '* By typing your name, you agree to the above. <b><u>NOTE: no refunds of the application fee will be made once you have been accepted into the contest under any circumstances.</u></b><br />' + '* By typing your name and submitting this Team Application, you agree to the above and agree to follow all of the COVID-19 restrictions & regulations enforced locally as well as any KCBS guidelines/addendums that may arise.'
        }
      },
      // captcha: '',
      // captchaImage: undefined,
      // session: '',
      feedback: false,
      loading: false,
      navEmail: __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */]._data._navEmail
    };
  },
  validations: {
    models: {
      recaptcha: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
      name: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
      leader: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
      members: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"], numeric: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["numeric"], between: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["between"])(1, 100) },
      memberNames: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
      kcbsNumber: {},
      // address: { required, maxLength: maxLength(500) },
      address: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"], maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(500) },
      address2: { maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(500) },
      city: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"], maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(191) },
      state: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"], maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(191) },
      zip: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"], maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["maxLength"])(191) },
      county: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
      email: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["email"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["minLength"])(4) },
      phone: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
      phone2: {},
      // sellBbq: { required },
      bbq: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
      power: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
        // required_custom: validateArrayRequired,
        // either_custom: validateArrayOneNoneOrTwoThreeFour
      },
      labelCheck: {}, // label
      labelVolunteer: {},
      volunteer: {
        required_custom: function required_custom(value) {
          if (this.models.competition === undefined || this.models.competition === false) {
            return true;
          }
          return this.models.volunteer !== undefined && this.models.volunteer !== 0;
        }
      },
      // labelVolunteerYes: {},
      competition: {
        required_custom: function required_custom(value) {
          return validateEitherOr(value, this.models.competition2);
        }
      },
      labelCompetition: {},
      competition2: {
        required_custom: function required_custom(value) {
          return validateEitherOr(value, this.models.competition);
        }
      },
      topDesiredLocation: {},
      topMap: {},
      top1: { numeric: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["numeric"],
        between: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["between"])(1, 42),
        either_custom: function either_custom(value) {
          return validateUnique(value, this.models.top2, this.models.top3, this.models.top4, this.models.top5);
        }
      },
      top2: { numeric: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["numeric"],
        between: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["between"])(1, 42),
        either_custom: function either_custom(value) {
          return validateUnique(value, this.models.top1, this.models.top3, this.models.top4, this.models.top5);
        }
      },
      top3: { numeric: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["numeric"],
        between: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["between"])(1, 42),
        either_custom: function either_custom(value) {
          return validateUnique(value, this.models.top1, this.models.top2, this.models.top4, this.models.top5);
        }
      },
      top4: { numeric: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["numeric"],
        between: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["between"])(1, 42),
        either_custom: function either_custom(value) {
          return validateUnique(value, this.models.top1, this.models.top2, this.models.top3, this.models.top5);
        }
      },
      top5: { numeric: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["numeric"],
        between: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["between"])(1, 42),
        either_custom: function either_custom(value) {
          return validateUnique(value, this.models.top1, this.models.top2, this.models.top3, this.models.top4);
        }
      },
      labelTopNote: {},
      tshirt: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
      tshirtS: { numeric: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["numeric"],
        required_custom: function required_custom(value) {
          if (this.models.tshirt !== 1) {
            return true;
          }
          var tshirts = addAllValues(this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL);
          console.log('total: ' + tshirts);
          if (tshirts > 0) {
            return true;
          }
          return false;
        }
      },
      tshirtM: { numeric: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["numeric"],
        required_custom: function required_custom(value) {
          if (this.models.tshirt !== 1) {
            return true;
          }
          var tshirts = addAllValues(this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL);
          return tshirts > 0;
        }
      },
      tshirtL: { numeric: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["numeric"],
        required_custom: function required_custom(value) {
          if (this.models.tshirt !== 1) {
            return true;
          }
          var tshirts = addAllValues(this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL);
          return tshirts > 0;
        }
      },
      tshirtXL: { numeric: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["numeric"],
        required_custom: function required_custom(value) {
          if (this.models.tshirt !== 1) {
            return true;
          }
          var tshirts = addAllValues(this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL);
          return tshirts > 0;
        }
      },
      tshirt2XL: { numeric: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["numeric"],
        required_custom: function required_custom(value) {
          if (this.models.tshirt !== 1) {
            return true;
          }
          var tshirts = addAllValues(this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL);
          return tshirts > 0;
        }
      },
      tshirt3XL: { numeric: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["numeric"],
        required_custom: function required_custom(value) {
          if (this.models.tshirt !== 1) {
            return true;
          }
          var tshirts = addAllValues(this.models.tshirtS, this.models.tshirtM, this.models.tshirtL, this.models.tshirtXL, this.models.tshirt2XL, this.models.tshirt3XL);
          return tshirts > 0;
        }
      },
      freeStrawberry: {},
      freeKingOfWing: {},
      labelAmount: {}, // label
      amount: {},
      labelAmountTerm: {}, // label
      labelTerm: {}, // label
      signatureRight: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
      signAtRight: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
      labelTerm2: {}, // label
      signature: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
      signAt: { required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"] },
      signNote: {}
    }
  },
  created: function created() {
    // console.log('-- creating... --')
    // console.log(this.$v)
    // console.log(this.models)
    // this.init()
  },
  mounted: function mounted() {
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    this.onUpdateMap(__WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */]._windowWidth);
    __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */].$on('windowWidthChanged', function () {
      this.onUpdateMap(__WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */]._windowWidth);
    }.bind(this));

    // this.onRecaptcha(data => {
    //   // console.log('recaptcha data!')
    //   this.captchaImage = data.data
    //   this.session = data.id
    // })

    if (this.isPrint) {
      this.attributes.topMap.column = 'is-10';
    } else {
      this.attributes.topMap.column = 'is-8';
    }

    if (this.isPrint) {
      this.models.signAt = '';
      this.models.signAtRight = '';
    } else {
      this.models.signAt = __WEBPACK_IMPORTED_MODULE_10_moment___default()(new Date()).format();
      this.models.signAtRight = __WEBPACK_IMPORTED_MODULE_10_moment___default()(new Date()).format();
    }

    // console.log('-- mounting... --')
    // console.log(this.$v)
    this.onLoad();
  },
  methods: {
    onLoad: function onLoad() {
      var _this2 = this;

      this.markerDisabledList = [];
      __WEBPACK_IMPORTED_MODULE_9__apis_Site__["a" /* default */].signUpApproved().then(function (data) {
        // console.log('-- approved')
        // console.log(data)
        for (var i in _this2.markerList) {
          var marker = _this2.markerList[i];
          var locationIndex = parseInt(marker.text, 10);
          // 0 = disabled
          // 1 = enabled
          // 2 = selected
          marker.state = 1; // all enabled

          var state = 1;
          var approved = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(data, { admin_location: locationIndex });
          if (approved && (typeof approved === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(approved)) === 'object') {
            state = 0;
          }
          _this2.markerDisabledList.push({
            text: marker.text,
            state: state
          });
        }
        _this2.onUpdateMapMarkers();
      }).catch(function (error) {
        console.error(error);
      });
    },

    onUpdateMapMarkers: function onUpdateMapMarkers() {
      for (var i in this.markerList) {
        var marker = this.markerList[i];
        var state = 0; // disabled
        var markerDisabled = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.markerDisabledList, { text: marker.text });
        // console.log(markerDisabled)
        if (markerDisabled && markerDisabled.hasOwnProperty('state')) {
          state = markerDisabled.state;
        }
        marker.textSelected = '';
        var spots = ['top1', 'top2', 'top3', 'top4', 'top5'];
        for (var s in spots) {
          var spot = spots[s];
          if (this.models[spot] + '' === marker.text) {
            state = 2; // selected
            marker.textSelected = '(' + this.attributes[spot].title + ' location)';
          }
        }
        marker.state = state;
      }
    },

    onUpdateMap: function onUpdateMap(windowWidth) {
      for (var i in this.markerList) {
        var marker = this.markerList[i];
        if (windowWidth > 1024) {
          marker.top = marker.topRatio * 720 / 100 + 27 + 'px';
          this.markerHeight = 4 * 720 / 100 + 'px';
        } else {
          if (this.$refs.mapRef) {
            // console.log(this.$refs.mapRef.width + ', ' + this.$refs.mapRef.height)
            marker.top = marker.topRatio * this.$refs.mapRef.height / 100 + 27 + 'px';
            this.markerHeight = 4 * 720 / 100 + 'px';
          } else {
            marker.top = marker.topRatio + '%';
            this.markerHeight = '4%';
          }
        }
      }

      if (windowWidth > 1024) {
        this.markerClear.top = this.markerClear.topRatio * 720 / 100 + 'px';
      } else {
        if (this.$refs.mapRef) {
          this.markerClear.top = this.markerClear.topRatio * 720 / 100 + 'px';
        } else {
          this.markerClear.top = this.markerClear.topRatio + '%';
        }
      }
    },

    calculateTotal: function calculateTotal(competition, competition2, members, tshirtS, tshirtM, tshirtL, tshirtXL, tshirt2XL, tshirt3XL) {
      var PRICE_TSHIRT = 15;
      this.models.amount = 0;
      if (competition) {
        this.models.amount += 225;
      }
      if (competition2) {
        this.models.amount += 300; // 275
      }
      if (tshirtS > 0) {
        this.models.amount += tshirtS * PRICE_TSHIRT;
      }
      if (tshirtM > 0) {
        this.models.amount += tshirtM * PRICE_TSHIRT;
      }
      if (tshirtL > 0) {
        this.models.amount += tshirtL * PRICE_TSHIRT;
      }
      if (tshirtXL > 0) {
        this.models.amount += tshirtXL * PRICE_TSHIRT;
      }
      if (tshirt2XL > 0) {
        this.models.amount += tshirt2XL * PRICE_TSHIRT;
      }
      if (tshirt3XL > 0) {
        this.models.amount += tshirt3XL * PRICE_TSHIRT;
      }
      if (members && members.length > 0 && !isNaN(parseInt(members, 10))) {
        var total = parseInt(members, 10);
        if (total > 4) {
          this.models.amount += (total - 4) * 10;
        }
      }
    },

    onRecaptcha: function onRecaptcha(info) {
      if (info && info.status) {
        this.models.recaptcha = info.status === 'ok' ? info.response : undefined;
        if (info.status !== 'ok') {
          console.log('FormDynamix:recaptcha():' + info.status);
        }
      }
    },

    onSelectMarkerAll: function onSelectMarkerAll() {
      if (this.models.competition !== 1) {
        return;
      }
      this.markerCurrent = undefined;
      this.isMapModalActive = true;
      this.$nextTick(function () {
        // console.log('-- refs --')
        // console.log(this.$refs.mapRef)
        this.onUpdateMap(__WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */]._windowWidth);
      });
    },

    onSelectMarker: function onSelectMarker(item) {
      if (this.models.competition !== 1) {
        return;
      }
      this.markerCurrent = item;
      this.isMapModalActive = true;
      this.$nextTick(function () {
        // console.log('-- refs --')
        // console.log(this.$refs.mapRef)
        this.onUpdateMap(__WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */]._windowWidth);
      });
    },

    getAvailableSpot: function getAvailableSpot() {
      var spots = ['top1', 'top2', 'top3', 'top4', 'top5'];
      for (var s in spots) {
        var spot = spots[s];
        // console.log('spot: ' + s + ', ' + this.models[spot] + ' = ' + this.models[spot].length)
        if (this.models[spot] === undefined || typeof this.models[spot] === 'string' && this.models[spot].length <= 0) {
          return spot;
        }
      }
      return undefined;
    },

    onResetMapMarker: function onResetMapMarker() {
      var spots = ['top1', 'top2', 'top3', 'top4', 'top5'];
      for (var s in spots) {
        var spot = spots[s];
        this.models[spot] = '';
      }
      this.onUpdateMapMarkers();
    },

    onProceed: function onProceed() {
      this.markerCurrent = undefined;
      this.isMapModalActive = false;
      this.$nextTick(function () {
        this.onUpdateMap(__WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */]._windowWidth);
      });
    },

    onClickMapMarker: function onClickMapMarker(marker) {
      // if (!this.markerCurrent) {
      //   console.error('something is wrong', marker)
      //   return
      // }

      if (marker.state !== 1) {
        // only can choose state enabled
        if (marker.state === 0) {
          this.$toast.open({
            duration: 2000,
            message: 'Location not available.',
            position: 'is-top',
            type: 'is-danger'
          });
        }
        return;
      }

      if (!this.markerCurrent) {
        var spot = this.getAvailableSpot();
        if (!spot) {
          console.error('all 5 locations selected');
          this.$toast.open({
            duration: 2000,
            message: 'All 5 locations selected, please kindly reset or proceed with the selections.',
            position: 'is-top',
            type: 'is-warning'
          });
          return;
        }

        this.models[spot] = marker.text;
        this.onUpdateMapMarkers();
        return;
      }

      // console.log('market text is: ' + marker.text)
      this.models[this.markerCurrent.name] = marker.text;
      // this.isMapModalActive = false
      this.onUpdateMapMarkers();
    },

    onClear: function onClear() {
      // this.models.recaptcha = undefined
      this.models.name = '';
      this.models.leader = '';
      this.models.members = '';
      this.models.memberNames = '';
      this.models.kcbsNumber = '';
      this.models.address = '';
      this.models.address2 = '';
      this.models.city = '';
      this.models.state = '';
      this.models.zip = '';
      this.models.county = '';
      this.models.email = '';
      this.models.phone = '';
      this.models.phone2 = '';
      // this.models.sellBbq = undefined
      this.models.bbq = undefined;
      this.models.power = undefined;
      this.models.volunteer = 0;
      this.models.competition = 0;
      this.models.competition2 = 0;
      // this.models.topDesiredLocation = []
      this.models.top1 = '';
      this.models.top2 = '';
      this.models.top3 = '';
      this.models.top4 = '';
      this.models.top5 = '';
      this.models.tshirt = false;
      this.models.tshirtS = '';
      this.models.tshirtM = '';
      this.models.tshirtL = '';
      this.models.tshirtXL = '';
      this.models.tshirt2XL = '';
      this.models.tshirt3XL = '';
      this.models.freeStrawberry = false;
      this.models.freeKingOfWing = false;
      // this.models.labelAmount = ''
      this.models.amount = '0';
      // this.models.labelAmountTerm = ''
      // this.models.labelTerm = ''
      this.models.signatureRight = '';
      this.models.signAtRight = __WEBPACK_IMPORTED_MODULE_10_moment___default()(new Date()).format();
      // this.models.labelTerm2 = ''
      this.models.signature = '';
      this.models.signAt = __WEBPACK_IMPORTED_MODULE_10_moment___default()(new Date()).format();
    },

    onSendDisabled: function onSendDisabled() {
      var _self = this;
      _self.feedback = 'We are sorry, team application is not open yet.';
      return;
    },

    onSend: function onSend(formInfo) {
      var _this3 = this;

      // $v.models.$touch()
      var _self = this;
      console.log('SignUpTeamSection:onSend(): $v / models');
      console.log(formInfo);

      // var models = formInfo.models
      if (formInfo.vuelidate.$invalid) {
        _self.feedback = 'Form contains errors, please recheck.';
        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Please fill in all fields to proceed.',
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
        return;
      }

      if (!this.models.recaptcha) {
        _self.feedback = 'Invalid recaptcha, please validate again.';
        return;
      }
      _self.feedback = false;

      var models = formInfo.models;

      // competition
      var competition = 0;
      if (models.competition && !models.competition2) {
        competition = 1;
      } else if (!models.competition && models.competition2) {
        competition = 2;
      } else if (models.competition && models.competition2) {
        competition = -1;
      }

      // locations
      var locations = [];
      locations.push(models.top1 ? models.top1 : '');
      locations.push(models.top2 ? models.top2 : '');
      locations.push(models.top3 ? models.top3 : '');
      locations.push(models.top4 ? models.top4 : '');
      locations.push(models.top5 ? models.top5 : '');

      // tshirts
      var tshirts = {};
      tshirts.s = models.tshirtS ? models.tshirtS : 0;
      tshirts.m = models.tshirtM ? models.tshirtM : 0;
      tshirts.l = models.tshirtL ? models.tshirtL : 0;
      tshirts.xl = models.tshirtXL ? models.tshirtXL : 0;
      tshirts.x2l = models.tshirt2XL ? models.tshirt2XL : 0;
      tshirts.x3l = models.tshirt3XL ? models.tshirt3XL : 0;

      console.log('-- send form --');
      console.log(models);
      // console.log(models.name)
      // console.log(models.leader)
      // console.log(models.members)
      // console.log(models.address)
      // console.log(models.address2)
      // console.log(models.city)
      // console.log(models.state)
      // console.log(models.zip)
      // console.log(models.county)
      // console.log(models.email)
      // console.log(models.phone)
      // console.log(models.phone2)
      // console.log(models.bbq)
      // console.log(models.power)
      // console.log(competition)
      // console.log(locations)
      // console.log(models.tshirt)
      // console.log(tshirts)
      // console.log(models.freeStrawberry)
      // console.log(models.freeKingOfWing)
      // console.log(models.signatureRight)
      // console.log(models.signAtRight)
      // console.log(models.signature)
      // console.log(models.signAt)
      // console.log(models.amount)

      // if (formInfo) {
      //   return
      // }

      _self.loading = true;
      __WEBPACK_IMPORTED_MODULE_9__apis_Site__["a" /* default */].signUpTeam(models.recaptcha, models.name, models.leader, models.members, models.memberNames, models.kcbsNumber, models.address, models.address2, models.city, models.state, models.zip, models.county, models.email, models.phone, models.phone2, models.bbq, // 1 = yes, 2 = no
      models.power, // 1 = none, 2 = 20 amp, 3 = 30 amp
      models.volunteer, competition, // 1 = kcbs & people's choice, 2 = kcbs
      locations, // 5 numerics
      models.tshirt, tshirts, // 6 types
      models.freeStrawberry, models.freeKingOfWing, models.signatureRight, models.signAtRight, models.signature, models.signAt, models.amount).then(function (data) {
        _self.loading = false;

        // invalid captcha
        if (data && data.status === 'invalid_session') {
          _self.feedback = 'Invalid session, please kindly refresh and try again.';
          return;
        }

        // invalid captcha
        if (data && data.status === 'invalid_captcha') {
          _self.feedback = 'Invalid captcha, please re-type again.';
          return;
        }

        if (data && data.status !== 'ok') {
          _self.feedback = 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail;
          return;
        }

        _this3.$v.models.$reset();
        _this3.onClear();

        // _self.captcha = ''
        // _self.session = '' // open up to maintain session

        // _self.$toast.open({
        //   message: 'We will be contacting you via email or phone. Thanks!',
        //   position: 'is-bottom',
        //   type: 'is-success'
        // })
        _self.feedback = 'Your application has been successfully submitted. You will receive a confirmation email within the next 48 hours.';
      }).catch(function (error) {
        console.log('invalid email', error);
        // this.error = error.error
        console.log(error);
        // _self.captcha = ''

        // invalid captcha
        if (error && error.status === 'invalid_session') {
          _self.feedback = 'Invalid session, please kindly refresh and try again.';
          _self.loading = false;
          return;
        }

        // invalid captcha
        if (error && error.status === 'invalid_captcha') {
          _self.feedback = 'Invalid captcha, please retype again.';
          _self.loading = false;
          return;
        }

        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail,
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
        _self.feedback = 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail;
        _self.loading = false;
      });
    }
  }
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageHeader__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PageSubheader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PageSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_PageSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TopSubpageSection__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TopSubpageSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_TopSubpageSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SponsorsSubSection__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SponsorsSubSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SponsorsSubSection__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sponsors',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_2__components_DivContainer___default.a,
    PageHeader: __WEBPACK_IMPORTED_MODULE_3__components_PageHeader___default.a,
    PageSubheader: __WEBPACK_IMPORTED_MODULE_4__components_PageSubheader___default.a,
    TopSubpageSection: __WEBPACK_IMPORTED_MODULE_5__components_TopSubpageSection___default.a,
    SponsorsSubSection: __WEBPACK_IMPORTED_MODULE_6__SponsorsSubSection___default.a
  },
  data: function data() {
    return {
      subnavs: [{
        route: 'sponsors',
        title: 'Info',
        section: 'sponsors-level-0'
      }],
      // subnavs: [{
      //   route: 'about',
      //   title: 'Official Partners'
      // }, {
      //   route: 'sponsors',
      //   title: 'Sponsors',
      //   section: 'sponsors-level-1'
      // }, {
      //   route: 'sponsors',
      //   title: 'Sponsorship',
      //   section: 'sponsors-level-0'
      // }],
      mnames: ['about-partner-1', 'about-partner-2', 'about-partner-3'],
      mitems: {},
      isDesktop: true,
      // itemsEnded: false,
      scrollPos: 0
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    if (this.$route.query && this.$route.query.anchor) {
      console.log('automatic scroll to...: ' + this.$route.query.anchor);
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor);
      }.bind(this), 1000);
    }

    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_1__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_1__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_1__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    this.refresh();
  },

  methods: {
    onScrollTo: function onScrollTo(name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } });
      } else {
        this.$scrollTo('#' + target, { offset: -30 });
      }
    },


    getMainItem: function getMainItem(mname, onComplete) {
      var _this = this;

      this.loading = true;
      this.error = undefined;
      __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].aboutWithName('bosshog::' + mname).then(function (data) {
        _this.loading = false;
        // console.log(data)
        if (!data) {
          _this.error = 'Unable to load, please kindly refresh the page.';
          return;
        }

        if (onComplete) {
          onComplete(mname, data);
        }
      }).catch(function (error) {
        _this.loading = false;
        _this.error = 'Unable to load, please kindly refresh the page.';
        console.log(error);
      });
    },

    refresh: function refresh() {
      var _this2 = this;

      for (var i = 0; i < this.mnames.length; i++) {
        var mname = this.mnames[i];
        this.getMainItem(mname, function (name, data) {
          var params = {};
          if (data && data.image) {
            params.image = data.image;
            params.link = data.link;
          }
          _this2.$set(_this2.mitems, name, params);
        });
      }
    }
  }
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivContainer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import ShowDown from 'showdown'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'section-sponsors',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default.a
  },
  data: function data() {
    return {
      mnames: ['about-partner-1', 'about-partner-2', 'about-partner-3'],
      mitems: {},
      items: [],
      error: undefined,
      loading: false
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    getMainItem: function getMainItem(mname, onComplete) {
      var _this = this;

      this.loading = true;
      this.error = undefined;
      __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].aboutWithName('bosshog::' + mname).then(function (data) {
        _this.loading = false;
        // console.log(data)
        if (!data) {
          _this.error = 'Unable to load, please kindly refresh the page.';
          return;
        }

        if (onComplete) {
          onComplete(mname, data);
        }
      }).catch(function (error) {
        _this.loading = false;
        _this.error = 'Unable to load, please kindly refresh the page.';
        console.log(error);
      });
    },

    getItems: function getItems(onComplete) {
      var _this2 = this;

      this.loading = true;
      this.error = undefined;
      __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].sponsor(1).then(function (data) {
        _this2.loading = false;
        // console.log(data)
        if (!data) {
          _this2.error = 'Unable to load, please kindly refresh the page.';
          return;
        }

        if (onComplete) {
          onComplete(data);
        }
      }).catch(function (error) {
        _this2.loading = false;
        _this2.error = 'Unable to load, please kindly refresh the page.';
        console.log(error);
      });
    },

    refresh: function refresh() {
      var _this3 = this;

      this.getItems(function (items) {
        _this3.items = items;
      });

      for (var i = 0; i < this.mnames.length; i++) {
        var mname = this.mnames[i];
        this.getMainItem(mname, function (name, data) {
          var params = {};
          if (data && data.image) {
            params.image = data.image;
            params.link = data.link;
          }
          _this3.$set(_this3.mitems, name, params);
        });
      }
    }
  }
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DivColumns__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DivColumns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_DivColumns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PageSubheader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PageSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_PageSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_showdown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_showdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_showdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_showdown_target_blank__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_showdown_target_blank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_showdown_target_blank__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sub-sponsors',
  props: ['level', 'title', 'index', 'is-alt', 'is-limit-content'],
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_2__components_DivContainer___default.a,
    DivColumns: __WEBPACK_IMPORTED_MODULE_3__components_DivColumns___default.a,
    PageSubheader: __WEBPACK_IMPORTED_MODULE_4__components_PageSubheader___default.a
  },
  data: function data() {
    return {
      isDesktop: true,
      paragraph: {
        title: '',
        content: ''
      },
      items: [],
      error: undefined,
      loading: false
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_1__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_1__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_1__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    getItems: function getItems(onComplete) {
      var _this = this;

      this.loading = true;
      this.error = undefined;
      this.paragraph = {
        title: '',
        content: ''
      };
      __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].sponsor(this.level).then(function (data) {
        _this.loading = false;
        // if (this.level === '0') {
        //   console.log(data)
        // }
        if (!data) {
          _this.error = 'Unable to load, please kindly refresh the page.';
          return;
        }

        // in case level 0
        if (_this.level === '0' && _this.index) {
          if (data && data.length > 0 && data[_this.index].description) {
            var converter = new __WEBPACK_IMPORTED_MODULE_5_showdown___default.a.Converter({ extension: ['targetblank'] });
            var html = converter.makeHtml(data[_this.index].description);
            _this.paragraph.content = html;
            _this.items.push(data[0]);

            if (!_this.title) {
              _this.paragraph.title = data[_this.index].title;
            }
          }
          return;
        }

        _this.items = data;
      }).catch(function (error) {
        _this.loading = false;
        _this.error = 'Unable to load, please kindly refresh the page.';
        console.log(error);
      });
    },

    refresh: function refresh() {
      this.getItems();
    }
  }
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TopSubpageSection__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TopSubpageSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_TopSubpageSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TeamsSubSection__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TeamsSubSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TeamsSubSection__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-teams',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default.a,
    PageHeader: __WEBPACK_IMPORTED_MODULE_2__components_PageHeader___default.a,
    TopSubpageSection: __WEBPACK_IMPORTED_MODULE_3__components_TopSubpageSection___default.a,
    TeamsSubSection: __WEBPACK_IMPORTED_MODULE_4__TeamsSubSection___default.a
  },
  data: function data() {
    return {
      isDesktop: true,
      // itemsEnded: false,
      scrollPos: 0
    };
  },

  computed: {
    year: function year() {
      return __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].info.year;
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    if (this.$route.query && this.$route.query.anchor) {
      console.log('automatic scroll to...: ' + this.$route.query.anchor);
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor);
      }.bind(this), 1000);
    }

    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));
  },

  methods: {
    onScrollTo: function onScrollTo(name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } });
      } else {
        this.$scrollTo('#' + target, { offset: 0 });
      }
    }
  }
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageSubheader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PageSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icon_teams_png__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icon_teams_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_icon_teams_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import ShowDown from 'showdown'
// import 'showdown-target-blank'


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sub-teams',
  props: ['title'],
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default.a,
    PageSubheader: __WEBPACK_IMPORTED_MODULE_2__components_PageSubheader___default.a
  },
  data: function data() {
    return {
      competitions: [],
      teams: [],
      filter: undefined,
      error: undefined,
      loading: false
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    getAll: function getAll() {
      var _this = this;

      this.loading = true;
      this.error = undefined;
      __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].competition().then(function (data) {
        _this.loading = false;
        // console.log(data)
        if (!data) {
          _this.error = 'Unable to load, please kindly refresh the page.';
          return __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].team();
        }
        _this.onCompetitionComplete(data);
        return __WEBPACK_IMPORTED_MODULE_0__apis_Site__["a" /* default */].team();
      }).then(function (data) {
        console.log(data);
        if (!data) {
          _this.error = 'Unable to load, please kindly refresh the page.';
          return;
        }
        _this.onTeamComplete(data);
      }).catch(function (error) {
        _this.loading = false;
        _this.error = 'Unable to load, please kindly refresh the page.';
        console.log(error);
      });
    },

    onCompetitionComplete: function onCompetitionComplete(competitions) {
      var allTeam = {
        name: 'All Teams',
        name_slug: 'all-teams',
        image: {
          path: __WEBPACK_IMPORTED_MODULE_3__assets_icon_teams_png___default.a
        }
      };
      competitions = [allTeam].concat(competitions);
      this.competitions = competitions;
    },

    onTeamComplete: function onTeamComplete(teams) {
      // assemble competitions from key into groups
      var teamKeys = [];
      for (var i = 1; i <= 9; i++) {
        teamKeys.push('team_' + i);
      }

      var countAlt = 0;
      for (var j = 0; j < teams.length; j++) {
        var team = teams[j];

        team.hide = false;
        team.isAlt = countAlt % 2 !== 0;
        countAlt++;

        // consolidate competitions for each team
        team.competitions = {};
        for (var k = 0; k < teamKeys.length; k++) {
          var teamKey = teamKeys[k];
          if (team[teamKey]) {
            team.competitions[team[teamKey].name_slug] = team[teamKey];
          }
        }
      }
      this.teams = teams;
    },

    refresh: function refresh() {
      this.getAll();
    },

    onClickTeam: function onClickTeam($event, teamSlug) {
      $event.preventDefault();
      this.filterTeam(teamSlug);
    },

    filterNone: function filterNone() {
      this.filter = undefined;
      var countAlt = 0;
      for (var i = 0; i < this.teams.length; i++) {
        var team = this.teams[i];
        team.hide = false;
        team.isAlt = countAlt % 2 !== 0;
        countAlt++;
      }
    },

    filterTeam: function filterTeam(teamSlug) {
      // toggle to clear (default to all-teams)
      if (this.filter !== undefined && this.filter.length > 0 && this.filter === teamSlug) {
        this.filterNone();
        return;
      }

      // default all filter
      if (!teamSlug) {
        this.filterNone();
        return;
      }

      if (teamSlug === 'all-teams') {
        this.filterNone();
        return;
      }

      // filter based on team slug
      this.filter = teamSlug;
      var countAlt = 0;
      for (var i = 0; i < this.teams.length; i++) {
        var team = this.teams[i];
        if (team.competitions && team.competitions[teamSlug]) {
          team.hide = false;
          team.isAlt = countAlt % 2 !== 0;
          countAlt++;
        } else {
          team.hide = true;
        }
      }
    }
  }
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_Site__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DivColumns__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DivColumns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_DivColumns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PageHeader__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PageSubheader__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PageSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_PageSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_TopSubpageSection__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_TopSubpageSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_TopSubpageSection__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tickets',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_4__components_DivContainer___default.a,
    DivColumns: __WEBPACK_IMPORTED_MODULE_5__components_DivColumns___default.a,
    PageHeader: __WEBPACK_IMPORTED_MODULE_6__components_PageHeader___default.a,
    PageSubheader: __WEBPACK_IMPORTED_MODULE_7__components_PageSubheader___default.a,
    TopSubpageSection: __WEBPACK_IMPORTED_MODULE_8__components_TopSubpageSection___default.a
  },
  data: function data() {
    return {
      subnavs: [{
        // route: 'https://wwwbosshogcookoffcom.ticketleap.com/theboss2021/',
        // route: 'https://wwwbosshogcookoffcom.ticketleap.com/16th-annual-boss-hog-state-championship-cook-off/',
        route: undefined,
        title: 'Tickets'
        // section: 'tickets-sub-section'
      }],
      isDesktop: true,
      // itemsEnded: false,
      scrollPos: 0,
      content1: undefined,
      content2: undefined,
      disabled: true
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data, _data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.$route.query && _this.$route.query.anchor) {
                console.log('automatic scroll to...: ' + _this.$route.query.anchor);
                setTimeout(function () {
                  this.$scrollTo('#' + this.$route.query.anchor);
                }.bind(_this), 1000);
              }

              _this.$set(_this, 'disabled', true);
              _this.$set(_this, 'content1', undefined);
              _this.$set(_this, 'content2', undefined);
              _this.$set(_this.subnavs[0], 'route', undefined);

              _context.prev = 5;
              _context.next = 8;
              return __WEBPACK_IMPORTED_MODULE_2__apis_Site__["a" /* default */].aboutWithName('bosshog::ticket-content');

            case 8:
              data = _context.sent;

              if (data && data.hasOwnProperty('disabled')) {
                _this.$set(_this, 'disabled', data.disabled);
              }
              if (data && data.content) {
                _this.$set(_this, 'content1', data.content);
              }
              if (data && data.link) {
                _this.$set(_this.subnavs[0], 'route', data.link);
              }
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context['catch'](5);

              console.error('load error', _context.t0);

            case 17:
              _context.prev = 17;
              _context.next = 20;
              return __WEBPACK_IMPORTED_MODULE_2__apis_Site__["a" /* default */].aboutWithName('bosshog::ticket-addresses');

            case 20:
              _data = _context.sent;

              if (_data && _data.content) {
                _this.$set(_this, 'content2', _data.content);
              }
              _context.next = 27;
              break;

            case 24:
              _context.prev = 24;
              _context.t1 = _context['catch'](17);

              console.error('load error', _context.t1);

            case 27:

              // on event resize
              _this.isDesktop = __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */]._isDesktop;
              __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
                this.isDesktop = __WEBPACK_IMPORTED_MODULE_3__controllers_EventBus__["a" /* default */]._isDesktop;
              }.bind(_this));

            case 29:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[5, 14], [17, 24]]);
    }))();
  },

  methods: {
    onScrollTo: function onScrollTo(name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } });
      } else {
        this.$scrollTo('#' + target, { offset: -30 });
      }
    }
  }
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controllers_EventBus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivContainer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DivContainer__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'top-countdown',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_2__components_DivContainer___default.a
  },
  props: {
    date: {
      type: String,
      coerce: function coerce(str) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(Date.parse(str) / 1000);
      }
    }
  },
  data: function data() {
    return {
      isDesktop: true,
      // itemsEnded: false,
      scrollPos: 0,
      now: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000)
    };
  },

  computed: {
    dateValue: function dateValue() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(Date.parse(this.date) / 1000);
    },

    seconds: function seconds() {
      if (this.dateValue - this.now < 0) return 0;
      return (this.dateValue - this.now) % 60;
    },
    minutes: function minutes() {
      if (this.dateValue - this.now < 0) return 0;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()((this.dateValue - this.now) / 60) % 60;
    },
    hours: function hours() {
      if (this.dateValue - this.now < 0) return 0;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()((this.dateValue - this.now) / 60 / 60) % 24;
    },
    days: function days() {
      if (this.dateValue - this.now < 0) return 0;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()((this.dateValue - this.now) / 60 / 60 / 24);
    }
  },
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    window.setInterval(function () {
      _this.now = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000);
    }, 1000);

    if (this.$route.query && this.$route.query.anchor) {
      // console.log('automatic scroll to...: ' + this.$route.query.anchor)
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor);
      }.bind(this), 2000);
    }

    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_1__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_1__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_1__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));
  },

  methods: {
    onScrollTo: function onScrollTo(name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } });
      } else {
        this.$scrollTo('#' + target, { offset: -30 });
      }
    }
  }
});

/***/ }),
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 802 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 803 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 807 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 812 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 816 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 817 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 818 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 823 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 825 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 826 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 830 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 833 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 834 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 248,
	"./af.js": 248,
	"./ar": 255,
	"./ar-dz": 249,
	"./ar-dz.js": 249,
	"./ar-kw": 250,
	"./ar-kw.js": 250,
	"./ar-ly": 251,
	"./ar-ly.js": 251,
	"./ar-ma": 252,
	"./ar-ma.js": 252,
	"./ar-sa": 253,
	"./ar-sa.js": 253,
	"./ar-tn": 254,
	"./ar-tn.js": 254,
	"./ar.js": 255,
	"./az": 256,
	"./az.js": 256,
	"./be": 257,
	"./be.js": 257,
	"./bg": 258,
	"./bg.js": 258,
	"./bm": 259,
	"./bm.js": 259,
	"./bn": 261,
	"./bn-bd": 260,
	"./bn-bd.js": 260,
	"./bn.js": 261,
	"./bo": 262,
	"./bo.js": 262,
	"./br": 263,
	"./br.js": 263,
	"./bs": 264,
	"./bs.js": 264,
	"./ca": 265,
	"./ca.js": 265,
	"./cs": 266,
	"./cs.js": 266,
	"./cv": 267,
	"./cv.js": 267,
	"./cy": 268,
	"./cy.js": 268,
	"./da": 269,
	"./da.js": 269,
	"./de": 272,
	"./de-at": 270,
	"./de-at.js": 270,
	"./de-ch": 271,
	"./de-ch.js": 271,
	"./de.js": 272,
	"./dv": 273,
	"./dv.js": 273,
	"./el": 274,
	"./el.js": 274,
	"./en-au": 275,
	"./en-au.js": 275,
	"./en-ca": 276,
	"./en-ca.js": 276,
	"./en-gb": 277,
	"./en-gb.js": 277,
	"./en-ie": 278,
	"./en-ie.js": 278,
	"./en-il": 279,
	"./en-il.js": 279,
	"./en-in": 280,
	"./en-in.js": 280,
	"./en-nz": 281,
	"./en-nz.js": 281,
	"./en-sg": 282,
	"./en-sg.js": 282,
	"./eo": 283,
	"./eo.js": 283,
	"./es": 287,
	"./es-do": 284,
	"./es-do.js": 284,
	"./es-mx": 285,
	"./es-mx.js": 285,
	"./es-us": 286,
	"./es-us.js": 286,
	"./es.js": 287,
	"./et": 288,
	"./et.js": 288,
	"./eu": 289,
	"./eu.js": 289,
	"./fa": 290,
	"./fa.js": 290,
	"./fi": 291,
	"./fi.js": 291,
	"./fil": 292,
	"./fil.js": 292,
	"./fo": 293,
	"./fo.js": 293,
	"./fr": 296,
	"./fr-ca": 294,
	"./fr-ca.js": 294,
	"./fr-ch": 295,
	"./fr-ch.js": 295,
	"./fr.js": 296,
	"./fy": 297,
	"./fy.js": 297,
	"./ga": 298,
	"./ga.js": 298,
	"./gd": 299,
	"./gd.js": 299,
	"./gl": 300,
	"./gl.js": 300,
	"./gom-deva": 301,
	"./gom-deva.js": 301,
	"./gom-latn": 302,
	"./gom-latn.js": 302,
	"./gu": 303,
	"./gu.js": 303,
	"./he": 304,
	"./he.js": 304,
	"./hi": 305,
	"./hi.js": 305,
	"./hr": 306,
	"./hr.js": 306,
	"./hu": 307,
	"./hu.js": 307,
	"./hy-am": 308,
	"./hy-am.js": 308,
	"./id": 309,
	"./id.js": 309,
	"./is": 310,
	"./is.js": 310,
	"./it": 312,
	"./it-ch": 311,
	"./it-ch.js": 311,
	"./it.js": 312,
	"./ja": 313,
	"./ja.js": 313,
	"./jv": 314,
	"./jv.js": 314,
	"./ka": 315,
	"./ka.js": 315,
	"./kk": 316,
	"./kk.js": 316,
	"./km": 317,
	"./km.js": 317,
	"./kn": 318,
	"./kn.js": 318,
	"./ko": 319,
	"./ko.js": 319,
	"./ku": 320,
	"./ku.js": 320,
	"./ky": 321,
	"./ky.js": 321,
	"./lb": 322,
	"./lb.js": 322,
	"./lo": 323,
	"./lo.js": 323,
	"./lt": 324,
	"./lt.js": 324,
	"./lv": 325,
	"./lv.js": 325,
	"./me": 326,
	"./me.js": 326,
	"./mi": 327,
	"./mi.js": 327,
	"./mk": 328,
	"./mk.js": 328,
	"./ml": 329,
	"./ml.js": 329,
	"./mn": 330,
	"./mn.js": 330,
	"./mr": 331,
	"./mr.js": 331,
	"./ms": 333,
	"./ms-my": 332,
	"./ms-my.js": 332,
	"./ms.js": 333,
	"./mt": 334,
	"./mt.js": 334,
	"./my": 335,
	"./my.js": 335,
	"./nb": 336,
	"./nb.js": 336,
	"./ne": 337,
	"./ne.js": 337,
	"./nl": 339,
	"./nl-be": 338,
	"./nl-be.js": 338,
	"./nl.js": 339,
	"./nn": 340,
	"./nn.js": 340,
	"./oc-lnc": 341,
	"./oc-lnc.js": 341,
	"./pa-in": 342,
	"./pa-in.js": 342,
	"./pl": 343,
	"./pl.js": 343,
	"./pt": 345,
	"./pt-br": 344,
	"./pt-br.js": 344,
	"./pt.js": 345,
	"./ro": 346,
	"./ro.js": 346,
	"./ru": 347,
	"./ru.js": 347,
	"./sd": 348,
	"./sd.js": 348,
	"./se": 349,
	"./se.js": 349,
	"./si": 350,
	"./si.js": 350,
	"./sk": 351,
	"./sk.js": 351,
	"./sl": 352,
	"./sl.js": 352,
	"./sq": 353,
	"./sq.js": 353,
	"./sr": 355,
	"./sr-cyrl": 354,
	"./sr-cyrl.js": 354,
	"./sr.js": 355,
	"./ss": 356,
	"./ss.js": 356,
	"./sv": 357,
	"./sv.js": 357,
	"./sw": 358,
	"./sw.js": 358,
	"./ta": 359,
	"./ta.js": 359,
	"./te": 360,
	"./te.js": 360,
	"./tet": 361,
	"./tet.js": 361,
	"./tg": 362,
	"./tg.js": 362,
	"./th": 363,
	"./th.js": 363,
	"./tk": 364,
	"./tk.js": 364,
	"./tl-ph": 365,
	"./tl-ph.js": 365,
	"./tlh": 366,
	"./tlh.js": 366,
	"./tr": 367,
	"./tr.js": 367,
	"./tzl": 368,
	"./tzl.js": 368,
	"./tzm": 370,
	"./tzm-latn": 369,
	"./tzm-latn.js": 369,
	"./tzm.js": 370,
	"./ug-cn": 371,
	"./ug-cn.js": 371,
	"./uk": 372,
	"./uk.js": 372,
	"./ur": 373,
	"./ur.js": 373,
	"./uz": 375,
	"./uz-latn": 374,
	"./uz-latn.js": 374,
	"./uz.js": 375,
	"./vi": 376,
	"./vi.js": 376,
	"./x-pseudo": 377,
	"./x-pseudo.js": 377,
	"./yo": 378,
	"./yo.js": 378,
	"./zh-cn": 379,
	"./zh-cn.js": 379,
	"./zh-hk": 380,
	"./zh-hk.js": 380,
	"./zh-mo": 381,
	"./zh-mo.js": 381,
	"./zh-tw": 382,
	"./zh-tw.js": 382
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 840;

/***/ }),
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB3aWR0aD0iNTAwcHgiIGhlaWdodD0iNTAwcHgiIHZpZXdCb3g9IjAgMCA1MDAgNTAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MDAgNTAwIiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxnPg0KCQk8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNMTgwLjM3MywzNzMuNjU0bDkuODkzLTY4LjEwNWgtMzAuODE5di0zNS4wMDNoMzYuOTA3bDYuMDg3LTQyLjYxM2gtMzIuMzR2LTM1LjM4NGgzNy42NjZsOS41MTItNjYuMjAzDQoJCQloMzMuODYybC05LjUxMiw2Ni4yMDNoMzQuNjI0bDkuODkzLTY2LjIwM2gzMy44NjJsLTkuODkzLDY2LjIwM2gzMC40Mzh2MzUuMzg0aC0zNS43NjVsLTYuMDg4LDQyLjYxM2gzMS41Nzl2MzUuMDAzaC0zNy4yODcNCgkJCWwtOS41MTIsNjguMTA1aC0zNC4yNDNsOS41MTItNjguMTA1aC0zNC42MjNsLTkuNTEyLDY4LjEwNUgxODAuMzczeiBNMjY0LjgzOSwyNzAuNTQ2bDYuMDg4LTQyLjYxM2gtMzQuNjI0bC02LjA4OCw0Mi42MTMNCgkJCUgyNjQuODM5eiIvPg0KCTwvZz4NCgk8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNNTAwLDI1MGMwLDEzOC4wNzEtMTExLjkyOSwyNTAtMjUwLDI1MFMwLDM4OC4wNzEsMCwyNTBDMCwxMTEuOTMsMTExLjkyOSwwLDI1MCwwUzUwMCwxMTEuOTMsNTAwLDI1MHoNCgkJIE0yNTAsMTQuNDQ4QzExOS45MDgsMTQuNDQ4LDE0LjQ0OCwxMTkuOTA5LDE0LjQ0OCwyNTBjMCwxMzAuMDkyLDEwNS40NiwyMzUuNTUyLDIzNS41NTIsMjM1LjU1MlM0ODUuNTUyLDM4MC4wOTIsNDg1LjU1MiwyNTANCgkJQzQ4NS41NTIsMTE5LjkwOSwzODAuMDkyLDE0LjQ0OCwyNTAsMTQuNDQ4eiIvPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE2LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjQyNS45NjNweCIgaGVpZ2h0PSI0MjUuOTYzcHgiIHZpZXdCb3g9IjAgMCA0MjUuOTYzIDQyNS45NjMiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQyNS45NjMgNDI1Ljk2MzsiDQoJIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPHBhdGggZmlsbD0iIzM5MGUwNyIgZD0iTTIxMy4yODUsMGgtMC42MDhDMTM5LjExNCwwLDc5LjI2OCw1OS44MjYsNzkuMjY4LDEzMy4zNjFjMCw0OC4yMDIsMjEuOTUyLDExMS44MTcsNjUuMjQ2LDE4OS4wODENCgkJYzMyLjA5OCw1Ny4yODEsNjQuNjQ2LDEwMS4xNTIsNjQuOTcyLDEwMS41ODhjMC45MDYsMS4yMTcsMi4zMzQsMS45MzQsMy44NDcsMS45MzRjMC4wNDMsMCwwLjA4NywwLDAuMTMtMC4wMDINCgkJYzEuNTYxLTAuMDQzLDMuMDAyLTAuODQyLDMuODY4LTIuMTQzYzAuMzIxLTAuNDg2LDMyLjYzNy00OS4yODcsNjQuNTE3LTEwOC45NzZjNDMuMDMtODAuNTYzLDY0Ljg0OC0xNDEuNjI0LDY0Ljg0OC0xODEuNDgyDQoJCUMzNDYuNjkzLDU5LjgyNSwyODYuODQ2LDAsMjEzLjI4NSwweiBNMjc0Ljg2NSwxMzYuNjJjMCwzNC4xMjQtMjcuNzYxLDYxLjg4NC02MS44ODUsNjEuODg0DQoJCWMtMzQuMTIzLDAtNjEuODg0LTI3Ljc2MS02MS44ODQtNjEuODg0czI3Ljc2MS02MS44ODQsNjEuODg0LTYxLjg4NEMyNDcuMTA0LDc0LjczNiwyNzQuODY1LDEwMi40OTcsMjc0Ljg2NSwxMzYuNjJ6Ii8+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 862 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.0610c72.svg";

/***/ }),
/* 865 */,
/* 866 */,
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(830)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(940),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(802)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(911),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(828)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(938),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(814)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(924),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(825)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(935),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b63b03a2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(812)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(922),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(818)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(928),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(798)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(907),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(827)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(937),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(805)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(914),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(824)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(934),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(809)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(919),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(832)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(942),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(820)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(930),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(823)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(933),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(810)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(920),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(811)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(921),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(792)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(901),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(789)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(898),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(821)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(931),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(806)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(916),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(800)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(909),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(793)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(902),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(808)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(918),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(822)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(932),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(815)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(925),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(791)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(900),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(807)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(917),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(826)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(936),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(819)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(929),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(796)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(905),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "page-schedule"
  }, [_c('top-subpage-section', [_c('page-header', {
    attrs: {
      "title": "Events & Schedule"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-flex-mobile has-text-centered",
    class: [{
      'is-centered': !_vm.isDesktop
    }]
  }, [(_vm.isDesktop) ? _c('div', {
    staticClass: "column"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow subnav-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onScrollTo('schedule', 'schedule-sub-section')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": __webpack_require__(860),
      "width": "80"
    }
  }), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "text"
  }, [_vm._v("\n              Schedule\n            ")])])]), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: item.title_slug,
      staticClass: "column is-narrow subnav-item"
    }, [_c('a', {
      attrs: {
        "href": _vm.$route.name + '?anchor=' + item.title_slug
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onScrollTo('schedule', item.title_slug)
        }
      }
    }, [(item.icon === 'strawberry') ? _c('img', {
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "src": __webpack_require__(861),
        "width": "80"
      }
    }) : (item.icon === 'king') ? _c('img', {
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "src": __webpack_require__(856),
        "width": "80"
      }
    }) : (item.icon === 'people') ? _c('img', {
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "src": __webpack_require__(858),
        "width": "80"
      }
    }) : _c('img', {
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "src": __webpack_require__(120),
        "width": "80"
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
      staticClass: "text"
    }, [_vm._v("\n              " + _vm._s(item.title_short) + "\n            ")])])])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content-bg"
  }, [_c('schedule-sub-section', {
    attrs: {
      "id": "schedule-sub-section",
      "date": "2017-5-12",
      "title": "Friday, May 12th Schedule"
    }
  }), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('event-sub-section', {
      key: item.id,
      attrs: {
        "id": item.title_slug,
        "slug": item.title_slug,
        "title": item.title,
        "item": item
      }
    })
  })], 2), _vm._v(" "), (false) ? _c('vm-back-top', {
    attrs: {
      "bottom": 45,
      "right": 25,
      "duration": 1000,
      "timing": 'ease'
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span')])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-wrapper",
    class: [_vm.$route.name !== 'landing' ? 'not-landing' : ''],
    attrs: {
      "id": "navse",
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "div-container container"
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "columns navbar-full is-gapless is-mobile"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column column-link is-hidden-touch"
  }, [_c('div', {
    staticClass: "columns is-gapless",
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "column has-text-right"
  }, _vm._l((_vm.navSocial), function(navItem) {
    return _c('a', {
      staticClass: "fa",
      attrs: {
        "href": navItem.path,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa",
      class: ['fa-' + navItem.fa]
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless",
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "column has-text-right"
  }, _vm._l((_vm.navMain), function(navItem) {
    return _c('a', {
      class: {
        'nav-item-link': true,
        active: _vm.$route.name === navItem.name
      },
      attrs: {
        "href": [navItem.section ? '/?anchor=' + navItem.section : navItem.path]
      },
      on: {
        "click": function($event) {
          [navItem.section ? _vm.onScrollTo($event, 'landing', navItem.section) : '']
        }
      }
    }, [_vm._v("\n                  " + _vm._s(navItem.title) + "\n                ")])
  }), 0)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "column navbar-menu",
    attrs: {
      "data-aos": "zoom-in",
      "data-aos-once": "true"
    },
    on: {
      "click": function($event) {
        return _vm.onToggle()
      }
    }
  }, [_c('div', {
    staticClass: "control-menu",
    class: {
      active: _vm.showNav
    }
  }, [_c('span')])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column navbar-brand is-narrow",
    attrs: {
      "align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": __webpack_require__(388),
      "width": "360"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-gapless",
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "column has-text-right link-ticket-wrapper"
  }, [_c('div', {
    staticClass: "bg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(384),
      "width": "200"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "href": "/tickets"
    }
  }, [_vm._v("\n                      Purchase Tickets\n                    ")])])])])
}]}

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "page-teams"
  }, [_c('top-subpage-section', [_c('page-header', {
    attrs: {
      "title": ("Signup & " + _vm.year + " Teams")
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-vcentered is-flex-mobile has-text-centered",
    class: [{
      'is-centered': !_vm.isDesktop
    }]
  }, [(_vm.isDesktop) ? _c('div', {
    staticClass: "column"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow subnav-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onScrollTo('info', 'info-sign-up')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": __webpack_require__(120),
      "width": "80"
    }
  }), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "text"
  }, [_vm._v("\n              Signup\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow subnav-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onScrollTo('info', 'info-prize')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": __webpack_require__(386),
      "width": "80"
    }
  }), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "text"
  }, [_vm._v("\n              Prize\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow subnav-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onScrollTo('teams', 'info-teams')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": __webpack_require__(387),
      "width": "80"
    }
  }), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "text"
  }, [_vm._v("\n              " + _vm._s(("" + _vm.year)) + " Teams\n            ")])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content-bg"
  }, [_c('teams-sub-section', {
    attrs: {
      "id": "info-teams",
      "title": "Teams"
    }
  })], 1), _vm._v(" "), (false) ? _c('vm-back-top', {
    attrs: {
      "bottom": 45,
      "right": 25,
      "duration": 1000,
      "timing": 'ease'
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span')])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "page-photos"
  }, [_c('top-subpage-section', [_c('page-header', {
    attrs: {
      "title": "Photos"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-vcentered is-flex-mobile has-text-centered",
    class: [{
      'is-centered': !_vm.isDesktop
    }]
  }, [(_vm.isDesktop) ? _c('div', {
    staticClass: "column"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow subnav-item has-text-left"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onScrollTo('photos', 'photos-trending')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": __webpack_require__(855),
      "width": "80"
    }
  }), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "text"
  }, [_vm._v("\n              Trending\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow subnav-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onScrollTo('photos', 'photos-official')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": __webpack_require__(857),
      "width": "80"
    }
  }), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "text"
  }, [_vm._v("\n              Official\n            ")])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content-bg"
  }, [_c('instagram-section', {
    attrs: {
      "id": "photos-official"
    }
  })], 1), _vm._v(" "), (false) ? _c('vm-back-top', {
    attrs: {
      "bottom": 45,
      "right": 25,
      "duration": 1000,
      "timing": 'ease'
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span')])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-sign-up-team",
    attrs: {
      "id": "section-sign-up-team"
    }
  }, [_c('form-dynamix', {
    attrs: {
      "type": "team",
      "feedback": _vm.feedback,
      "loading": _vm.loading,
      "names": _vm.names,
      "models": _vm.models,
      "attributes": _vm.attributes,
      "vuelidate": _vm.$v,
      "is-print": _vm.isPrint,
      "is-print-pdf": _vm.isPrintPdf
    },
    on: {
      "recaptcha": _vm.onRecaptcha,
      "send": _vm.onSend
    }
  }), _vm._v(" "), _c('b-modal', {
    staticClass: "modal-wrapper",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "scroll": "keep",
      "active": _vm.isMapModalActive
    },
    on: {
      "update:active": function($event) {
        _vm.isMapModalActive = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "white",
      "padding": "12px 8px 3px 8px",
      "font-weight": "bold",
      "font-size": "0.9em"
    }
  }, [(_vm.markerCurrent !== undefined) ? _c('span', [_vm._v("\n        Choose " + _vm._s(_vm.markerCurrent.attributes.title) + " desired location.\n      ")]) : _c('span', [_vm._v("\n        Choose all five desired locations.\n      ")])]), _vm._v(" "), _c('p', {
    staticClass: "image is-4by3",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "relative",
      "background-color": "white",
      "margin-bottom": "0"
    }
  }, [(_vm.isDesktop) ? _c('img', {
    ref: "mapRef",
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%",
      "height": "auto",
      "display": "inline-block"
    },
    attrs: {
      "src": __webpack_require__(175)
    }
  }) : _c('a', {
    attrs: {
      "href": _vm.imageMapSrc,
      "target": "_blank"
    }
  }, [_c('img', {
    ref: "mapRef",
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%",
      "display": "inline-block"
    },
    attrs: {
      "src": __webpack_require__(175)
    }
  })])]), (!_vm.isDesktop) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "background-color": "white"
    }
  }, [_vm._v("\n        (click to open map in a new tab)\n      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.markerList), function(marker) {
    return (_vm.isDesktop) ? _c('div', {
      key: marker.text,
      staticClass: "marker",
      class: {
        'disabled': marker.state === 0,
        'enabled': marker.state === 1,
        'selected': marker.state === 2
      },
      style: ({
        top: marker.top,
        left: marker.left,
        height: _vm.markerHeight
      }),
      on: {
        "click": function($event) {
          return _vm.onClickMapMarker(marker)
        }
      }
    }, [_vm._v("\n        " + _vm._s(marker.text) + "\n        "), (_vm.isDesktop) ? _c('div', {
      staticStyle: {
        "position": "absolute",
        "z-index": "99999",
        "background-color": "rgba(255,255,255,0.5)",
        "font-size": "0.8em",
        "font-weight": "bold"
      },
      style: ({
        top: marker.selTop,
        bottom: marker.selBottom,
        left: marker.selLeft,
        right: marker.selRight
      })
    }, [_vm._v("\n          " + _vm._s(marker.textSelected) + "\n        ")]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), ( false) ? _c('div', {
    staticClass: "marker",
    staticStyle: {
      "position": "absolute",
      "padding-left": "8px",
      "padding-right": "8px",
      "background-color": "rgba(255,255,255,0.5)"
    },
    style: ({
      top: _vm.markerClear.top,
      left: _vm.markerClear.left,
      height: _vm.markerHeight,
      width: 'auto'
    }),
    on: {
      "click": function($event) {
        return _vm.onResetMapMarker()
      }
    }
  }, [_vm._v("\n        Reset All Locations\n      ")]) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), (!_vm.isDesktop) ? _c('div', {
    staticClass: "columns is-multiline is-mobile is-centered is-gapless",
    staticStyle: {
      "text-align": "center",
      "background-color": "rgba(255,255,255,0.5)",
      "margin-bottom": "0"
    }
  }, _vm._l((_vm.markerList), function(marker) {
    return _c('div', {
      key: marker.text,
      staticClass: "column is-narrow"
    }, [_c('div', {
      staticClass: "marker static",
      class: {
        'disabled': marker.state === 0,
        'enabled': marker.state === 1,
        'selected': marker.state === 2
      },
      staticStyle: {
        "display": "inline-block",
        "margin": "3px auto",
        "padding": "3px 15px",
        "text-align": "center"
      },
      on: {
        "click": function($event) {
          return _vm.onClickMapMarker(marker)
        }
      }
    }, [_vm._v("\n          " + _vm._s(marker.text) + "\n          "), _c('div', {
      staticStyle: {
        "font-size": "0.7em",
        "font-weight": "bold"
      }
    }, [_vm._v("\n            " + _vm._s(marker.textSelected) + "\n          ")])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline is-mobile is-centered is-gapless",
    staticStyle: {
      "text-align": "center",
      "background-color": "white"
    }
  }, [(_vm.markerCurrent === undefined) ? _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "marker static",
    staticStyle: {
      "display": "inline-block",
      "margin": "5px auto 18px auto",
      "padding": "5px 12px",
      "text-align": "center",
      "background-color": "rgba(255,255,255,0.5)"
    },
    on: {
      "click": function($event) {
        return _vm.onResetMapMarker()
      }
    }
  }, [_vm._v("\n          Reset All Locations\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "marker static",
    staticStyle: {
      "display": "inline-block",
      "margin": "5px auto 18px auto",
      "padding": "5px 12px",
      "text-align": "center",
      "background-color": "rgba(10,30,200,0.5)",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.onProceed()
      }
    }
  }, [_vm._v("\n          Proceed\n        ")])])])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-subheader",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div-container', {
    staticClass: "has-text-centered",
    attrs: {
      "padding-top": "0rem",
      "padding-bottom": "0rem"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-flex-mobile is-vcentered"
  }, [_c('div', {
    staticClass: "column is-11 wrapper",
    class: [{
      'has-text-left': !_vm.textAlign || _vm.textAlign === 'left',
      'has-text-centered': _vm.textAlign === 'center',
      'has-text-right': _vm.textAlign === 'right'
    }]
  }, [_c('h1', {
    style: (_vm.titleStyle)
  }, [_vm._v(_vm._s(_vm.title))])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div-container container",
    class: [{
      'is-fluid': _vm.full === 'true'
    }],
    style: ([{
      paddingTop: (_vm.paddingTop ? _vm.paddingTop : undefined),
      paddingBottom: (_vm.paddingBottom ? _vm.paddingBottom : undefined)
    }])
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered"
  }, [_c('div', {
    staticClass: "column",
    class: [{
      'is-10': _vm.full !== 'true' && !_vm.columnNum
    }, _vm.columnNum]
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-pulse v-pulse1",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay1])
  }), _c('div', {
    staticClass: "v-pulse v-pulse2",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay2])
  }), _c('div', {
    staticClass: "v-pulse v-pulse3",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay3])
  })])
},staticRenderFns: []}

/***/ }),
/* 906 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-subtab",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div-container', {
    staticClass: "has-text-centered",
    attrs: {
      "full": _vm.full,
      "padding-top": "0rem",
      "padding-bottom": "0rem"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-flex-mobile is-vcentered"
  }, [_c('div', {
    staticClass: "column has-text-centered wrapper",
    class: [{
      'is-11': _vm.full !== 'true' && !_vm.columnNum
    }, _vm.columnNum]
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-flex-mobile is-vcentered"
  }, _vm._l((_vm.titleInfos), function(titleInfo, index) {
    return _c('div', {
      key: titleInfo.title,
      staticClass: "column has-text-centered wrapper",
      class: {
        'has-divider-right': index < (_vm.titleInfos.length - 1),
        'is-active': (index === _vm.currentIndex),
        'is-print': _vm.isPrint
      }
    }, [_c('a', {
      staticStyle: {
        "position": "relative",
        "display": "block"
      },
      attrs: {
        "href": '/?date=' + titleInfo.id
      },
      on: {
        "click": function($event) {
          return _vm.onClickTitle($event, titleInfo.id, index, titleInfo.isfull, titleInfo.disabledText);
        }
      }
    }, [(titleInfo.strikethrough) ? _c('h1', {
      staticStyle: {
        "text-decoration": "line-through"
      }
    }, [_vm._v(_vm._s(titleInfo.title))]) : _c('h1', [_vm._v(_vm._s(titleInfo.title))]), _vm._v(" "), (titleInfo.disabled) ? _c('div', {
      staticStyle: {
        "position": "absolute",
        "left": "0",
        "top": "0",
        "width": "100%",
        "transform": "rotate(-4deg) translate(-15%,-70%)",
        "font-size": "0.8em"
      }
    }, [_c('h2', {
      staticStyle: {
        "color": "#390e07"
      },
      domProps: {
        "innerHTML": _vm._s(titleInfo.disabledText)
      }
    })]) : _vm._e()])])
  }), 0)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-prize-awards-sub-about",
    class: [{
      'is-alt': _vm.isAlt
    }],
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('page-subheader', {
    staticStyle: {
      "margin-bottom": "2em"
    },
    attrs: {
      "title": "Here's Your Chance To Win Even If Your Bar-b-que Doesn't"
    }
  }), _vm._v(" "), _c('div-container', _vm._l((_vm.items), function(item, ikey) {
    return (item && item.imageUrl) ? _c('div-columns', {
      key: ("" + ikey),
      attrs: {
        "paddingTop": "0",
        "paddingBottom": "0"
      }
    }, [(item) ? _c('div', {
      staticClass: "columns is-gapless is-centered row"
    }, [_c('div', {
      staticClass: "column is-5 has-text-centered"
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.imageUrl,
        "width": "200"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "column is-7 has-text-left"
    }, [_c('h2', {
      staticStyle: {
        "margin-bottom": "0",
        "padding-bottom": "30px"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])]) : _vm._e()]) : _vm._e()
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-contact",
    attrs: {
      "id": "section-contact"
    }
  }, [_c('div-container', {
    attrs: {
      "full": "true"
    }
  }, [(false) ? _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline"
  }, [_c('div', {
    staticClass: "column is-6 has-text-centered"
  }, [_c('div', {
    staticClass: "cont-desc",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/bosshogcookoff",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/bosshogcookoff",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/bosshogcookoff",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('div', {
    staticClass: "column is-12 has-text-left"
  }, [_c('div', {
    staticClass: "cont-desc",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('h3', {
    staticClass: "title",
    staticStyle: {
      "font-size": "1.8em"
    }
  }, [_vm._v("Contact")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-multiline"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "cont-form cont-form-info",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "value": "",
      "placeholder": "Name"
    },
    on: {
      "input": function($event) {
        return _vm.$v.name.$touch()
      }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "value": "",
      "placeholder": "Email Address"
    },
    on: {
      "input": function($event) {
        return _vm.$v.email.$touch()
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "email"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "cont-form cont-form-message",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "maxlength": "500",
      "type": "textarea",
      "placeholder": "Message"
    },
    on: {
      "input": function($event) {
        return _vm.$v.message.$touch()
      }
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "message"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-flex-mobile is-vcentered"
  }, [_c('div', {
    staticClass: "column captcha-image-wrapper"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": _vm.recaptchaKey
    },
    on: {
      "verify": _vm.onVerifyRecaptcha,
      "expired": _vm.onExpiredRecaptcha,
      "render": _vm.onRenderRecaptcha
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.recaptcha),
      expression: "recaptcha",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.recaptcha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.recaptcha = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.recaptcha && _vm.recaptcha.$dirty && _vm.recaptcha.$invalid && _vm.recaptcha.$params.required && !_vm.recaptcha.required) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("Invalid recaptcha.")]) : _vm._e()], 1), _vm._v(" "), (_vm.isDesktop) ? _c('div', {
    staticClass: "column is-4 is-3-mobile"
  }, [_c('button', {
    staticClass: "button is-outlined",
    class: {
      'is-loading': _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.onSend(_vm.$v)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.loading ? ' ' : 'SUBMIT'))])])]) : _vm._e()])]), _vm._v(" "), (!_vm.isDesktop) ? _c('b-field', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('button', {
    staticClass: "button is-outlined",
    class: {
      'is-loading': _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.onSend(_vm.$v)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.loading ? ' ' : 'SUBMIT'))])])]) : _vm._e(), _vm._v(" "), (_vm.feedback) ? _c('p', [_vm._v(_vm._s(_vm.feedback))]) : _vm._e()], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-sign-up-judge",
    attrs: {
      "id": "section-sign-up-judge"
    }
  }, [_c('form-dynamix', {
    attrs: {
      "type": "judge",
      "feedback": _vm.feedback,
      "loading": _vm.loading,
      "names": _vm.names,
      "models": _vm.models,
      "attributes": _vm.attributes,
      "vuelidate": _vm.$v,
      "is-print": _vm.isPrint,
      "is-print-pdf": _vm.isPrintPdf
    },
    on: {
      "recaptcha": _vm.onRecaptcha,
      "send": _vm.onSend
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help is-danger has-text-left"
  }, _vm._l((_vm.infos), function(info) {
    return _c('li', [_vm._v(_vm._s(info.message))])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div-container', [_c('div', {
    staticClass: "columns content is-centered is-gapless is-flex-mobile is-multiline",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true",
      "data-aos-offset": "-30"
    }
  }, [_c('p', {
    staticClass: "column is-8 is-12-touch copyright-wrapper is-hidden-touch"
  }, [_vm._v("\n        © " + _vm._s(_vm.year) + " BOSS HOG COOK-OFF. All Rights Reserved. Website by "), _c('a', {
    attrs: {
      "href": "http://adaptconcepts.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticStyle: {
      "border-bottom": "1px solid black"
    }
  }, [_vm._v("Adapt Concepts")])])]), _vm._v(" "), _c('p', {
    staticClass: "column is-4 is-12-touch social-wrapper"
  }, [_c('span', {
    staticClass: "social"
  }, [_vm._v("Follow us on social media")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.navFacebook.path,
      "target": "_bank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.navTwitter.path,
      "target": "_bank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.navInstagram.path,
      "target": "_bank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "column is-8 is-12-touch copyright-wrapper is-hidden-desktop"
  }, [_vm._v("\n        © " + _vm._s(_vm.year) + " BOSS HOG COOK-OFF. All Rights Reserved. Website by "), _c('a', {
    attrs: {
      "href": "http://adaptconcepts.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticStyle: {
      "border-bottom": "1px solid black"
    }
  }, [_vm._v("Adapt Concepts")])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field"
  }, [(false) ? _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control has-icon has-icon-right"
  }, [(_vm.type === 'email') ? _c('input', {
    staticClass: "input",
    class: [_vm.name + '-input', {
      'is-danger': _vm.error
    }],
    attrs: {
      "type": "email",
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  }) : (_vm.type === 'password') ? _c('input', {
    staticClass: "input",
    class: [_vm.name + '-input', {
      'is-danger': _vm.error
    }],
    attrs: {
      "type": "password",
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  }) : _c('input', {
    staticClass: "input",
    class: [_vm.name + '-input', {
      'is-danger': _vm.error
    }],
    attrs: {
      "type": "text",
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon"
  }, [(false) ? _c('i', {
    staticClass: "fa",
    class: ['fa-' + _vm.fa],
    attrs: {
      "name": _vm.fa
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mdi !== undefined) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v(_vm._s(_vm.mdi))]) : _vm._e()]), _vm._v(" "), (_vm.error) ? _c('form-error', {
    attrs: {
      "error": _vm.error
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-dynamix"
  }, [(!_vm.isPrint) ? _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "column is-12 has-text-right"
  }, [(!_vm.isIE) ? _c('a', {
    attrs: {
      "href": ('/' + _vm.$route.name + '?type=' + _vm.type + '&print=true'),
      "target": "_blank"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Printer Friendly")]), _vm._v("  \n        "), _c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "width": "18px",
      "vertical-align": "middle"
    },
    attrs: {
      "src": __webpack_require__(385),
      "width": "18"
    }
  })]) : _c('a', {
    attrs: {
      "href": _vm.isPrintPdf,
      "target": "_blank"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Printer Friendly")]), _vm._v("  \n        "), _c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "width": "18px",
      "vertical-align": "middle"
    },
    attrs: {
      "src": __webpack_require__(385),
      "width": "18"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: "item",
      staticClass: "column",
      class: [{
        'is-12': !item.attributes.column
      }, item.attributes.column]
    }, [_c('div', {
      staticClass: "field"
    }, [_c('div', {
      staticClass: "control has-icons-right"
    }, [((item.attributes.type === 'checkbox' || item.attributes.type === 'radio')) ? _c('p', {
      staticClass: "label"
    }, [(item.attributes.title && !item.attributes.withDefault && !item.attributes.titleHidden) ? _c('span', [_vm._v("\n              " + _vm._s(item.attributes.title + (_vm.vuelidate.models[item.name].$params.hasOwnProperty('required') || _vm.vuelidate.models[item.name].$params.hasOwnProperty('required_custom') ? ' *' : '')) + "\n            ")]) : _vm._e(), _vm._v(" "), (item.attributes.type === 'checkbox' && item.attributes.withDefault === true) ? _c('label', {
      key: "option.value",
      staticClass: "label default",
      class: [item.attributes.type]
    }, [(!item.attributes.withDefaultHideInput) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.models[item.name]),
        expression: "models[item.name]"
      }],
      attrs: {
        "type": "checkbox",
        "name": [item.name]
      },
      domProps: {
        "checked": Array.isArray(_vm.models[item.name]) ? _vm._i(_vm.models[item.name], null) > -1 : (_vm.models[item.name])
      },
      on: {
        "clicked": function($event) {
          return item.attributes.onChecked()
        },
        "change": function($event) {
          var $$a = _vm.models[item.name],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.models, item.name, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.models, item.name, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.models, item.name, $$c)
          }
        }
      }
    }) : _vm._e(), _vm._v("\n              " + _vm._s(item.attributes.title + (_vm.vuelidate.models[item.name].$params.required ? ' *' : '')) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.attributes.type === 'dropdown') ? _c('div', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.models[item.name]),
        expression: "models[item.name]"
      }],
      class: [{
        'is-danger': _vm.vuelidate.models[item.name].$dirty && (_vm.models[item.name] == undefined || _vm.models[item.name] == 0 || _vm.models[item.name].length <= 0) && (_vm.vuelidate.models[item.name].$params.required && !_vm.vuelidate.models[item.name].required)
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.models, item.name, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((item.attributes.options), function(option) {
      return _c('option', {
        key: "option.value",
        domProps: {
          "value": option.value
        }
      }, [_vm._v("\n                " + _vm._s(option.value !== undefined ? option.title : (option.title + (_vm.vuelidate.models[item.name].$params.required ? ' *' : ''))) + "\n              ")])
    }), 0)]) : (item.attributes.type === 'checkbox' || item.attributes.type === 'radio') ? _vm._l((item.attributes.options), function(option) {
      return _c('label', {
        key: "option.value",
        class: [item.attributes.type]
      }, [(item.attributes.type === 'checkbox') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.models[item.name][option.value]),
          expression: "models[item.name][option.value]"
        }],
        attrs: {
          "type": "checkbox",
          "name": [item.name + '-' + item.value],
          "disabled": item.attributes.disabled
        },
        domProps: {
          "checked": Array.isArray(_vm.models[item.name][option.value]) ? _vm._i(_vm.models[item.name][option.value], null) > -1 : (_vm.models[item.name][option.value])
        },
        on: {
          "clicked": function($event) {
            return item.attributes.onChecked()
          },
          "change": function($event) {
            var $$a = _vm.models[item.name][option.value],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(_vm.models[item.name], option.value, $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(_vm.models[item.name], option.value, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(_vm.models[item.name], option.value, $$c)
            }
          }
        }
      }) : (item.attributes.type === 'radio') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.models[item.name]),
          expression: "models[item.name]"
        }],
        attrs: {
          "type": "radio",
          "name": [item.name + '-' + item.value],
          "disabled": item.attributes.disabled
        },
        domProps: {
          "value": option.value,
          "checked": _vm._q(_vm.models[item.name], option.value)
        },
        on: {
          "change": function($event) {
            return _vm.$set(_vm.models, item.name, option.value)
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(option.title))])])
    }) : (item.attributes.type === 'textarea') ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.models[item.name]),
        expression: "models[item.name]",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "textarea",
      class: [{
        'is-danger': _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$dirty
      }],
      attrs: {
        "placeholder": [item.attributes.title + (_vm.vuelidate.models[item.name].$params.required ? ' *' : '')],
        "maxlength": item.attributes.maxLength
      },
      domProps: {
        "value": (_vm.models[item.name])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.models, item.name, $event.target.value.trim())
        }, function($event) {
          if (item.attributes.onInput) { item.attributes.onInput(_vm.models[item.name], item.attributes); }
        }],
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }) : (item.attributes.type === 'text') ? _c('label', {
      class: [item.attributes.type]
    }, [(!item.attributes.null) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.models[item.name]),
        expression: "models[item.name]"
      }],
      staticClass: "input",
      class: [{
        'is-danger': _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$dirty
      }],
      attrs: {
        "placeholder": [item.attributes.title + (_vm.vuelidate.models[item.name].$params.required ? ' *' : '')],
        "disabled": item.attributes.disabled
      },
      domProps: {
        "value": (_vm.models[item.name])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.models, item.name, $event.target.value)
        }
      }
    }) : _vm._e()]) : (item.attributes.type === 'label') ? _c('p', {
      staticClass: "label"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.attributes.title)
      }
    }, [_vm._v(_vm._s(item.attributes.title))])]) : (item.attributes.type === 'image') ? _c('p', {
      staticClass: "image-wrapper",
      staticStyle: {
        "text-align": "center"
      }
    }, [(item.attributes.onClick &&
      typeof item.attributes.onClick === 'function') ? _c('a', {
      attrs: {
        "href": '#'
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          item.attributes.onClick()
        }
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": item.attributes.link
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "gray",
        "font-size": "0.8em"
      }
    }, [_vm._v(_vm._s(item.attributes.title))])]) : (item.attributes.link) ? _c('a', {
      attrs: {
        "href": item.attributes.link,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": item.attributes.link
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "gray",
        "font-size": "0.8em"
      }
    }, [_vm._v(_vm._s(item.attributes.title))])]) : _vm._e()]) : (item.attributes.type === 'button') ? _c('p', [_c('button', {
      staticClass: "btn btn-default",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "disabled": item.attributes.disabled
      },
      on: {
        "click": function($event) {
          return item.attributes.onClick(item, _vm.models[item.name])
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.attributes.title) + ": " + _vm._s(_vm.models[item.name]) + "\n            ")])]) : _c('p', {
      staticClass: "label"
    }, [_vm._v("\n            Invalid field.\n          ")]), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid) ? _c('span', {
      staticClass: "icon is-small is-right is-danger"
    }, [_c('i', {
      staticClass: "fa fa-warning"
    })]) : _vm._e(), _vm._v(" "), (item.attributes.type === 'text-area') ? _c('small', {
      staticClass: "help counter"
    }, [_vm._v(_vm._s(item.attributes.curLength) + " / " + _vm._s(item.attributes.maxLength))]) : _vm._e(), _vm._v(" "), (item.attributes.note) ? _c('p', {
      staticClass: "help is-note",
      style: (item.attributes.noteStyle),
      domProps: {
        "innerHTML": _vm._s(item.attributes.note)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.required && !_vm.vuelidate.models[item.name].required) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" is required.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.numeric && !_vm.vuelidate.models[item.name].numeric) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" must be numeric value.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.between && !_vm.vuelidate.models[item.name].between) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" must be between " + _vm._s(_vm.vuelidate.models[item.name].$params.between.min) + " and " + _vm._s(_vm.vuelidate.models[item.name].$params.between.max) + ".")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.minLength && !_vm.vuelidate.models[item.name].minLength) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" is too short.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.maxLength && !_vm.vuelidate.models[item.name].maxLength) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" is too long.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.email && !_vm.vuelidate.models[item.name].email) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(item.attributes.title) + " is invalid.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.hasOwnProperty('required_custom') && !_vm.vuelidate.models[item.name].required_custom) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" selection with at least one option.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.hasOwnProperty('either_custom') && !_vm.vuelidate.models[item.name].either_custom) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" selection with conflicting option, please revise.")]) : _vm._e()], 2)])])
  }), 0), _vm._v(" "), (!_vm.isPrint) ? _c('b-field', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-flex-mobile is-vcentered"
  }, [_c('div', {
    staticClass: "column captcha-image-wrapper"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": _vm.recaptchaKey
    },
    on: {
      "verify": _vm.onVerifyRecaptcha,
      "expired": _vm.onExpiredRecaptcha,
      "render": _vm.onRenderRecaptcha
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.models['recaptcha']),
      expression: "models['recaptcha']",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.models['recaptcha'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.models, 'recaptcha', $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.vuelidate.models['recaptcha'] && _vm.vuelidate.models['recaptcha'].$dirty && _vm.vuelidate.models['recaptcha'].$invalid && _vm.vuelidate.models['recaptcha'].$params.required && !_vm.vuelidate.models['recaptcha'].required) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("Invalid recaptcha.")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.isPrint) ? _c('b-field', {
    staticClass: "submit-wrapper"
  }, [_c('button', {
    staticClass: "control button is-outlined",
    class: {
      'is-loading': _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.onSend(_vm.vuelidate)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.loading ? ' ' : 'SUBMIT'))])])]) : _vm._e(), _vm._v(" "), (_vm.feedback) ? _c('p', {
    staticClass: "help is-danger",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.feedback))]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 914 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-about",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('div-container', [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered"
  }, [_c('div', {
    staticClass: "column is-4 has-text-centered aplayer-wrapper"
  }, [(_vm.music && !_vm.disabled) ? _c('vue-aplayer', {
    ref: "aplayer",
    attrs: {
      "id": "aplayer",
      "element": _vm.music.element,
      "narrow": _vm.music.narrow,
      "autoplay": _vm.music.autoplay,
      "mode": 'single',
      "music": _vm.music
    }
  }) : _c('img', {
    staticStyle: {
      "max-width": "100%",
      "padding": "5px"
    },
    attrs: {
      "src": _vm.imageUrl,
      "width": "350"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-7 has-text-left",
    domProps: {
      "innerHTML": _vm._s(_vm.paragraph.content)
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "disqus_thread"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "page-sign-up",
    class: (_vm.isPrint ? 'is-print' : undefined)
  }, [(!_vm.isPrint) ? _c('top-subpage-section', [_c('page-header', {
    attrs: {
      "title": "Signup"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-content-bg",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.isPrint) ? _c('div-container', {
    staticClass: "form-print-logo",
    attrs: {
      "full": 'true',
      "column-num": 'is-11',
      "padding-bottom": "0"
    }
  }, [_c('div-columns', {
    attrs: {
      "full": 'true',
      "background-color": "gray",
      "text-align": 'center'
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(388)
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('page-subtab', {
    attrs: {
      "full": (_vm.isPrint ? 'true' : undefined),
      "column-num": (_vm.isPrint ? 'is-11' : undefined),
      "is-print": _vm.isPrint,
      "title-infos": _vm.applications,
      "selected-index": _vm.applicationIndex
    },
    on: {
      "title-changed": _vm.onApplicationChanged
    }
  }), _vm._v(" "), _c('div-container', {
    attrs: {
      "full": (_vm.isPrint ? 'true' : undefined),
      "column-num": (_vm.isPrint ? 'is-11' : undefined),
      "padding-bottom": "4rem"
    }
  }, [_c('div-columns', {
    attrs: {
      "full": (_vm.isPrint ? 'true' : undefined),
      "padding-top": "0rem",
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless"
  }, [(!_vm.applications[0].isfull) ? _c('div', {
    staticClass: "column is-12 sign-up-team-section-wrapper",
    style: ([_vm.signUpTeamSectionWrapper])
  }, [_c('sign-up-team-section', {
    attrs: {
      "is-print": _vm.isPrint
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.applications[1].isfull) ? _c('div', {
    staticClass: "column is-12 sign-up-judge-section-wrapper",
    style: ([_vm.signUpJudgeSectionWrapper])
  }, [_c('sign-up-judge-section', {
    attrs: {
      "is-print": _vm.isPrint
    }
  })], 1) : _vm._e()])])], 1)], 1), _vm._v(" "), (false) ? _c('vm-back-top', {
    attrs: {
      "bottom": 45,
      "right": 25,
      "duration": 1000,
      "timing": 'ease'
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span')])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-sub-teams",
    attrs: {
      "id": "section-sub-teams",
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('page-subheader', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('div-container', [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered is-multiline is-flex-mobile"
  }, [_c('div', {
    staticClass: "column is-11 is-12-mobile has-text-centered content content-competitions"
  }, _vm._l((_vm.competitions), function(competition) {
    return _c('span', {
      staticClass: "wrapper"
    }, [_c('a', {
      attrs: {
        "href": _vm.$route.path + '?team=' + competition.name_slug
      },
      on: {
        "click": function($event) {
          return _vm.onClickTeam($event, competition.name_slug)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "display": "inline-block",
        "padding": "5px",
        "vertical-align": "middle",
        "width": "40px",
        "max-height": "50px"
      },
      attrs: {
        "src": competition.image.path
      }
    }), _vm._v(" "), _c('h3', {
      staticStyle: {
        "display": "inline-block",
        "padding": "3px 16px"
      }
    }, [_c('span', {
      staticClass: "name",
      class: {
        'is-active': (competition.name_slug === _vm.filter)
      }
    }, [_vm._v(_vm._s(competition.name))])]), _c('br')])])
  }), 0), _vm._v(" "), (_vm.teams) ? _c('div', {
    staticClass: "column is-11 is-12-mobile has-text-centered content content-teams",
    staticStyle: {
      "padding-top": "0"
    }
  }, _vm._l((_vm.teams), function(team, index) {
    return (!team.hide) ? _c('div', {
      key: team.name_slug,
      staticClass: "columns is-gapless is-centered is-vcentered is-multiline is-flex-mobile",
      class: {
        'is-alt': team.isAlt
      }
    }, [_c('div', {
      staticClass: "column is-8 has-text-centered"
    }, [_c('h3', {
      staticStyle: {
        "display": "inline-block",
        "padding": "16px 0px",
        "margin-bottom": "0"
      }
    }, [_vm._v(_vm._s(team.name))]), _vm._v(" "), _c('h4', {
      staticStyle: {
        "display": "inline-block",
        "padding": "16px 8px",
        "margin-bottom": "0",
        "font-weight": "normal"
      }
    }, [_vm._v("(" + _vm._s(team.city) + ", " + _vm._s(team.state) + ")")]), _c('br')]), _vm._v(" "), (team.competitions) ? _c('div', {
      staticClass: "column is-4 has-text-centered"
    }, _vm._l((team.competitions), function(competition) {
      return _c('img', {
        staticStyle: {
          "display": "inline-block",
          "padding": "5px",
          "vertical-align": "middle",
          "width": "40px",
          "max-height": "50px"
        },
        attrs: {
          "src": competition.image.path
        }
      })
    }), 0) : _vm._e()]) : _vm._e()
  }), 0) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "page-sponsors"
  }, [_c('top-subpage-section', [_c('page-header', {
    attrs: {
      "title": "Sponsors"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-vcentered is-flex-mobile has-text-centered",
    class: [{
      'is-centered': !_vm.isDesktop
    }]
  }, [(_vm.isDesktop) ? _c('div', {
    staticClass: "column"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.subnavs), function(subnav) {
    return _c('div', {
      key: "subnav.title",
      staticClass: "column is-narrow subnav-item"
    }, [_c('a', {
      attrs: {
        "href": subnav.section ? (_vm.$route.name + '?anchor=' + subnav.section) : subnav.route
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onScrollTo(subnav.route, subnav.section)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "src": __webpack_require__(120),
        "width": "80"
      }
    }), _c('br'), _vm._v(" "), _c('h4', {
      staticClass: "text"
    }, [_vm._v("\n              " + _vm._s(subnav.title) + "\n            ")])])])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content-bg"
  }, [_c('div', {
    staticClass: "sponsors-official"
  }, [_c('page-subheader', {
    attrs: {
      "title": "Official Partners",
      "text-align": 'center',
      "title-style": {
        borderBottom: '0px'
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered is-flex-mobile is-multiline"
  }, _vm._l((_vm.mnames), function(mname) {
    return (_vm.mitems[mname]) ? _c('div', {
      key: mname,
      staticClass: "column is-3 is-6-mobile has-text-centered item-wrapper"
    }, [(_vm.mitems[mname].link) ? _c('a', {
      staticClass: "item",
      attrs: {
        "href": _vm.mitems[mname].link,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "width": "100%",
        "max-width": "160px"
      },
      attrs: {
        "src": _vm.mitems[mname].image.path,
        "nopin": "nopin"
      }
    })]) : _c('a', {
      staticClass: "item",
      attrs: {
        "href": '/about?anchor=' + mname
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "width": "100%",
        "max-width": "160px"
      },
      attrs: {
        "src": _vm.mitems[mname].image.path,
        "nopin": "nopin"
      }
    })])]) : _vm._e()
  }), 0)], 1), _vm._v(" "), _c('sponsors-sub-section', {
    attrs: {
      "id": "sponsors-level-1",
      "title": "J.D. Hogg Sponsors",
      "level": "1"
    }
  }), _vm._v(" "), _c('sponsors-sub-section', {
    attrs: {
      "id": "sponsors-level-2",
      "title": "The Duke Boys Sponsors",
      "level": "2"
    }
  }), _vm._v(" "), _c('sponsors-sub-section', {
    attrs: {
      "id": "sponsors-level-3",
      "title": "Uncle Jesse Sponsors",
      "level": "3"
    }
  }), _vm._v(" "), _c('sponsors-sub-section', {
    attrs: {
      "id": "sponsors-level-4",
      "title": "Roscoe P. Coltrane",
      "level": "4"
    }
  }), _vm._v(" "), _c('sponsors-sub-section', {
    attrs: {
      "id": "sponsors-level-5",
      "title": "Daisy Duke Sponsors",
      "level": "5"
    }
  }), _vm._v(" "), _c('sponsors-sub-section', {
    attrs: {
      "id": "sponsors-level-0",
      "level": "0",
      "index": "0",
      "is-alt": "true",
      "is-limit-content": "true"
    }
  }), _vm._v(" "), _c('sponsors-sub-section', {
    attrs: {
      "id": "sponsors-level-0",
      "level": "0",
      "index": "1",
      "is-alt": "false"
    }
  })], 1), _vm._v(" "), (false) ? _c('vm-back-top', {
    attrs: {
      "bottom": 45,
      "right": 25,
      "duration": 1000,
      "timing": 'ease'
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span')])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 919 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-sub-event",
    attrs: {
      "id": "section-sub-event",
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('page-subheader', {
    attrs: {
      "title": _vm.paragraph.title
    }
  }), _vm._v(" "), _c('div-container', [(_vm.imageUrl) ? _c('div', {
    staticClass: "columns is-gapless is-centered"
  }, [_c('div', {
    staticClass: "column is-3 has-text-centered content content-image"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "padding": "30px"
    },
    attrs: {
      "src": _vm.imageUrl,
      "width": "200"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-8 has-text-left content",
    class: {
      'with-image': _vm.imageUrl !== undefined
    },
    domProps: {
      "innerHTML": _vm._s(_vm.paragraph.content)
    }
  })]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-newsletter",
    attrs: {
      "id": "section-newsletter"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-flex-mobile is-centered"
  }, [_c('div', {
    staticClass: "column is-8 is-11-mobile"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-multiline"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "cont-form cont-form-info",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "value": "",
      "placeholder": "NAME"
    },
    on: {
      "input": function($event) {
        return _vm.$v.name.$touch()
      }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "name"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "cont-form cont-form-message",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "value": "",
      "placeholder": "EMAIL"
    },
    on: {
      "input": function($event) {
        return _vm.$v.email.$touch()
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "button submit is-outlined",
    class: {
      'is-loading': _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.onSend(_vm.$v)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.loading ? ' ' : 'SUBSCRIBE'))])]), _vm._v(" "), (_vm.feedback) ? _c('p', [_vm._v(_vm._s(_vm.feedback))]) : _vm._e()], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline"
  }, [_c('div', {
    staticClass: "column is-6 has-text-centered"
  }, [_c('div', {
    staticClass: "cont-desc",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": __webpack_require__(864),
      "width": "50"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline"
  }, [_c('div', {
    staticClass: "column is-6 has-text-centered"
  }, [_c('div', {
    staticClass: "cont-desc",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('h3', {
    staticClass: "title",
    staticStyle: {
      "font-size": "1.8em"
    }
  }, [_vm._v("Mailing List")]), _vm._v(" "), _c('span', [_vm._v("Stay up to date! Never miss an unforgettable 'Live In Concert' experience by InTour Live. Subscribe to receive emails on our next big show.")])])])])
}]}

/***/ }),
/* 921 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-notfound"
  }, [_c('top-subpage-section'), _vm._v(" "), _c('div-container', [_c('div', {
    staticClass: "hero is-primary",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('div', {
    staticClass: "hero-body content has-text-centered"
  }, [_c('div', {
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n            Uh oh\n          ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n            404 Page Not Found\n          ")])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 922 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-top-section",
    class: [_vm.$route.name !== 'landing' ? 'not-landing' : '']
  }, [(false) ? _c('div', {
    staticClass: "section-indicator"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'landing') ? _c('div', {
    staticClass: "container-wrapper"
  }, [(_vm.loading === false) ? _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "slick-wrapper",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('slick', {
    ref: "slick",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.title,
      staticClass: "item-wrapper",
      staticStyle: {
        "background-color": "black"
      },
      attrs: {
        "caption": item.title,
        "href": item.image.path,
        "src": item.image.path
      }
    }, [(_vm.isDesktop) ? _c('div', {
      staticClass: "item-image item-image-desktop",
      style: ({
        'background-image': 'url(' + item.image.path + ')'
      }),
      attrs: {
        "nopin": "nopin"
      }
    }) : (item.image_mobile) ? _c('div', {
      staticClass: "item-image item-image-mobile",
      style: ({
        'background-image': 'url(' + item.image_mobile.path + ')'
      }),
      attrs: {
        "nopin": "nopin"
      }
    }) : _c('div', {
      staticClass: "item-image item-image-desktop",
      style: ({
        'background-image': 'url(' + item.image.path + ')'
      }),
      attrs: {
        "nopin": "nopin"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "item-slogan"
    }, [_c('div-container', [_c('div', {
      staticClass: "slogan"
    }, [_c('h1', [_vm._v("\n                    Come BBQ\n                  ")]), _c('br'), _vm._v(" "), _c('h1', [_vm._v("\n                    With The Boss\n                  ")])])])], 1)])
  }), 0)], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (false) ? _c('section', {
    staticClass: "scroll-down"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.$scrollTo('#section-about', {
          offset: -30
        })
      }
    }
  }, [_vm._m(0)])]) : _vm._e(), _vm._v(" "), (false) ? _c('section', {
    staticClass: "arrow-down"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.$scrollTo('#section-about', {
          offset: -30
        })
      }
    }
  }, [_c('span')])]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "circle"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down"
  })])])
}]}

/***/ }),
/* 923 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-subpage-section"
  }, [_c('div', {
    staticClass: "container-wrapper"
  }, [(_vm.loading === false) ? _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "slick-wrapper",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('slick', {
    ref: "slick",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.title,
      staticClass: "item-wrapper",
      staticStyle: {
        "background-color": "black"
      },
      attrs: {
        "caption": item.title,
        "href": item.image.path,
        "src": item.image.path
      }
    }, [(_vm.isDesktop) ? _c('div', {
      staticClass: "item-image item-image-desktop",
      style: ({
        'background-image': 'url(' + item.image.path + ')'
      }),
      attrs: {
        "nopin": "nopin"
      }
    }) : (item.image_mobile) ? _c('div', {
      staticClass: "item-image item-image-mobile",
      style: ({
        'background-image': 'url(' + item.image_mobile.path + ')'
      }),
      attrs: {
        "nopin": "nopin"
      }
    }) : _c('div', {
      staticClass: "item-image item-image-desktop",
      style: ({
        'background-image': 'url(' + item.image.path + ')'
      }),
      attrs: {
        "nopin": "nopin"
      }
    })])
  }), 0)], 1)]) : _vm._e()]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container masonry-youtube",
    attrs: {
      "id": "masonry-youtube"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered"
  }, [_c('div', {
    staticClass: "column is-10"
  }, [(false) ? _c('h1', {
    staticClass: "title"
  }, [_vm._v("\n        Videos\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "masonry",
      rawName: "v-masonry"
    }, {
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "masonry-container",
    attrs: {
      "id": "masonry-container",
      "transition-duration": "0.0s",
      "item-selector": ".masonry-item",
      "data-masonry-options": "{ 'isFitWidth': true }",
      "infinite-scroll-disabled": "itemsLoading",
      "infinite-scroll-distance": "10"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      directives: [{
        name: "masonry-tile",
        rawName: "v-masonry-tile"
      }],
      staticClass: "masonry-item",
      attrs: {
        "data-aos": "slide-up",
        "data-aos-once": "true",
        "data-aos-duration": "1000",
        "data-aos-offset": "0"
      }
    }, [_c('a', {
      attrs: {
        "href": 'http://www.youtube.com/watch?v=' + item.snippet.resourceId.videoId,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-image"
    }, [_c('figure', {
      staticClass: "image",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.parseInstagramImageLink(item.snippet.thumbnails.high.url),
        "alt": "Image"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "card-image-cover"
    }, [_c('i', {
      staticClass: "fa fa-4x fa-play"
    }), _vm._v(" "), _c('div', {
      staticClass: "card-image-cover-description"
    }, [_vm._v("\n                      " + _vm._s(item.snippet.title) + "\n                    ")])])])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "load-more"
  }, [(!_vm.itemsEnded) ? _c('div', {
    staticClass: "button",
    class: {
      'is-loading': _vm.itemsLoading
    },
    on: {
      "click": function($event) {
        return _vm.loadMore()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.itemsEnded) ? _c('div', {
    staticClass: "ended",
    attrs: {
      "data-aos": "slide-up",
      "data-aos-once": "true",
      "data-aos-duration": "1000"
    }
  }, [_vm._v("More videos:"), _c('br', {
    staticClass: "is-hidden-desktop"
  }), _vm._v("  "), _c('a', {
    attrs: {
      "href": _vm.navYoutube.path,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-youtube",
    staticStyle: {
      "vertical-align": "middle"
    }
  }), _vm._v(" / " + _vm._s(_vm.navYoutube.title))])]) : _vm._e()]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-sub-sponsors-wrapper",
    class: [{
      'is-alt': _vm.isAlt === 'true'
    }]
  }, [(_vm.isAlt === 'true' && _vm.isDesktop) ? _c('div', {
    staticClass: "background"
  }, [_c('img', {
    staticClass: "object",
    attrs: {
      "src": __webpack_require__(119)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-sub-sponsors",
    attrs: {
      "id": "section-sub-sponsors",
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('page-subheader', {
    staticStyle: {
      "padding-bottom": "0"
    },
    attrs: {
      "title": _vm.title ? _vm.title : _vm.paragraph.title,
      "text-align": (_vm.level === '0' ? 'left' : 'center'),
      "title-style": [_vm.level === '0' && _vm.index !== '1' ? {} : {
        borderBottom: '0px'
      }]
    }
  }), _vm._v(" "), _c('div-container', [(_vm.level !== '0') ? _c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered is-multiline is-flex-mobile"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "column has-text-left content-images",
      class: {
        'is-3 is-6-mobile': true
      }
    }, [_c('a', {
      staticClass: "item",
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": item.image.path
      }
    })])])
  }), 0) : _c('div-columns', {
    attrs: {
      "paddingTop": "1rem",
      "paddingBottom": "0"
    }
  }, [_c('div', {
    class: [(_vm.isLimitContent ? 'level-0-content' : '')],
    domProps: {
      "innerHTML": _vm._s(_vm.paragraph.content)
    }
  })])], 1)], 1), _vm._v(" "), (_vm.isAlt === 'true' && !_vm.isDesktop) ? _c('div', {
    staticClass: "section-sub-sponsors",
    staticStyle: {
      "text-align": "right",
      "padding-top": "0"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('img', {
    staticClass: "object",
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "src": __webpack_require__(119)
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('div-container', {
    staticClass: "has-text-centered",
    attrs: {
      "padding-top": "1rem",
      "padding-bottom": "1rem"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered is-multiline"
  }, [_c('div', {
    staticClass: "column is-narrow has-text-left"
  }, [_c('h1', {
    staticClass: "main-header",
    staticStyle: {
      "padding": "0 15px"
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "column subnav-links"
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 927 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-bar"
  }, [_c('aside', {
    staticClass: "menu"
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n      Admin\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('router-link', {
    class: {
      'is-active': _vm.$route.name === 'dashboard'
    },
    attrs: {
      "to": "dashboard"
    }
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      'is-active': _vm.$route.name === 'users'
    },
    attrs: {
      "to": "users"
    }
  }, [_vm._v("Users")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      'is-active': _vm.$route.name === 'projects'
    },
    attrs: {
      "to": "projects"
    }
  }, [_vm._v("Projects")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n      Debug\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('router-link', {
    class: {
      'is-active': _vm.$route.name === 'blogs'
    },
    attrs: {
      "to": "blogs"
    }
  }, [_vm._v("Blogs")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      'is-active': _vm.$route.name === 'components'
    },
    attrs: {
      "to": "components"
    }
  }, [_vm._v("Components")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 928 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "page-about"
  }, [_c('top-subpage-section', [_c('page-header', {
    attrs: {
      "title": "About"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content-bg"
  }, [_c('about-sub-section', {
    attrs: {
      "id": "about-partner-1",
      "name": "bosshog::about-partner-1"
    }
  }), _vm._v(" "), _c('about-sub-section', {
    attrs: {
      "id": "about-partner-3",
      "name": "bosshog::about-partner-3"
    }
  })], 1), _vm._v(" "), (false) ? _c('vm-back-top', {
    attrs: {
      "bottom": 45,
      "right": 25,
      "duration": 1000,
      "timing": 'ease'
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span')])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 929 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-countdown"
  }, [_c('div-container', [_c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "digit"
  }, [_vm._v(_vm._s(_vm._f("two_digits")(_vm.days)))]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("DAYS")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "digit"
  }, [_vm._v(_vm._s(_vm._f("two_digits")(_vm.hours)))]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("HRS")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "digit"
  }, [_vm._v(_vm._s(_vm._f("two_digits")(_vm.minutes)))]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("MINS")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "digit"
  }, [_vm._v(_vm._s(_vm._f("two_digits")(_vm.seconds)))]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("SECS")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "page-info"
  }, [_c('top-subpage-section', [_c('page-header', {
    attrs: {
      "title": ("Signup & " + _vm.year + " Teams")
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-flex-mobile has-text-centered",
    class: [{
      'is-centered': !_vm.isDesktop
    }]
  }, [(_vm.isDesktop) ? _c('div', {
    staticClass: "column"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow subnav-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onScrollTo('info', 'info-sign-up')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": __webpack_require__(120),
      "width": "80"
    }
  }), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "text"
  }, [_vm._v("\n              Signup\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow subnav-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onScrollTo('info', 'info-prize')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": __webpack_require__(386),
      "width": "80"
    }
  }), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "text"
  }, [_vm._v("\n              Prize\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow subnav-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onScrollTo('teams', 'info-teams')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": __webpack_require__(387),
      "width": "80"
    }
  }), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "text"
  }, [_vm._v("\n              " + _vm._s(_vm.year) + " Teams\n            ")])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content-bg"
  }, [_c('about-sign-up-sub-section', {
    attrs: {
      "id": "info-sign-up"
    }
  }), _vm._v(" "), _c('about-prize-sub-section', {
    attrs: {
      "id": "info-prize",
      "name": "bosshog::about-prize",
      "is-alt": "true"
    }
  }), _vm._v(" "), _c('about-prize-awards-sub-section', {
    attrs: {
      "id": "info-prize-awards",
      "name-like": ['bosshog::about-prize-award']
    }
  })], 1), _vm._v(" "), (false) ? _c('vm-back-top', {
    attrs: {
      "bottom": 45,
      "right": 25,
      "duration": 1000,
      "timing": 'ease'
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span')])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 931 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-sub-schedule",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('page-subtab', {
    attrs: {
      "title-infos": _vm.dates,
      "selected-index": _vm.dateIndex
    },
    on: {
      "title-changed": _vm.onDateChanged
    }
  }), _vm._v(" "), (_vm.currentDate && _vm.currentDateScheduleLoaded && _vm.items[_vm.currentDate]) ? _c('div-container', [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered is-multiline is-flex-mobile"
  }, [_c('div', {
    staticClass: "column is-11 has-text-left content"
  }, _vm._l((_vm.items[_vm.currentDate]), function(item) {
    return _c('div', {
      staticClass: "columns is-gapless is-centered is-multiline content-row"
    }, [_c('div', {
      staticClass: "column is-4 has-text-left content-date"
    }, [_c('h2', [_c('p', [_vm._v("\n              " + _vm._s(item.full_date) + "\n            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "column is-8 has-text-left content-description"
    }, [_c('h2', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    })])])])
  }), 0)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 932 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-sponsors",
    attrs: {
      "id": "section-sponsors",
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-offset": "-200"
    }
  }, [_c('div-container', [_c('div', {
    staticClass: "columns is-gapless is-centered"
  }, [_c('div', {
    staticClass: "column has-text-centered item-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("\n            Official Partners\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered is-flex-mobile is-multiline"
  }, _vm._l((_vm.mnames), function(mname) {
    return (_vm.mitems[mname]) ? _c('div', {
      key: mname,
      staticClass: "column is-3 is-6-mobile has-text-centered item-wrapper"
    }, [(_vm.mitems[mname].link) ? _c('a', {
      staticClass: "item",
      attrs: {
        "href": _vm.mitems[mname].link,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "width": "100%",
        "max-width": "160px"
      },
      attrs: {
        "src": _vm.mitems[mname].image.path,
        "nopin": "nopin"
      }
    })]) : _c('a', {
      staticClass: "item",
      attrs: {
        "href": '/about?anchor=' + mname
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "width": "100%",
        "max-width": "160px"
      },
      attrs: {
        "src": _vm.mitems[mname].image.path,
        "nopin": "nopin"
      }
    })])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-centered"
  }, [_c('div', {
    staticClass: "column has-text-centered item-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "/sponsors"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("\n            Sponsors\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-centered is-flex-mobile is-multiline"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "column is-3 is-6-mobile has-text-centered item-wrapper"
    }, [_c('a', {
      staticClass: "item",
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": item.image.path
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div-container', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', {
    staticClass: "button is-primary"
  }, [_c('a', {
    attrs: {
      "href": "/sponsors"
    }
  }, [_vm._v("View All")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "page-landing"
  }, [_c('hotlink-section'), _vm._v(" "), _c('about-section'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0"
    },
    attrs: {
      "id": "section-show",
      "height": "0"
    }
  }), _vm._v(" "), _c('instagram-section', {
    attrs: {
      "id": "photos-official",
      "data-aos": "fade-in",
      "data-aos-once": "true"
    },
    on: {
      "onItemClick": _vm.onDialogPhoto
    }
  }), _vm._v(" "), _c('sponsors-section'), _vm._v(" "), _c('base-dialog', {
    attrs: {
      "visible": _vm.dialogPhotoVisible,
      "no-footer": true
    },
    on: {
      "onClose": _vm.onCloseDialogPhoto
    }
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": (_vm.dialogPhoto.image && _vm.dialogPhoto.image.path ? _vm.dialogPhoto.image.path : (_vm.dialogPhoto.type === 'VIDEO' ? _vm.dialogPhoto.url2 : _vm.dialogPhoto.url)),
      "alt": "Image"
    }
  })])]), _vm._v(" "), (false) ? _c('vm-back-top', {
    attrs: {
      "bottom": 45,
      "right": 25,
      "duration": 1000,
      "timing": 'ease'
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span')])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 934 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-sign-up-sub-about",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('page-subheader', {
    attrs: {
      "title": "Signup & Rules"
    }
  }), _vm._v(" "), _c('div-container', [_c('div-columns', {
    attrs: {
      "paddingTop": "1rem",
      "paddingBottom": "0px"
    }
  }, [_c('h2', {
    staticStyle: {
      "margin-bottom": "0",
      "padding-bottom": "15px"
    }
  }, [_vm._v(_vm._s(_vm.paragraph1.title))])]), _vm._v(" "), (_vm.imageUrl) ? _c('div-columns', {
    attrs: {
      "paddingTop": "1em"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-flex-mobile is-vcentered"
  }, [_c('div', {
    staticClass: "column is-5 has-text-centered"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "padding": "30px"
    },
    attrs: {
      "src": _vm.imageUrl,
      "width": "200"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div-columns', {
    class: {
      'with-image': _vm.imageUrl !== undefined
    },
    attrs: {
      "paddingTop": "1em"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.paragraph1.content)
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('h4', {
    staticClass: "button is-primary",
    class: [(_vm.isSignUpTeam ? '' : 'button-disabled')],
    staticStyle: {
      "margin": "10px"
    },
    attrs: {
      "disabled": !_vm.isSignUpTeam
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.isSignUpTeam ? '/signup?type=team' : ''
    },
    on: {
      "click": function($event) {
        _vm.isSignUpTeam ? function () {} : $event.preventDefault()
      }
    }
  }, [_vm._v("\n            Team Application\n          ")]), _vm._v(" "), (_vm.teamDisabledText && _vm.isSignUpTeamUi) ? _c('div', {
    staticClass: "text-tilted"
  }, [_c('h4', {
    staticStyle: {
      "color": "#390e07"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.teamDisabledText)
    }
  })]) : _vm._e()]), _vm._v(" "), _c('h4', {
    staticClass: "button is-primary",
    class: [(_vm.isSignUpJudge ? '' : 'button-disabled')],
    staticStyle: {
      "margin": "10px",
      "position": "relative"
    },
    attrs: {
      "disabled": !_vm.isSignUpJudge
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.isSignUpJudge ? '/signup?type=judge' : ''
    },
    on: {
      "click": function($event) {
        _vm.isSignUpJudge ? function () {} : $event.preventDefault()
      }
    }
  }, [_vm._v("\n            Judge Application\n          ")]), _vm._v(" "), (_vm.judgeDisabledText && _vm.isSignUpJudgeUi) ? _c('div', {
    staticClass: "text-tilted"
  }, [_c('h4', {
    staticStyle: {
      "color": "#390e07"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.judgeDisabledText)
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div-columns', {
    attrs: {
      "paddingTop": "0px",
      "paddingBottom": "0px"
    }
  }, [_c('h2', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v(_vm._s(_vm.paragraph2.title))])]), _vm._v(" "), (_vm.imageUrl) ? _c('div-columns', {
    attrs: {
      "paddingTop": "0.5em"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-flex-mobile is-vcentered"
  }, [_c('div', {
    staticClass: "column is-5 has-text-centered"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "padding": "30px"
    },
    attrs: {
      "src": _vm.imageUrl,
      "width": "200"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div-columns', {
    class: {
      'with-image': _vm.imageUrl !== undefined
    },
    attrs: {
      "paddingTop": "0.5em"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.paragraph2.content)
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-wrapper",
    attrs: {
      "id": "tsection"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.toggle) ? _c('div', {
    staticClass: "active-nav"
  }, [_c('div', {
    staticClass: "link shorthand"
  }, [_vm._l((_vm.navMain), function(navItem) {
    return _c('div', {
      staticClass: "small-div"
    }, [_c('a', {
      staticClass: "div-link",
      attrs: {
        "href": [navItem.section ? '/?anchor=' + navItem.section : navItem.path]
      },
      on: {
        "click": function($event) {
          [navItem.section ? _vm.onScrollTo($event, 'landing', navItem.section) : '']
        }
      }
    }, [_vm._v("\n          " + _vm._s(navItem.title) + "\n        ")])])
  }), _vm._v(" "), (false) ? _c('div', {
    staticClass: "small-div"
  }, [_c('div', [_c('a', {
    staticClass: "elink",
    attrs: {
      "href": ['mailto:' + _vm.navEmail]
    }
  }, [_vm._v(_vm._s(_vm.navEmail))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "small-div"
  }, [_c('div', {
    staticClass: "eicon"
  }, _vm._l((_vm.navSocial), function(navItem) {
    return _c('a', {
      staticClass: "fa",
      attrs: {
        "href": navItem.path,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa",
      class: ['fa-' + navItem.fa],
      attrs: {
        "aria-hidden": "true"
      }
    })])
  }), 0)]), _vm._v(" "), (_vm.toggle) ? _c('div', {
    staticClass: "small-div"
  }, [_c('div', {
    staticClass: "eicon link-ticket-wrapper"
  }, [_c('div', {
    staticClass: "bg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(384),
      "width": "200"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('a', {
    attrs: {
      "href": "/tickets"
    }
  }, [_vm._v("\n                Purchase Tickets\n              ")])])])]) : _vm._e()], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "full-layer"
  }, [_c('navbar-full', {
    attrs: {
      "toggle": _vm.toggle
    },
    on: {
      "onToggle": function($event) {
        _vm.toggle = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "page-tickets"
  }, [_c('top-subpage-section', [_c('page-header', {
    attrs: {
      "title": "Tickets"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-vcentered is-flex-mobile has-text-centered",
    class: [{
      'is-centered': !_vm.isDesktop
    }]
  }, [(_vm.isDesktop) ? _c('div', {
    staticClass: "column"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.subnavs), function(subnav) {
    return _c('div', {
      key: "subnav.title",
      staticClass: "column is-narrow subnav-item"
    }, [_c('a', {
      staticStyle: {
        "cursor": "not-allowed"
      },
      attrs: {
        "title": "Coming Soon"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "src": __webpack_require__(862),
        "width": "80"
      }
    }), _c('br'), _vm._v(" "), _c('h4', {
      staticClass: "text"
    }, [_vm._v("\n              " + _vm._s(subnav.title) + "\n            ")])])])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-tickets-sub-section",
    attrs: {
      "id": "tickets-sub-section"
    }
  }, [_c('page-subheader', {
    attrs: {
      "title": "Purchase Tickets"
    }
  }), _vm._v(" "), _c('div-container', [_c('div-columns', {
    attrs: {
      "paddingTop": "0"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content1)
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [((_vm.subnavs[0].route && _vm.subnavs[0].route.length > 0) && !_vm.disabled) ? _c('h4', {
    staticClass: "button is-primary button-ticket",
    staticStyle: {
      "margin-top": "30px",
      "position": "relative"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.subnavs[0].route,
      "target": "_blank"
    }
  }, [_vm._v("Purchase Here")])]) : _c('h4', {
    staticClass: "button is-primary button-ticket disabled",
    staticStyle: {
      "margin-top": "30px",
      "position": "relative"
    },
    attrs: {
      "disabled": "true"
    }
  }, [_c('a', {
    attrs: {
      "href": '#'
    },
    on: {
      "click": function($event) {
        return $event.preventDefault();
      }
    }
  }, [_vm._v("Coming Soon")])])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content2)
    }
  })])], 1)], 1), _vm._v(" "), (false) ? _c('vm-back-top', {
    attrs: {
      "bottom": 45,
      "right": 25,
      "duration": 1000,
      "timing": 'ease'
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span')])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-prize-sub-about-wrapper"
  }, [(_vm.isDesktop) ? _c('div', {
    staticClass: "background"
  }, [_c('img', {
    staticClass: "object",
    attrs: {
      "src": __webpack_require__(119)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-prize-sub-about",
    class: [{
      'is-alt': _vm.isAlt
    }],
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('page-subheader', {
    attrs: {
      "title": _vm.paragraph.title
    }
  }), _vm._v(" "), _c('div-container', [(_vm.imageUrl) ? _c('div-columns', [_c('div', {
    staticClass: "columns is-gapless is-centered is-flex-mobile is-vcentered"
  }, [_c('div', {
    staticClass: "column is-5 has-text-centered"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "padding": "30px"
    },
    attrs: {
      "src": _vm.imageUrl,
      "width": "200"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div-columns', {
    class: {
      'with-image': _vm.imageUrl !== undefined
    },
    attrs: {
      "paddingTop": "1rem"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.paragraph.content)
    }
  })])], 1)], 1), _vm._v(" "), (!_vm.isDesktop) ? _c('div', {
    staticClass: "section-prize-sub-about",
    staticStyle: {
      "text-align": "right",
      "padding-top": "0"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('img', {
    staticClass: "object",
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "src": __webpack_require__(119)
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 938 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "main-dialog",
    attrs: {
      "title": undefined,
      "show-close": false,
      "visible": _vm.visible,
      "width": _vm.isDesktop ? '60%' : '90%',
      "before-close": _vm.onCloseSettings
    }
  }, [_c('div', {
    staticClass: "el-dialog__content",
    staticStyle: {
      "max-width": "930px",
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "center"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-bottom": "1em",
      "color": "black"
    }
  }, [_vm._v("COVID-19 STATEMENT")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "30px",
      "padding-right": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "word-break": "break-word"
    }
  }, [_vm._v("\n        Thanks for stopping by the BOSS!  We are eager to host the 15th Annual Boss Hog Cook-Off (BHC); however, we understand that we are living in uncertain times.  The health and safety of our community, teams, judges, and volunteers remain our top priority; therefore, we are closely monitoring the ever-changing news and spread of COVID-19, and will make decisions and update as needed…  Check our social media (Facebook & Instagram) for any and all updates.\n      ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "30px",
      "padding-right": "30px",
      "margin-top": "15px"
    }
  }, [_c('span', {
    staticStyle: {
      "word-break": "break-word"
    }
  }, [_vm._v("\n        Our desire is to bring back this community favored event, even with mask-covered smiles, air hugs, and air high-fives.  Hope to see you at the BOSS in Waynesboro, GA on May 14th & 15th!\n      ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "30px",
      "padding-right": "30px",
      "margin-top": "15px"
    }
  }, [_c('span', {
    staticStyle: {
      "word-break": "break-word"
    }
  }, [_vm._v("\n        Your BHC Crew,"), _c('br'), _vm._v("\n        Lindsey Beazley Keller, Nan Palmer Lynch, Elizabeth Billips, & Tim Lively\n      ")])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer",
      "align": "center"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "button is-primary",
    staticStyle: {
      "margin-bottom": "15px",
      "margin-right": "-10px"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_c('span', {
    staticStyle: {
      "text-transform": "uppercase"
    }
  }, [_vm._v("Close")])])])])
},staticRenderFns: []}

/***/ }),
/* 939 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-sub-about",
    class: [{
      'is-alt': _vm.isAlt
    }],
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('page-subheader', {
    attrs: {
      "title": _vm.paragraph.title
    }
  }), _vm._v(" "), _c('div-container', [(_vm.imageUrl) ? _c('div-columns', {
    staticClass: "is-hidden-desktop"
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-flex-mobile is-vcentered"
  }, [_c('div', {
    staticClass: "column is-5 has-text-centered"
  }, [_c('a', {
    attrs: {
      "href": _vm.imageLink,
      "target": "_blank"
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticStyle: {
      "width": "300px",
      "padding": "30px"
    },
    attrs: {
      "src": _vm.imageUrl,
      "width": "300"
    }
  }) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div-columns', {
    class: {
      'with-image': _vm.imageUrl !== undefined
    },
    attrs: {
      "paddingTop": "0.5em"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.imageLink,
      "target": "_blank"
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "is-hidden-touch",
    staticStyle: {
      "width": "300px",
      "padding": "50px",
      "float": "left"
    },
    attrs: {
      "src": _vm.imageUrl,
      "width": "300"
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.paragraph.content)
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 940 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "base-dialog",
    attrs: {
      "title": undefined,
      "show-close": true,
      "close-on-click-modal": true,
      "visible": _vm.visible,
      "width": _vm.isDesktop ? '60%' : '90%',
      "modal-append-to-body": false,
      "modal": false
    },
    on: {
      "close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "el-dialog__content",
    staticStyle: {
      "max-width": "930px",
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "center"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), (!_vm.noFooter) ? _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer",
      "align": "center"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "button is-primary",
    staticStyle: {
      "margin-bottom": "15px",
      "margin-right": "-10px"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_c('span', {
    staticStyle: {
      "text-transform": "uppercase"
    }
  }, [_vm._v("Close")])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div-columns"
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered"
  }, [_c('div', {
    staticClass: "column content",
    class: [{
      'is-11': _vm.full !== 'true' && !_vm.columnNum
    }, _vm.columnNum],
    style: ([{
      paddingTop: (_vm.paddingTop ? _vm.paddingTop : undefined),
      paddingBottom: (_vm.paddingBottom ? _vm.paddingBottom : undefined),
      backgroundColor: (_vm.backgroundColor ? _vm.backgroundColor : undefined),
      textAlign: (_vm.textAlign ? _vm.textAlign : undefined)
    }])
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 942 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-hotlink",
    attrs: {
      "id": "section-hotlink",
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-offset": "-200"
    }
  }, [_c('div-container', [(_vm.items && _vm.items.length > 0) ? _c('div', {
    staticClass: "columns is-gapless is-centered"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "column has-text-centered item-wrapper"
    }, [_c('a', {
      staticClass: "item",
      attrs: {
        "href": item.route
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": item.image.path,
        "nopin": "nopin"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "banner-wrapper"
    }, [_c('div', {
      staticClass: "banner"
    }, [_c('span', [_vm._v(_vm._s(item.title))])])])])])
  }), 0) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery-container",
    attrs: {
      "id": _vm.id
    }
  }, [(_vm.id === 'photos-official') ? _c('div-container', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "href": _vm.navInstagram.path,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram",
    staticStyle: {
      "font-size": "1.4em",
      "vertical-align": "middle",
      "margin-bottom": "5px"
    }
  }), _vm._v(" / " + _vm._s(_vm.navInstagram.title))])])]) : _c('div-container', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "href": _vm.navInstagramHashtag.path,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.navInstagramHashtag.title))])])]), _vm._v(" "), _c('div-container', [_c('div-columns', {
    attrs: {
      "column-num": "is-11",
      "padding-top": "1rem"
    }
  }, [_c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "masonry-container columns is-gapless is-centered is-multiline is-flex-mobile",
    attrs: {
      "id": "masonry-container",
      "infinite-scroll-disabled": "itemsLoading",
      "infinite-scroll-distance": "-1"
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return (index !== 8 || _vm.isDesktop) ? _c('div', {
      staticClass: "column is-4 is-6-mobile",
      attrs: {
        "data-aos": "fade-up",
        "data-aos-once": "true"
      }
    }, [_c('a', {
      attrs: {
        "href": item.url3,
        "target": "_blank"
      },
      on: {
        "click": function ($event) { return _vm.onItemClick($event, item); }
      }
    }, [_c('div', {
      staticClass: "focus-image-wrapper"
    }, [_c('figure', {
      staticClass: "image square",
      style: ([{
        'background-image': 'url(' + (item.image && item.image.path ? item.image.path : (item.type === 'VIDEO' ? item.url2 : item.url)) + ')'
      }, _vm.styleIE])
    })])])]) : _vm._e()
  }), _vm._v(" "), (!_vm.itemsLoading && !_vm.error && _vm.items.length <= 0) ? _c('div', [_c('h3', {
    staticStyle: {
      "padding-top": "3rem",
      "color": "#aaaaaa"
    }
  }, [_vm._v("(not available yet)")])]) : _vm._e()], 2), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  })]) : _vm._e()])], 1), _vm._v(" "), (_vm.id === 'photos-trending') ? _c('div-container', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', {
    staticClass: "button is-primary"
  }, [_c('a', {
    attrs: {
      "href": _vm.navInstagramHashtag.path,
      "target": "_blank"
    }
  }, [_vm._v("View More on Instagram")])])]) : (_vm.id === 'photos-official') ? _c('div-container', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', {
    staticClass: "button is-primary"
  }, [_c('a', {
    attrs: {
      "href": _vm.navInstagram.path,
      "target": "_blank"
    }
  }, [_vm._v("View More on Instagram")])])]) : _c('div-container', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', {
    staticClass: "button is-primary"
  }, [_c('a', {
    attrs: {
      "href": '/photos'
    }
  }, [_vm._v("View All")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "app"
    }
  }, [(true) ? _c('top-countdown', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "date": _vm.countdown
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPrint && _vm.$route.name != 'staytuned' && _vm.$route.name != 'notfound') ? _c('navbar-overlay', {
    staticClass: "navbar-overlay"
  }) : _vm._e(), _vm._v(" "), (!_vm.isPrint && _vm.$route.name != 'staytuned' && _vm.$route.name != 'notfound') ? _c('top-section') : _vm._e(), _vm._v(" "), _c('router-view', {
    staticClass: "page-wrapper"
  }), _vm._v(" "), (!_vm.isPrint && _vm.$route.name != 'staytuned' && _vm.$route.name != 'notfound') ? _c('div', {
    staticClass: "contact-info"
  }, [_c('div-container', {
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-multiline is-flex-mobile"
  }, [_c('div', {
    staticClass: "column is-6 is-12-mobile"
  }, [_c('contact-section', {
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true",
      "data-aos-duration": "1000"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-1 is-12-mobile wrapper is-hidden-mobile"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-5 is-12-mobile wrapper"
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-multiline is-hidden-mobile",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('div', {
    staticClass: "column is-12 has-text-left"
  }, [_c('div', {
    staticClass: "cont-desc",
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('h3', {
    staticClass: "title",
    staticStyle: {
      "font-size": "2.6em"
    }
  }, [_vm._v(" ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline"
  }, [_c('div', {
    staticClass: "column is-12 has-text-left"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', [_c('b', [_vm._v("Fundraising / Vending / Event Coordinating")])]), _vm._v(" "), _c('div', [_vm._v("\n                  Nan Lynch or Lindsey Beazley Keller • (706) 554-8100\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', [_c('b', [_vm._v("Team Registration")])]), _vm._v(" "), _c('div', [_vm._v("\n                  Elizabeth Billips • (706) 551-0729\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', [_c('b', [_vm._v("Judges Signup")])]), _vm._v(" "), _c('div', [_vm._v("\n                  Tim Lively • (706) 551-2045\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": _vm.navLocation.path,
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "40px",
      "float": "left",
      "margin-right": "15px"
    },
    attrs: {
      "src": __webpack_require__(859),
      "width": "40"
    }
  })]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Boss Hog Cook-Off")])]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "#390e07"
    },
    attrs: {
      "href": _vm.navLocation.path,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.navLocation.title))])])])])])])])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isPrint && _vm.$route.name != 'staytuned' && _vm.$route.name != 'notfound') ? _c('footer-main') : _vm._e()], 1)
},staticRenderFns: []}

/***/ })
],[471]);


// WEBPACK FOOTER //
// static/js/app.4fb116381653a24dbce1.js